// import React, { useContext, useEffect, useState } from "react";
// import { createPortal, flushSync } from "react-dom";
// import { createRoot } from "react-dom/client";
// import {
//   BriefcaseBusiness,
//   CalendarClock,
//   Coins,
//   FileDown,
//   FileText,
//   Globe2,
//   GraduationCap,
//   Hash,
//   ImagePlus,
//   Languages,
//   Mail,
//   Phone,
//   Linkedin,
//   Copy,
//   Check,
//   MapPin,
//   Target,
//   UserRound,
// } from "lucide-react";
// import { motion, AnimatePresence } from "framer-motion";
// import { useParams } from "react-router-dom";
// import ProjectTitle from "../components/ProjectDetails/ProjectTitle";
// import "../styles/projectSummary.css";
// import LoadingIcon from "../images/Loading_icon.gif";
// import successIcon from "../images/successGreenIcon.png";
// import errorIcon from "../images/errorRedIcon.png";
// import Swal from "sweetalert2";
// import AddLogo from "../components/ProjectDetails/AddLogo";
// import AppointmentScheduler from "../components/ProjectDetails/AppointmentCreator";
// import { UrlContext } from "../contexts/UrlContext";
// import { UserContext } from "../contexts/UserContext";
// import ClientLog from "../components/ProjectSummary/ClientLog";
// import expertDefaultImg from "../images/expert-default.png";
// import ComposeNewEmail from "../components/EmailUI/ComposeNewEmail";
// import EphCalendar from "../components/ProjectDetails/EphCalendar";
// import ProjectClientEmail from "../components/EmailUI/ProjectClientEmail";
// import bulkPdfFirstPage from "../images/bulk_pdf_first_page.png";
// import bulkPdfLastPage from "../images/bulk_pdf_last_page.png";
// import DigitalProfileSlide from "../components/PreviewDigitalPPT/DigitalProfileSlide";
// import "../styles/previewDigitalPPTBrowser.css";
// import "react-quill/dist/quill.snow.css";

// const rowGridTemplateColumns =
//   "250px 100px repeat(5, 50px) 60px minmax(120px, 1fr) minmax(120px, 1fr) minmax(140px, 1fr) 48px";

// function ToggleTooltip({ label, isLeftEdge = false, isRightEdge = false, isTop = false }) {
//   const verticalClass = isTop ? "bottom-full mb-2" : "top-full mt-2";
//   const horizontalClass = isLeftEdge
//     ? "left-0 translate-x-0"
//     : isRightEdge
//       ? "right-0 translate-x-0"
//       : "left-1/2 -translate-x-1/2";
//   const arrowVerticalClass = isTop ? "top-full -translate-y-1" : "bottom-full translate-y-1";
//   const arrowHorizontalClass = isLeftEdge
//     ? "left-3"
//     : isRightEdge
//       ? "right-3"
//       : "left-1/2 -translate-x-1/2";

//   return (
//     <span
//       className={[
//         "pointer-events-none absolute z-[80] hidden whitespace-nowrap rounded-xl bg-slate-900 px-2.5 py-1.5 text-[11px] font-semibold text-white shadow-xl group-hover:block",
//         verticalClass,
//         horizontalClass,
//       ].join(" ")}
//     >
//       {label}
//       <span
//         className={[
//           "absolute h-2 w-2 rotate-45 bg-slate-900",
//           arrowVerticalClass,
//           arrowHorizontalClass,
//         ].join(" ")}
//       />
//     </span>
//   );
// }

// function ProfileTypeToggle({ value, onChange, counts = {} }) {
//   const options = [
//     {
//       value: "all",
//       label: "All profiles",
//       shortLabel: "All",
//       count: counts.all || 0,
//       icon: "fa-users",
//       activeBg: "bg-[#365561]",
//       inactiveText: "text-[#365561]",
//       hoverBg: "hover:bg-[#365561]/10",
//     },
//     {
//       value: "ppt",
//       label: "PowerPoint generated",
//       shortLabel: "PPT",
//       count: counts.ppt || 0,
//       icon: "fa-file-powerpoint",
//       activeBg: "bg-orange-500",
//       inactiveText: "text-orange-700",
//       hoverBg: "hover:bg-orange-50",
//     },
//     {
//       value: "sharedViaLink",
//       label: "Shared via link",
//       shortLabel: "Link",
//       count: counts.sharedViaLink || 0,
//       icon: "fa-share-nodes",
//       activeBg: "bg-blue-500",
//       inactiveText: "text-blue-700",
//       hoverBg: "hover:bg-blue-50",
//     },
//   ];

//   return (
//     <div className="relative z-30 inline-flex w-fit max-w-full overflow-visible rounded-2xl border border-slate-200 bg-white p-1 shadow-[0_10px_30px_rgba(15,23,42,0.05)]">
//       {options.map((option, optionIndex) => {
//         const isActive = value === option.value;

//         return (
//           <button
//             key={option.value}
//             type="button"
//             onClick={() => onChange(option.value)}
//             className={[
//               "group relative z-10 inline-flex shrink-0 items-center gap-1 rounded-xl px-2 py-2 text-[11px] font-semibold transition-colors duration-200 focus:outline-none sm:px-2.5",
//               isActive ? "text-white" : `${option.inactiveText} ${option.hoverBg}`,
//             ].join(" ")}
//           >
//             {isActive && (
//               <motion.span
//                 layoutId="project-summary-profile-type-toggle-pill"
//                 className={[
//                   "absolute inset-0 -z-10 rounded-xl shadow-[0_10px_24px_rgba(54,85,97,0.18)]",
//                   option.activeBg,
//                 ].join(" ")}
//                 transition={{ type: "spring", stiffness: 420, damping: 32 }}
//               />
//             )}

//             <i className={`fa-solid ${option.icon} text-[10px]`} />
//             <span>{option.shortLabel}</span>
//             <span
//               className={[
//                 "rounded-full px-1.5 py-0.5 text-[10px] leading-none",
//                 isActive ? "bg-white/20 text-white" : "bg-slate-100 text-slate-500",
//               ].join(" ")}
//             >
//               {option.count}
//             </span>
//             <ToggleTooltip
//               label={`${option.label}: ${option.count}`}
//               isLeftEdge={optionIndex === 0}
//               isRightEdge={optionIndex === options.length - 1}
//             />
//           </button>
//         );
//       })}
//     </div>
//   );
// }


// function MSActionButton({
//   icon,
//   label,
//   shortLabel,
//   onClick,
//   primary = false,
//   loading = false,
//   disabled = false,
//   isLeftEdge = false,
//   isRightEdge = false,
// }) {
//   return (
//     <button
//       type="button"
//       onClick={onClick}
//       disabled={disabled || loading}
//       className={[
//         "group relative inline-flex h-8 items-center gap-1 overflow-visible rounded-xl px-2.5 text-[11px] font-semibold transition focus:outline-none disabled:cursor-wait disabled:opacity-60",
//         primary
//           ? "bg-[#365561] text-white shadow-[0_8px_20px_rgba(54,85,97,0.18)] hover:bg-[#2c4650]"
//           : "border border-slate-200 bg-white text-slate-600 shadow-sm hover:border-[#365561]/25 hover:bg-[#365561]/10 hover:text-[#365561]",
//       ].join(" ")}
//       aria-label={label}
//     >
//       <i className={loading ? "fa-solid fa-spinner fa-spin text-[14px]" : `${icon} text-[14px]`} />
//       <span>{shortLabel}</span>
//       <ToggleTooltip label={label} isLeftEdge={isLeftEdge} isRightEdge={isRightEdge} />
//     </button>
//   );
// }

// function LoadingOverlay({ text }) {
//   return (
//     <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/35 backdrop-blur-sm">
//       <div className="rounded-3xl border border-slate-200 bg-white px-8 py-7 text-center shadow-[0_24px_70px_rgba(15,23,42,0.28)]">
//         <i className="fa-solid fa-spinner fa-spin text-4xl text-[#365561]" />
//         <p className="mt-3 text-sm font-semibold text-slate-700">{text}</p>
//       </div>
//     </div>
//   );
// }


// const DEFAULT_BULK_PDF_SECTION_VISIBILITY = {
//   profilePicture: true,
//   identity: true,
//   position: true,
//   location: true,
//   region: false,
//   language: true,
//   totalExperience: true,
//   availability: true,
//   rate: true,
//   summary: true,
//   matching: true,
//   experience: true,
//   education: true,
// };

// const DEFAULT_CLIENT_ENVIRONMENT_SECTION_VISIBILITY = {
//   identity: true,
//   position: true,
//   location: true,
//   region: true,
//   language: true,
//   totalExperience: true,
//   availability: true,
//   rate: true,
//   summary: true,
//   matching: true,
//   experience: true,
//   education: true,
// };

// const CLIENT_ENVIRONMENT_PROJECT_FIELD_MAP = {
//   position: "hasPositionSection",
//   location: "hasLocationSection",
//   region: "hasRegionSection",
//   language: "hasLanguageSection",
//   totalExperience: "hasTotalExperienceSection",
//   availability: "hasAvailabilitySection",
//   rate: "hasRateSection",
//   summary: "hasSummarySection",
//   matching: "hasMatchingSection",
//   experience: "hasExperienceSection",
//   education: "hasEducationSection",
// };

// function getDefaultClientEnvironmentVisibility(projectType) {
//   return {
//     ...DEFAULT_CLIENT_ENVIRONMENT_SECTION_VISIBILITY,
//     ...(projectType === "exp"
//       ? { matching: false, education: false }
//       : {}),
//   };
// }

// function clientEnvironmentSelectionPayload(sectionVisibility, identityMode) {
//   const identityVisible = sectionVisibility.identity !== false;

//   return {
//     isNameShared: identityVisible && identityMode === "name",
//     isIdShared: identityVisible && identityMode === "id",
//     hasPositionSection: sectionVisibility.position !== false,
//     hasLocationSection: sectionVisibility.location !== false,
//     hasRegionSection: sectionVisibility.region !== false,
//     hasLanguageSection: sectionVisibility.language !== false,
//     hasTotalExperienceSection: sectionVisibility.totalExperience !== false,
//     hasAvailabilitySection: sectionVisibility.availability !== false,
//     hasRateSection: sectionVisibility.rate !== false,
//     hasSummarySection: sectionVisibility.summary !== false,
//     hasMatchingSection: sectionVisibility.matching !== false,
//     hasExperienceSection: sectionVisibility.experience !== false,
//     hasEducationSection: sectionVisibility.education !== false,
//   };
// }

// function BulkPdfSectionToggle({
//   checked,
//   onChange,
//   icon: Icon,
//   label,
//   description,
//   showDescription = true,
// }) {
//   return (
//     <button
//       type="button"
//       className={`pdp2-section-option${checked ? " is-active" : ""}`}
//       onClick={onChange}
//       aria-pressed={checked}
//     >
//       <span className="pdp2-section-option-icon" aria-hidden="true">
//         <Icon size={17} strokeWidth={2} />
//       </span>

//       <span className="pdp2-section-option-copy">
//         <strong>{label}</strong>
//         {showDescription && description ? <small>{description}</small> : null}
//       </span>

//       <span className="pdp2-section-option-switch" aria-hidden="true">
//         <span />
//       </span>
//     </button>
//   );
// }

// function BulkPdfLivePreview({
//   profiles,
//   loading,
//   error,
//   sectionVisibility,
//   identityMode,
//   projectName,
//   clientName,
//   contactName,
//   contactEmail,
// }) {
//   if (loading) {
//     return (
//       <div className="flex h-full min-h-[420px] items-center justify-center rounded-2xl border border-slate-200 bg-white/80">
//         <div className="text-center">
//           <i className="fa-solid fa-spinner fa-spin text-3xl text-[#365561]" />
//           <p className="mt-3 text-sm font-semibold text-slate-600">Loading PDF preview...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="flex h-full min-h-[420px] items-center justify-center rounded-2xl border border-rose-200 bg-rose-50/70 p-6 text-center">
//         <div>
//           <p className="text-sm font-semibold text-rose-700">Preview unavailable</p>
//           <p className="mt-1 max-w-md text-xs leading-5 text-rose-600">{error}</p>
//         </div>
//       </div>
//     );
//   }

//   if (!Array.isArray(profiles) || profiles.length === 0) {
//     return (
//       <div className="flex h-full min-h-[420px] items-center justify-center rounded-2xl border border-slate-200 bg-white/80 p-6 text-center">
//         <p className="text-sm text-slate-500">Select at least one profile to load a preview.</p>
//       </div>
//     );
//   }

//   const previewScale = 0.62;
//   const pageCount = profiles.length + 2;
//   const pageGap = 18;
//   const unscaledDeckHeight = pageCount * 720 + Math.max(pageCount - 1, 0) * pageGap;

//   return (
//     <div className="flex h-full min-h-0 flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-[0_10px_34px_rgba(15,23,42,0.08)]">
//       <div className="flex shrink-0 items-start justify-between gap-4 border-b border-slate-200 px-4 py-3">
//         <div>
//           <p className="text-sm font-bold text-slate-800">Full PDF preview</p>
//           <p className="mt-0.5 text-xs text-slate-500">
//             Scroll through the cover, all selected profiles, and the closing page. Changes on the left are reflected immediately.
//           </p>
//         </div>
//         <span className="shrink-0 rounded-full bg-[#365561]/10 px-2.5 py-1 text-[10px] font-bold text-[#365561]">
//           {pageCount} pages
//         </span>
//       </div>

//       <div className="bulk-pdf-live-preview min-h-0 flex-1 overflow-auto bg-slate-100/80 p-4">
//         <style>{`
//           .bulk-pdf-live-preview .pdp2-page-shell.pdp2-bulk-pdf-deck {
//             width: 1280px !important;
//             min-height: 0 !important;
//             margin: 0 !important;
//             padding: 0 !important;
//             display: flex !important;
//             flex-direction: column !important;
//             gap: ${pageGap}px !important;
//             overflow: visible !important;
//             background: transparent !important;
//           }

//           .bulk-pdf-live-preview .pdp2-bulk-pdf-deck > .pdp2-slide,
//           .bulk-pdf-live-preview .pdp2-bulk-pdf-deck > [data-pdp2-bulk-static-page] {
//             flex: 0 0 720px !important;
//             width: 1280px !important;
//             height: 720px !important;
//             margin: 0 !important;
//             box-shadow: 0 12px 34px rgba(15, 23, 42, 0.14) !important;
//           }
//         `}</style>

//         <div
//           className="mx-auto"
//           style={{
//             width: `${1280 * previewScale}px`,
//             height: `${unscaledDeckHeight * previewScale}px`,
//           }}
//         >
//           <div
//             style={{
//               width: "1280px",
//               height: `${unscaledDeckHeight}px`,
//               transform: `scale(${previewScale})`,
//               transformOrigin: "top left",
//             }}
//           >
//             <BulkDigitalProfileDeck
//               profiles={profiles}
//               projectName={projectName}
//               clientName={clientName}
//               contactName={contactName}
//               contactEmail={contactEmail}
//               projectType={profiles?.[0]?.projectType}
//               sectionVisibility={sectionVisibility}
//               identityMode={identityMode}
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// function BulkPdfSectionSelectionModal({
//   open,
//   sectionVisibility,
//   identityMode,
//   previewProfiles,
//   previewLoading,
//   previewError,
//   projectName,
//   clientName,
//   contactName,
//   contactEmail,
//   onToggleSection,
//   onIdentitySelection,
//   onClose,
//   onConfirm,
// }) {
//   if (typeof document === "undefined") return null;

//   const informationOptions = [
//     { key: "profilePicture", label: "Profile picture", description: "Consultant profile photo", icon: ImagePlus, checked: sectionVisibility.profilePicture, onChange: () => onToggleSection("profilePicture") },
//     { key: "ephId", label: "EPH ID", description: "EPH_CON_ / EPH_EXP_ identifier", icon: Hash, checked: sectionVisibility.identity && identityMode === "id", onChange: () => onIdentitySelection("id") },
//     { key: "name", label: "Name", description: "Consultant name", icon: UserRound, checked: sectionVisibility.identity && identityMode === "name", onChange: () => onIdentitySelection("name") },
//     { key: "position", label: "Position", description: "Current role or headline", icon: BriefcaseBusiness, checked: sectionVisibility.position, onChange: () => onToggleSection("position") },
//     { key: "location", label: "Location", description: "Current consultant location", icon: MapPin, checked: sectionVisibility.location, onChange: () => onToggleSection("location") },
//     { key: "region", label: "Region", description: "Regional experience", icon: Globe2, checked: sectionVisibility.region, onChange: () => onToggleSection("region") },
//     { key: "language", label: "Languages", description: "Language capabilities", icon: Languages, checked: sectionVisibility.language, onChange: () => onToggleSection("language") },
//     { key: "totalExperience", label: "Total experience", description: "Years of professional experience", icon: BriefcaseBusiness, checked: sectionVisibility.totalExperience, onChange: () => onToggleSection("totalExperience") },
//     { key: "availability", label: "Availability", description: "Current availability note", icon: CalendarClock, checked: sectionVisibility.availability, onChange: () => onToggleSection("availability") },
//     { key: "rate", label: "Rate", description: "Currency, rate and billing unit", icon: Coins, checked: sectionVisibility.rate, onChange: () => onToggleSection("rate") },
//   ];

//   const contentOptions = [
//     { key: "summary", label: "Professional Summary", description: "Main consultant summary", icon: FileText, checked: sectionVisibility.summary, onChange: () => onToggleSection("summary") },
//     { key: "matching", label: "Requirement Matching", description: "Dimensions and radar matching", icon: Target, checked: sectionVisibility.matching, onChange: () => onToggleSection("matching") },
//     { key: "experience", label: "Relevant Experience", description: "Selected professional experience", icon: BriefcaseBusiness, checked: sectionVisibility.experience, onChange: () => onToggleSection("experience") },
//     { key: "education", label: "Education & Certification", description: "Education and credentials", icon: GraduationCap, checked: sectionVisibility.education, onChange: () => onToggleSection("education") },
//   ];

//   const informationActiveCount = informationOptions.filter((option) => option.checked).length;
//   const contentActiveCount = contentOptions.filter((option) => option.checked).length;

//   return createPortal(
//     <AnimatePresence>
//       {open && (
//         <motion.div
//           className="fixed inset-0 z-[10050] flex items-center justify-center bg-slate-950/45 p-4 backdrop-blur-sm sm:p-6"
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           exit={{ opacity: 0 }}
//           transition={{ duration: 0.16 }}
//           role="presentation"
//           data-pdp2-print-hide="true"
//           onMouseDown={(event) => {
//             if (event.target === event.currentTarget) onClose();
//           }}
//         >
//           <motion.div
//             className="pdp2-section-picker flex h-[94vh] max-h-[94vh] w-[min(900px,calc(100vw-24px))] flex-col overflow-hidden rounded-[26px] border border-slate-200/90 bg-[radial-gradient(circle_at_top,rgba(54,85,97,0.14),transparent_34%),linear-gradient(to_bottom,#f8fafc,#eef2f6)] shadow-[0_28px_90px_rgba(15,23,42,0.34)] lg:w-[min(1720px,calc(100vw-24px))]"
//             initial={{ opacity: 0, y: 22, scale: 0.975 }}
//             animate={{ opacity: 1, y: 0, scale: 1 }}
//             exit={{ opacity: 0, y: 18, scale: 0.98 }}
//             transition={{ type: "spring", stiffness: 340, damping: 30, mass: 0.82 }}
//             role="dialog"
//             aria-modal="true"
//             aria-labelledby="bulk-pdf-section-picker-title"
//             onMouseDown={(event) => event.stopPropagation()}
//           >
//             <div className="pdp2-section-picker-header">
//               <div className="pdp2-section-picker-title-wrap">
//                 <span className="pdp2-section-picker-eyebrow">Bulk PDF layout</span>
//                 <strong id="bulk-pdf-section-picker-title">Choose visible sections</strong>
//                 <p>Choose which information and content blocks should appear on every selected digital profile in this PDF. This selection is used only for the PDF and is not saved to the profile.</p>
//               </div>
//               <button type="button" className="pdp2-section-picker-close" onClick={onClose} aria-label="Close bulk PDF section picker">×</button>
//             </div>

//             <div className="pdp2-section-picker-body min-h-0 overflow-hidden" style={{ overflow: "hidden" }}>
//               <div
//                 className="grid h-full min-h-0 grid-cols-1 gap-4 p-3 sm:p-4 lg:grid-cols-[minmax(420px,620px)_minmax(0,1fr)] xl:grid-cols-[720px_minmax(0,1fr)]"
//                 style={{ gridTemplateRows: "minmax(0, 1fr)" }}
//               >
//                 <div className="h-full min-h-0 space-y-4 overflow-y-auto overscroll-contain pr-2">
//                   <section className="pdp2-section-picker-panel pdp2-section-picker-panel-information">
//                     <div className="pdp2-section-picker-panel-header">
//                       <div className="pdp2-section-picker-panel-title">
//                         <span className="pdp2-section-picker-panel-icon"><UserRound size={17} strokeWidth={2} /></span>
//                         <div><strong>Information</strong></div>
//                       </div>
//                       <span className="pdp2-section-picker-count">{informationActiveCount}/{informationOptions.length}</span>
//                     </div>
//                     <div className="pdp2-section-picker-grid grid-cols-1 sm:grid-cols-2">
//                       {informationOptions.map((option) => (
//                         <BulkPdfSectionToggle
//                           key={option.key}
//                           checked={option.checked}
//                           onChange={option.onChange}
//                           icon={option.icon}
//                           label={option.label}
//                           description={option.description}
//                           showDescription={false}
//                         />
//                       ))}
//                     </div>
//                     <div className="pdp2-section-picker-note">
//                       <Hash size={13} strokeWidth={2} />
//                       <span><strong>EPH ID</strong> and <strong>Name</strong> share the same profile area and are mutually exclusive.</span>
//                     </div>
//                   </section>

//                   <section className="pdp2-section-picker-panel pdp2-section-picker-panel-content">
//                     <div className="pdp2-section-picker-panel-header">
//                       <div className="pdp2-section-picker-panel-title">
//                         <span className="pdp2-section-picker-panel-icon"><FileText size={17} strokeWidth={2} /></span>
//                         <div><strong>Content</strong></div>
//                       </div>
//                       <span className="pdp2-section-picker-count">{contentActiveCount}/{contentOptions.length}</span>
//                     </div>
//                     <div className="pdp2-section-picker-grid grid-cols-1 sm:grid-cols-2">
//                       {contentOptions.map((option) => (
//                         <BulkPdfSectionToggle
//                           key={option.key}
//                           checked={option.checked}
//                           onChange={option.onChange}
//                           icon={option.icon}
//                           label={option.label}
//                           description={option.description}
//                           showDescription={false}
//                         />
//                       ))}
//                     </div>
//                   </section>
//                 </div>

//                 <div className="hidden min-h-0 lg:block">
//                   <BulkPdfLivePreview
//                     profiles={previewProfiles}
//                     loading={previewLoading}
//                     error={previewError}
//                     sectionVisibility={sectionVisibility}
//                     identityMode={sectionVisibility.identity ? identityMode || "id" : null}
//                     projectName={projectName}
//                     clientName={clientName}
//                     contactName={contactName}
//                     contactEmail={contactEmail}
//                   />
//                 </div>
//               </div>
//             </div>

//             <div className="flex shrink-0 items-center justify-end gap-2 border-t border-slate-200/90 bg-white/85 px-5 py-4 backdrop-blur-sm">
//               <button type="button" className="rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-600 transition hover:bg-slate-50 focus:outline-none" onClick={onClose}>Cancel</button>
//               <button type="button" className="rounded-xl border-0 bg-[#365561] px-5 py-2 text-sm font-semibold text-white transition hover:bg-[#2e4a54] focus:outline-none" onClick={onConfirm}>Generate PDF</button>
//             </div>
//           </motion.div>
//         </motion.div>
//       )}
//     </AnimatePresence>,
//     document.body
//   );
// }

// function BulkPdfCoverPage({
//   projectName,
//   clientName,
//   projectType,
// }) {
//   const monthYear = new Intl.DateTimeFormat("en-US", {
//     month: "long",
//     year: "numeric",
//   })
//     .format(new Date())
//     .toUpperCase();

//   const deckTitle =
//     projectType === "exp"
//       ? "Selected Expert Profiles"
//       : "Selected Consulting Profiles";

//   return (
//     <div
//       className="pdp2-bulk-print-page relative h-[720px] w-[1280px] shrink-0 overflow-hidden bg-white"
//       data-pdp2-bulk-static-page="cover"
//     >
//       {/*
//         Use a real <img> rather than CSS background-image so the first
//         page is always included by the browser print engine even when
//         "Background graphics" is disabled.
//       */}
//       <img
//         src={bulkPdfFirstPage}
//         alt=""
//         aria-hidden="true"
//         className="absolute inset-0 h-full w-full select-none object-fill"
//         draggable="false"
//       />

//       <div
//         className="absolute text-white"
//         style={{
//           left: "10.2%",
//           top: "62.0%",
//           width: "64%",
//           fontFamily: "Arial, Helvetica, sans-serif",
//         }}
//       >
//         <div
//           style={{
//             fontSize: "32px",
//             lineHeight: 1.12,
//             fontWeight: 700,
//             letterSpacing: "-0.4px",
//           }}
//         >
//           {deckTitle}
//         </div>

//         <div
//           style={{
//             display: "flex",
//             alignItems: "flex-start",
//             gap: "0px",
//             marginTop: "17px",
//             fontSize: "23px",
//             lineHeight: 1.18,
//             fontWeight: 400,
//             width: "100%",
//           }}
//         >
//           <span
//             className="shrink-0"
//             style={{ minWidth: "66px" }}
//           >
//             Topic:
//           </span>

//           <span
//             style={{
//               display: "block",
//               width: "50ch",
//               maxWidth: "50ch",
//               flex: "0 0 50ch",
//               fontWeight: 400,
//               whiteSpace: "normal",
//               overflowWrap: "break-word",
//               wordBreak: "normal",
//             }}
//           >
//             {projectName || ""}
//           </span>
//         </div>
//       </div>

//       <div
//         className="absolute text-white"
//         style={{
//           left: "10.2%",
//           top: "82.4%",
//           width: "64%",
//           fontFamily: "Arial, Helvetica, sans-serif",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "baseline",
//             gap: "6px",
//             fontSize: "20px",
//             lineHeight: 1.2,
//             whiteSpace: "nowrap",
//           }}
//         >
//           <span style={{ fontWeight: 700 }}>
//             Prepared for
//           </span>
//           <span
//             style={{
//               fontWeight: 600,
//               minWidth: 0,
//               whiteSpace: "nowrap",
//             }}
//           >
//             {clientName || ""}
//           </span>
//         </div>
//       </div>

//       <div
//         className="absolute text-[#365561]"
//         style={{
//           left: "10.2%",
//           top: "93.5%",
//           width: "50%",
//           fontFamily: "Arial, Helvetica, sans-serif",
//           fontSize: "17px",
//           lineHeight: 1.2,
//           fontWeight: 700,
//         }}
//       >
//         {monthYear}
//       </div>
//     </div>
//   );
// }

// function BulkPdfLastPage({
//   contactName,
//   contactEmail,
// }) {
//   return (
//     <div
//       className="pdp2-bulk-print-page relative h-[720px] w-[1280px] shrink-0 overflow-hidden bg-[#365561]"
//       data-pdp2-bulk-static-page="outro"
//     >
//       <img
//         src={bulkPdfLastPage}
//         alt=""
//         aria-hidden="true"
//         className="absolute inset-0 h-full w-full select-none object-fill"
//         draggable="false"
//       />

//       <div
//         className="absolute text-white"
//         style={{
//           left: "60.7%",
//           top: "4.0%",
//           width: "34.5%",
//           fontFamily: "Arial, Helvetica, sans-serif",
//         }}
//       >
//         <div
//           style={{
//             fontSize: "28px",
//             lineHeight: 1.24,
//             fontWeight: 700,
//             letterSpacing: "-0.35px",
//           }}
//         >
//           Let us find the right expertise
//           <br />
//           for your project
//         </div>

//         <div
//           style={{
//             marginTop: "31px",
//             fontSize: "17px",
//             lineHeight: 1.25,
//             fontWeight: 400,
//           }}
//         >
//           Reach out to your Contact
//         </div>

//         <div
//           style={{
//             marginTop: "6px",
//             fontSize: "17px",
//             lineHeight: 1.28,
//             fontWeight: 600,
//             overflowWrap: "anywhere",
//           }}
//         >
//           {contactName || ""}
//         </div>

//         <div
//           style={{
//             marginTop: "1px",
//             fontSize: "17px",
//             lineHeight: 1.28,
//             fontWeight: 600,
//             overflowWrap: "anywhere",
//           }}
//         >
//           {contactEmail || ""}
//         </div>

//         <div
//           style={{
//             marginTop: "66px",
//             fontSize: "17px",
//             lineHeight: 1.2,
//             fontWeight: 700,
//           }}
//         >
//           Cologne | Düsseldorf | Mumbai
//         </div>
//       </div>
//     </div>
//   );
// }

// function BulkDigitalProfileDeck({
//   profiles,
//   projectName,
//   clientName,
//   contactName,
//   contactEmail,
//   projectType,
//   sectionVisibility,
//   identityMode,
// }) {
//   return (
//     <div className="pdp2-page-shell pdp2-bulk-pdf-deck">
//       <BulkPdfCoverPage
//         projectName={projectName}
//         clientName={clientName}
//         projectType={projectType}
//       />

//       {profiles.map((profile, index) => (
//         <DigitalProfileSlide
//           key={profile?.ID || profile?.expertID || index}
//           readOnly
//           previewPrintLayout
//           showProposedRates={false}
//           sectionVisibility={sectionVisibility}
//           expertID={profile?.expertID || profile?.ID}
//           powerPointID={
//             profile?.powerPointID ||
//             profile?.powerpointID ||
//             profile?.PowerPointID ||
//             null
//           }
//           experienceData={
//             Array.isArray(profile?.expertExperience)
//               ? profile.expertExperience
//               : []
//           }
//           data={{
//             identityMode,
//             projectType: profile?.projectType,
//             profilePicture: profile?.profilePicture,
//             expertDigitalID: profile?.expertDigitalID,
//             expertName: profile?.expertName,
//             position: profile?.position,
//             location: profile?.location,
//             region: profile?.region,
//             language: profile?.language,
//             totalExperience: profile?.totalExperience,
//             availableComment: profile?.Available_comment,
//             projectCurrency: profile?.projectCurrency,
//             dailyRate: profile?.daily_rate,
//             billingFrequency: profile?.billingFrequency,
//             footNote: profile?.footNote,
//             summary: profile?.summ,
//             education: profile?.education,
//             dimensions: [
//               profile?.dimension1,
//               profile?.dimension2,
//               profile?.dimension3,
//               profile?.dimension4,
//               profile?.dimension5,
//             ],
//             ratings: [
//               Number(profile?.rating1) || 0,
//               Number(profile?.rating2) || 0,
//               Number(profile?.rating3) || 0,
//               Number(profile?.rating4) || 0,
//               Number(profile?.rating5) || 0,
//             ],
//           }}
//         />
//       ))}

//       <BulkPdfLastPage
//         contactName={contactName}
//         contactEmail={contactEmail}
//       />
//     </div>
//   );
// }

// function waitForBulkImages(root) {
//   const images = Array.from(
//     root?.querySelectorAll?.("img") || []
//   );

//   return Promise.all(
//     images.map((image) => {
//       if (image.complete) {
//         return Promise.resolve();
//       }

//       return new Promise((resolve) => {
//         image.onload = resolve;
//         image.onerror = resolve;
//       });
//     })
//   );
// }

// function waitForBulkStyles(doc) {
//   const stylesheetLinks = Array.from(
//     doc.querySelectorAll('link[rel="stylesheet"]')
//   );

//   return Promise.all(
//     stylesheetLinks.map((link) => {
//       if (link.sheet) {
//         return Promise.resolve();
//       }

//       return new Promise((resolve) => {
//         const done = () => resolve();

//         link.addEventListener("load", done, {
//           once: true,
//         });
//         link.addEventListener("error", done, {
//           once: true,
//         });

//         setTimeout(done, 3000);
//       });
//     })
//   );
// }

// function copyBulkDocumentStyles(printWindow) {
//   Array.from(
//     document.querySelectorAll(
//       'style, link[rel="stylesheet"]'
//     )
//   ).forEach((node) => {
//     try {
//       const clone = node.cloneNode(true);

//       if (
//         node.tagName === "LINK" &&
//         node.href
//       ) {
//         clone.href = node.href;
//       }

//       printWindow.document.head.appendChild(clone);
//     } catch (error) {
//       console.error(
//         "Failed to copy stylesheet into bulk PDF window:",
//         error
//       );
//     }
//   });
// }

// const BULK_PDF_PRINT_STYLE = `
//   @page {
//     size: 13.333333333in 7.5in;
//     margin: 0;
//   }

//   html,
//   body {
//     width: auto !important;
//     height: auto !important;
//     min-height: 0 !important;
//     margin: 0 !important;
//     padding: 0 !important;
//     overflow: visible !important;
//     background: #ffffff !important;
//     -webkit-print-color-adjust: exact !important;
//     print-color-adjust: exact !important;
//   }

//   #pdp2-bulk-print-root {
//     width: auto !important;
//     height: auto !important;
//     margin: 0 !important;
//     padding: 0 !important;
//     overflow: visible !important;
//   }

//   .pdp2-screen-only,
//   [data-pdp2-print-hide="true"] {
//     display: none !important;
//   }

//   .pdp2-print-only {
//     display: block !important;
//   }

//   /* The normal Preview stylesheet fixes .pdp2-page-shell to one print page.
//      The bulk deck is the only exception: it must be allowed to contain many
//      otherwise-standard DigitalProfileSlide pages. */
//   .pdp2-page-shell.pdp2-bulk-pdf-deck {
//     width: auto !important;
//     height: auto !important;
//     min-height: 0 !important;
//     margin: 0 !important;
//     padding: 0 !important;
//     overflow: visible !important;
//     background: #ffffff !important;
//   }

//   .pdp2-bulk-pdf-deck > .pdp2-slide,
//   .pdp2-bulk-pdf-deck > [data-pdp2-bulk-static-page] {
//     width: 13.333333333in !important;
//     height: 7.5in !important;
//     min-width: 13.333333333in !important;
//     min-height: 7.5in !important;
//     max-width: 13.333333333in !important;
//     max-height: 7.5in !important;
//     margin: 0 !important;
//     box-shadow: none !important;
//     overflow: hidden !important;
//     break-after: page !important;
//     page-break-after: always !important;
//     -webkit-print-color-adjust: exact !important;
//     print-color-adjust: exact !important;
//   }

//   .pdp2-bulk-pdf-deck > :last-child {
//     break-after: auto !important;
//     page-break-after: auto !important;
//   }

//   .pdp2-bulk-pdf-deck
//     [data-pdp2-bulk-static-page]
//     > img {
//     position: absolute !important;
//     inset: 0 !important;
//     width: 100% !important;
//     height: 100% !important;
//     max-width: none !important;
//     max-height: none !important;
//     object-fit: fill !important;
//   }
// `;

// function freezeBulkSlideGeometry(sourceDeck, clonedDeck) {
//   const sourceSlides = Array.from(
//     sourceDeck.querySelectorAll(":scope > .pdp2-slide")
//   );
//   const clonedSlides = Array.from(
//     clonedDeck.querySelectorAll(":scope > .pdp2-slide")
//   );

//   const sectionSelectors = [
//     ".pdp2-summary-section",
//     ".pdp2-matching-section",
//     ".pdp2-experience-section",
//     ".pdp2-education-section",
//   ];

//   sourceSlides.forEach((sourceSlide, slideIndex) => {
//     const clonedSlide = clonedSlides[slideIndex];
//     if (!clonedSlide) return;

//     // The standard Preview slide is already laid out correctly in the active
//     // document. Freeze those calculated section heights onto the clone so the
//     // multi-page print wrapper cannot make Flexbox recalculate them differently.
//     sectionSelectors.forEach((selector) => {
//       const sourceSection = sourceSlide.querySelector(selector);
//       const clonedSection = clonedSlide.querySelector(selector);

//       if (!sourceSection || !clonedSection) return;

//       const height = sourceSection.getBoundingClientRect().height;
//       if (!Number.isFinite(height) || height <= 0) return;

//       clonedSection.style.height = `${height}px`;
//       clonedSection.style.flex = `0 0 ${height}px`;
//     });

//     // Keep the two 600px content columns at the exact same runtime height as
//     // PreviewDigitalPPT as well. This is only a snapshot of the shared layout;
//     // it does not introduce any new design dimensions.
//     [".pdp2-center-column", ".pdp2-right-column"].forEach(
//       (selector) => {
//         const sourceColumn = sourceSlide.querySelector(selector);
//         const clonedColumn = clonedSlide.querySelector(selector);

//         if (!sourceColumn || !clonedColumn) return;

//         const height = sourceColumn.getBoundingClientRect().height;
//         if (!Number.isFinite(height) || height <= 0) return;

//         clonedColumn.style.height = `${height}px`;
//       }
//     );
//   });
// }

// async function prepareBulkPdfPrintWindow(
//   printWindow,
//   sourceHost,
//   title
// ) {
//   printWindow.document.open();
//   printWindow.document.write(`
//     <!doctype html>
//     <html>
//       <head>
//         <meta charset="utf-8" />
//         <title></title>
//       </head>
//       <body>
//         <div id="pdp2-bulk-print-root"></div>
//       </body>
//     </html>
//   `);
//   printWindow.document.close();

//   printWindow.document.title = title;

//   copyBulkDocumentStyles(printWindow);

//   const printStyle =
//     printWindow.document.createElement("style");

//   printStyle.textContent = BULK_PDF_PRINT_STYLE;
//   printWindow.document.head.appendChild(printStyle);

//   const sourceDeck = sourceHost.querySelector(
//     ".pdp2-bulk-pdf-deck"
//   );

//   if (!sourceDeck) {
//     throw new Error(
//       "Bulk digital profile slides could not be rendered."
//     );
//   }

//   const clonedDeck = sourceDeck.cloneNode(true);

//   // Preserve the exact section allocation that the shared DigitalProfileSlide
//   // calculated in the parent document before the multi-page deck is mounted in
//   // the print window.
//   freezeBulkSlideGeometry(sourceDeck, clonedDeck);

//   const sourceFields = sourceDeck.querySelectorAll(
//     "input, textarea, select"
//   );
//   const clonedFields = clonedDeck.querySelectorAll(
//     "input, textarea, select"
//   );

//   sourceFields.forEach((sourceField, index) => {
//     const clonedField = clonedFields[index];

//     if (!clonedField) return;

//     clonedField.value = sourceField.value;

//     if (clonedField.tagName === "TEXTAREA") {
//       clonedField.textContent = sourceField.value;
//     }

//     if (
//       sourceField.type === "checkbox" ||
//       sourceField.type === "radio"
//     ) {
//       clonedField.checked = sourceField.checked;
//     }
//   });

//   // Match PreviewDigitalPPT.handleBrowserPdf(): the normal single-profile
//   // PDF removes editing-only DOM before mounting the print snapshot instead
//   // of merely relying on @media print to hide it. Doing the same here keeps
//   // the Bulk snapshot structurally identical to the standard Preview PDF.
//   clonedDeck
//     .querySelectorAll(
//       '[data-pdp2-print-hide="true"], .pdp2-screen-only'
//     )
//     .forEach((node) => node.remove());

//   clonedDeck
//     .querySelectorAll(".pdp2-print-only")
//     .forEach((node) => {
//       node.style.display = "block";
//     });

//   const printRoot =
//     printWindow.document.getElementById(
//       "pdp2-bulk-print-root"
//     );

//   printRoot.appendChild(clonedDeck);

//   await waitForBulkStyles(printWindow.document);
//   await waitForBulkImages(printWindow.document);

//   if (printWindow.document.fonts?.ready) {
//     try {
//       await printWindow.document.fonts.ready;
//     } catch (error) {
//       console.error(
//         "Could not wait for print fonts:",
//         error
//       );
//     }
//   }
// }

// function MSbuttonsSummery({
//   project_id,
//   expertIds,
//   clientLogo,
//   setAddLogoPopUp,
//   continueWithoutLogo,
//   setContinueWithoutLogo,
//   isLinkCreated,
//   setIsLinkCreated,
//   getSummaryData,
//   showButtons,
//   project_name = "",
//   client_name = "",
//   project_type = "",
// }) {
//   const urlContextValue = useContext(UrlContext);
//   const { API_URL } = urlContextValue;
//   const { userData } = useContext(UserContext);

//   const [pptDownloading, setPptDownloading] = useState(false);
//   const [wordDownloading, setWordDownloading] = useState(false);
//   const [excelDownloading, setExcelDownloading] = useState(false);
//   const [openSelection, setOpenSelection] = useState(false);
//   const [openModifySelection, setOpenModifySelection] = useState(false);
//   const [showPdfUpload, setShowPdfUpload] = useState(false);
//   const [pdfFile, setPdfFile] = useState(null);
//   const [pdfDragActive, setPdfDragActive] = useState(false);
//   const [pdfUploading, setPdfUploading] = useState(false);
//   const [showBulkPdfSelection, setShowBulkPdfSelection] = useState(false);
//   const [bulkPdfSectionVisibility, setBulkPdfSectionVisibility] = useState(
//     () => ({ ...DEFAULT_BULK_PDF_SECTION_VISIBILITY })
//   );
//   const [bulkPdfIdentityMode, setBulkPdfIdentityMode] = useState("id");
//   const [bulkPdfPreviewProfiles, setBulkPdfPreviewProfiles] = useState([]);
//   const [bulkPdfPreviewLoading, setBulkPdfPreviewLoading] = useState(false);
//   const [bulkPdfPreviewError, setBulkPdfPreviewError] = useState("");

//   const checkForLogo = () => {
//     setAddLogoPopUp(true);
//   };

//   const fileCreationHandler = (format) => {
//     const authToken = localStorage.getItem("accesstoken");
//     const tokenObj = localStorage.getItem("eph-token");
//     const token = JSON.parse(tokenObj).value;
//     const url = `${API_URL}create-full-${format}-from-ps/`;
//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "x-access-token": token,
//       },
//       body: JSON.stringify({ expertIds, project_id, authToken }),
//     })
//       .then((res) => res.json())
//       .then(async (data) => {
//         if (data.status === "success") {
//           window.open(data.filePath, "_blank", "rel=noopener noreferrer");
//           await getSummaryData?.(project_id);
//         } else if (data.status === "error") {
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: data.message,
//           });
//         }
//       })
//       .catch((err) => {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: `${err.message}`,
//         });
//       })
//       .finally(() => {
//         if (format === "word") setWordDownloading(false);
//         else if (format === "ppt") setPptDownloading(false);
//         else setExcelDownloading(false);
//       });
//   };

//   const createWordHandler = () => {
//     setWordDownloading(true);
//     fileCreationHandler("word");
//   };

//   const createExcelHandler = () => {
//     setExcelDownloading(true);
//     fileCreationHandler("excel");
//   };

//   const createPPTHandler = () => {
//     if (clientLogo || continueWithoutLogo) {
//       setPptDownloading(true);
//       fileCreationHandler("ppt");
//     } else {
//       checkForLogo();
//     }
//   };

//   const toggleBulkPdfSection = (key) => {
//     setBulkPdfSectionVisibility((previous) => ({
//       ...previous,
//       [key]: !previous[key],
//     }));
//   };

//   const handleBulkPdfIdentitySelection = (mode) => {
//     const isAlreadyActive =
//       bulkPdfSectionVisibility.identity && bulkPdfIdentityMode === mode;

//     if (isAlreadyActive) {
//       setBulkPdfIdentityMode(null);
//       setBulkPdfSectionVisibility((previous) => ({
//         ...previous,
//         identity: false,
//       }));
//       return;
//     }

//     setBulkPdfIdentityMode(mode);
//     setBulkPdfSectionVisibility((previous) => ({
//       ...previous,
//       identity: true,
//     }));
//   };

//   const openBulkPdfSelection = async () => {
//     if (!Array.isArray(expertIds) || expertIds.length === 0) {
//       Swal.fire({
//         icon: "warning",
//         title: "No profiles selected",
//         text: "Please select at least one digital profile first.",
//       });
//       return;
//     }

//     setShowBulkPdfSelection(true);
//     setBulkPdfPreviewProfiles([]);
//     setBulkPdfPreviewError("");
//     setBulkPdfPreviewLoading(true);

//     try {
//       const tokenObj = localStorage.getItem("eph-token");
//       const token = tokenObj ? JSON.parse(tokenObj).value : null;

//       // Fetch all selected profiles for the full live PDF preview. Experience is
//       // explicitly requested so turning that section on never requires another
//       // round-trip while the user is adjusting the layout.
//       const previewSectionVisibility = Object.fromEntries(
//         Object.keys(DEFAULT_BULK_PDF_SECTION_VISIBILITY).map((key) => [key, true])
//       );

//       const response = await fetch(
//         `${API_URL}fetch-digital-profiles-for-pdf`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             ...(token ? { "x-access-token": token } : {}),
//           },
//           body: JSON.stringify({
//             projectID: project_id,
//             expertIDs: expertIds,
//             sectionVisibility: previewSectionVisibility,
//             identityMode: bulkPdfIdentityMode || "id",
//           }),
//         }
//       );

//       const data = await response.json();

//       if (!response.ok || data.status !== "success") {
//         throw new Error(
//           data.text || data.message || "Failed to load the PDF preview profile."
//         );
//       }

//       const previewProfiles = Array.isArray(data.powerpointData)
//         ? data.powerpointData
//         : [];

//       if (!previewProfiles.length) {
//         throw new Error("No digital profiles were returned for the preview.");
//       }

//       setBulkPdfPreviewProfiles(previewProfiles);
//     } catch (error) {
//       console.error("Error loading bulk PDF live preview:", error);
//       setBulkPdfPreviewError(
//         error.message || "The live preview could not be loaded."
//       );
//     } finally {
//       setBulkPdfPreviewLoading(false);
//     }
//   };

//   const addSelectedProfilesToClientEnvironment = async () => {
//     if (!Array.isArray(expertIds) || expertIds.length === 0) {
//       Swal.fire({
//         icon: "warning",
//         title: "No profiles selected",
//         text: "Please select at least one digital profile first.",
//       });
//       return;
//     }

//     const confirmation = await Swal.fire({
//       title: "Add selected profiles to client environment?",
//       text: `${expertIds.length} selected profile${
//         expertIds.length === 1 ? "" : "s"
//       } will be added using the current client-view selection.`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#365561",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Add",
//     });

//     if (!confirmation.isConfirmed) return;

//     Swal.fire({
//       title: "Adding profiles",
//       text: "Please wait while the selected profiles are added...",
//       allowOutsideClick: false,
//       allowEscapeKey: false,
//       showConfirmButton: false,
//       didOpen: () => Swal.showLoading(),
//     });

//     try {
//       const response = await fetch(`${API_URL}add-to-existing-link`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           projectID: project_id,
//           expertList: expertIds,
//         }),
//       });

//       const responseData = await response.json();

//       if (!response.ok || responseData.status !== "success") {
//         throw new Error(
//           responseData.text ||
//             responseData.message ||
//             "Failed to add profiles to the client environment."
//         );
//       }

//       await getSummaryData?.(project_id);

//       Swal.fire({
//         icon: "success",
//         title: "Added!",
//         text:
//           responseData.text ||
//           "Selected profiles have been added to the client environment.",
//         timer: 1800,
//         timerProgressBar: true,
//         showConfirmButton: false,
//       });
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Could not add profiles",
//         text:
//           error.message ||
//           "Failed to add profiles to the client environment.",
//       });
//     }
//   };

//   const selectPdfFile = (file) => {
//     if (!file) return;

//     const isPdf =
//       file.type === "application/pdf" ||
//       file.name?.toLowerCase().endsWith(".pdf");

//     if (!isPdf) {
//       Swal.fire({
//         icon: "warning",
//         title: "PDF required",
//         text: "Please select a PDF file.",
//       });
//       return;
//     }

//     setPdfFile(file);
//   };

//   const handlePdfDrop = (event) => {
//     event.preventDefault();
//     event.stopPropagation();
//     setPdfDragActive(false);

//     if (pdfUploading) return;

//     const files = Array.from(event.dataTransfer.files || []);

//     if (files.length > 1) {
//       Swal.fire({
//         icon: "warning",
//         title: "One PDF at a time",
//         text: "Please upload only one PDF file.",
//       });
//       return;
//     }

//     selectPdfFile(files[0]);
//   };

//   const closePdfUpload = () => {
//     if (pdfUploading) return;

//     setShowPdfUpload(false);
//     setPdfFile(null);
//     setPdfDragActive(false);
//   };

//   const uploadPdfToSharePoint = async () => {
//     if (!pdfFile) {
//       Swal.fire({
//         icon: "warning",
//         title: "No PDF selected",
//         text: "Please select or drop the PDF file first.",
//       });
//       return;
//     }

//     const authToken = localStorage.getItem("accesstoken");
//     const formData = new FormData();

//     formData.append("file", pdfFile);
//     formData.append("fileName", pdfFile.name);
//     formData.append("authToken", authToken || "");
//     formData.append("projectID", String(project_id));

//     try {
//       setPdfUploading(true);

//       const response = await fetch(
//         `${API_URL}upload-file-to-sharePoint`,
//         {
//           method: "POST",
//           body: formData,
//         }
//       );

//       const data = await response.json();

//       if (
//         !response.ok ||
//         data.status !== "success"
//       ) {
//         throw new Error(
//           data.text ||
//             data.message ||
//             "Failed to upload PDF to SharePoint."
//         );
//       }

//       setShowPdfUpload(false);
//       setPdfFile(null);
//       setPdfDragActive(false);

//       Swal.fire({
//         icon: "success",
//         title: "PDF uploaded",
//         text: "The PDF has been uploaded to SharePoint.",
//       });
//     } catch (error) {
//       console.error(
//         "Error uploading PDF to SharePoint:",
//         error
//       );

//       Swal.fire({
//         icon: "error",
//         title: "Upload failed",
//         text:
//           error.message ||
//           "Failed to upload the PDF to SharePoint.",
//       });
//     } finally {
//       setPdfUploading(false);
//     }
//   };

//   const createBulkPdfHandler = async (pdfSelection) => {
//     if (!Array.isArray(expertIds) || expertIds.length === 0) {
//       Swal.fire({
//         icon: "warning",
//         title: "No profiles selected",
//         text: "Please select at least one digital profile first.",
//       });
//       return;
//     }

//     const selectedSectionVisibility = {
//       ...DEFAULT_BULK_PDF_SECTION_VISIBILITY,
//       ...(pdfSelection?.sectionVisibility || {}),
//     };
//     const selectedIdentityMode = selectedSectionVisibility.identity
//       ? pdfSelection?.identityMode || "id"
//       : null;

//     Swal.fire({
//       title: "Generating bulk PDF",
//       text: `Preparing ${expertIds.length} digital profile${
//         expertIds.length === 1 ? "" : "s"
//       }...`,
//       allowOutsideClick: false,
//       allowEscapeKey: false,
//       showConfirmButton: false,
//       didOpen: () => {
//         Swal.showLoading();
//       },
//     });

//     let renderHost = null;
//     let renderRoot = null;

//     try {
//       const tokenObj =
//         localStorage.getItem("eph-token");
//       const token = tokenObj
//         ? JSON.parse(tokenObj).value
//         : null;

//       /*
//        * 1. Fetch everything first while the parent page remains active.
//        */
//       const response = await fetch(
//         `${API_URL}fetch-digital-profiles-for-pdf`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             ...(token
//               ? { "x-access-token": token }
//               : {}),
//           },
//           body: JSON.stringify({
//             projectID: project_id,
//             expertIDs: expertIds,
//             sectionVisibility: selectedSectionVisibility,
//             identityMode: selectedIdentityMode,
//           }),
//         }
//       );

//       const data = await response.json();

//       if (
//         !response.ok ||
//         data.status !== "success"
//       ) {
//         throw new Error(
//           data.text ||
//             data.message ||
//             "Failed to fetch digital profiles."
//         );
//       }

//       const profiles = Array.isArray(
//         data.powerpointData
//       )
//         ? data.powerpointData
//         : [];

//       if (!profiles.length) {
//         throw new Error(
//           "No digital profiles were returned."
//         );
//       }

//       /*
//        * 2. Render the full read-only PDF deck in the CURRENT page first.
//        *
//        * The previous implementation opened the new tab before this step.
//        * Browsers pause/throttle requestAnimationFrame in a background tab,
//        * which meant this parent-page render could remain suspended until
//        * the user returned to the parent tab.
//        *
//        * flushSync commits the hidden deck immediately while this tab is
//        * active, so there is no background-tab dependency.
//        */
//       renderHost = document.createElement("div");
//       renderHost.setAttribute(
//         "data-pdp2-bulk-render-host",
//         "true"
//       );

//       Object.assign(renderHost.style, {
//         position: "fixed",
//         left: "-100000px",
//         top: "0",
//         width: "1280px",
//         visibility: "hidden",
//         pointerEvents: "none",
//         zIndex: "-1",
//       });

//       document.body.appendChild(renderHost);

//       renderRoot = createRoot(renderHost);

//       flushSync(() => {
//         renderRoot.render(
//           <UrlContext.Provider value={urlContextValue}>
//             <BulkDigitalProfileDeck
//               profiles={profiles}
//               projectName={project_name}
//               clientName={client_name}
//               contactName={userData?.fullname || ""}
//               contactEmail={userData?.email || ""}
//               projectType={profiles?.[0]?.projectType}
//               sectionVisibility={selectedSectionVisibility}
//               identityMode={selectedIdentityMode}
//             />
//           </UrlContext.Provider>
//         );
//       });

//       // Let shared-slide effects (notably Education auto-sizing) commit before
//       // cloning the rendered deck into the print window.
//       await new Promise((resolve) => {
//         requestAnimationFrame(() => requestAnimationFrame(resolve));
//       });

//       await waitForBulkImages(renderHost);

//       if (document.fonts?.ready) {
//         try {
//           await document.fonts.ready;
//         } catch (error) {
//           console.error(
//             "Could not wait for PDF fonts:",
//             error
//           );
//         }
//       }

//       const makeSafePdfFilePart = (value, fallback) => {
//         const cleaned = String(value || fallback || "")
//           .replace(/[\\/:*?"<>|]+/g, " ")
//           .replace(/\s+/g, " ")
//           .trim();

//         return cleaned;
//       };

//       const now = new Date();
//       const dateMonthYear = `${String(now.getDate()).padStart(2, "0")}${new Intl.DateTimeFormat(
//         "en-US",
//         { month: "short" }
//       ).format(now)}${String(now.getFullYear()).slice(-2)}`;

//       const bulkPdfFileName = `expertpowerhouse_${makeSafePdfFilePart(
//         client_name,
//         "Client"
//       )}_${makeSafePdfFilePart(
//         project_name,
//         "Project"
//       )}_${dateMonthYear}`;

//       /*
//        * 3. At this point the backend data, React deck and images are ready.
//        *
//        * Ask for one explicit click before opening the print window.
//        * This prevents browser popup blockers from rejecting window.open()
//        * after the asynchronous fetch/render work.
//        */
//       const readyResult = await Swal.fire({
//         icon: "success",
//         title: "Bulk PDF ready",
//         text: `${profiles.length} digital profile${
//           profiles.length === 1 ? "" : "s"
//         } prepared and ready to print.`,
//         confirmButtonText: "Open PDF",
//         showCancelButton: true,
//         cancelButtonText: "Cancel",
//         reverseButtons: true,
//       });

//       if (!readyResult.isConfirmed) {
//         renderRoot.unmount();
//         renderRoot = null;

//         renderHost.remove();
//         renderHost = null;

//         return;
//       }

//       /*
//        * 4. Only now open the new window.
//        * This click is a direct user action, so popup blockers should allow it.
//        */
//       const printWindow = window.open(
//         "",
//         "_blank",
//         "width=1400,height=900"
//       );

//       if (!printWindow) {
//         throw new Error(
//           "The PDF window was blocked. Please allow popups for this site and try again."
//         );
//       }

//       Swal.fire({
//         title: "Opening PDF",
//         text: "Preparing the print window...",
//         allowOutsideClick: false,
//         allowEscapeKey: false,
//         showConfirmButton: false,
//         didOpen: () => {
//           Swal.showLoading();
//         },
//       });

//       try {
//         await prepareBulkPdfPrintWindow(
//           printWindow,
//           renderHost,
//           bulkPdfFileName
//         );

//         renderRoot.unmount();
//         renderRoot = null;

//         renderHost.remove();
//         renderHost = null;

//         Swal.close();

//         printWindow.onafterprint = () => {
//           setPdfFile(null);
//           setPdfDragActive(false);
//           setShowPdfUpload(true);

//           try {
//             printWindow.close();
//           } catch (error) {
//             console.error(
//               "Could not close bulk PDF window:",
//               error
//             );
//           }
//         };

//         setTimeout(() => {
//           printWindow.focus();
//           printWindow.print();
//         }, 250);
//       } catch (printError) {
//         try {
//           printWindow.close();
//         } catch (closeError) {
//           console.error(
//             "Could not close failed bulk PDF window:",
//             closeError
//           );
//         }

//         throw printError;
//       }
//     } catch (error) {
//       console.error(
//         "Error generating bulk digital profile PDF:",
//         error
//       );

//       if (renderRoot) {
//         renderRoot.unmount();
//       }

//       if (renderHost?.isConnected) {
//         renderHost.remove();
//       }

//       Swal.fire({
//         icon: "error",
//         title: "Bulk PDF generation failed",
//         text:
//           error.message ||
//           "Failed to generate the bulk PDF.",
//       });
//     }
//   };

//   useEffect(() => {
//     if (continueWithoutLogo) {
//       createPPTHandler();
//       setContinueWithoutLogo(false);
//       setAddLogoPopUp(false);
//     }
//   }, [continueWithoutLogo]);

//   return (
//     <>
//       {isLinkCreated && (
//         <>
//           <MSActionButton
//             icon="fa-regular fa-eye"
//             shortLabel="View"
//             isLeftEdge
//             label="View client environment"
//             onClick={() => window.open(`/app/SharedProfiles/${project_id}`, "_blank")}
//           />

//           <MSActionButton
//             icon="fa-regular fa-pen-to-square"
//             shortLabel="Modify"
//             label="Modify shared information selection"
//             onClick={() => setOpenModifySelection(true)}
//           />
//         </>
//       )}

//       {showButtons && (
//         <>
//           {isLinkCreated ? (
//             <MSActionButton
//               icon="fa-solid fa-file-circle-plus"
//               shortLabel="Add"
//               isLeftEdge={!isLinkCreated}
//               label="Add selected profiles to client environment"
//               primary
//               onClick={addSelectedProfilesToClientEnvironment}
//             />
//           ) : (
//             <MSActionButton
//               icon="fa-solid fa-globe"
//               shortLabel="Create"
//               isLeftEdge={!isLinkCreated}
//               label="Create client environment from selected profiles"
//               primary
//               onClick={() => setOpenSelection(true)}
//             />
//           )}

//           <MSActionButton
//             icon="fa-regular fa-file-word"
//             shortLabel="Word"
//             label="Generate Word document"
//             loading={wordDownloading}
//             onClick={createWordHandler}
//           />
//           <MSActionButton
//             icon="fa-regular fa-file-powerpoint"
//             shortLabel="PPTX"
//             label="Generate PowerPoint document"
//             loading={pptDownloading}
//             onClick={createPPTHandler}
//           />
//           <MSActionButton
//             icon="fa-regular fa-file-excel"
//             shortLabel="Excel"
//             label="Generate Excel document"
//             loading={excelDownloading}
//             onClick={createExcelHandler}
//           />
//           <MSActionButton
//             icon="fa-regular fa-file-pdf"
//             shortLabel="PDF"
//             label="Generate bulk PDF"
//             onClick={openBulkPdfSelection}
//           />
//         </>
//       )}

//       {pptDownloading && <LoadingOverlay text="Generating PowerPoint..." />}
//       {wordDownloading && <LoadingOverlay text="Generating Word document..." />}
//       {excelDownloading && <LoadingOverlay text="Generating Excel file..." />}

//       <BulkPdfSectionSelectionModal
//         open={showBulkPdfSelection}
//         sectionVisibility={bulkPdfSectionVisibility}
//         identityMode={bulkPdfIdentityMode}
//         previewProfiles={bulkPdfPreviewProfiles}
//         previewLoading={bulkPdfPreviewLoading}
//         previewError={bulkPdfPreviewError}
//         projectName={project_name}
//         clientName={client_name}
//         contactName={userData?.fullname || ""}
//         contactEmail={userData?.email || ""}
//         onToggleSection={toggleBulkPdfSection}
//         onIdentitySelection={handleBulkPdfIdentitySelection}
//         onClose={() => setShowBulkPdfSelection(false)}
//         onConfirm={() => {
//           const selection = {
//             sectionVisibility: { ...bulkPdfSectionVisibility },
//             identityMode: bulkPdfSectionVisibility.identity
//               ? bulkPdfIdentityMode || "id"
//               : null,
//           };

//           flushSync(() => {
//             setShowBulkPdfSelection(false);
//           });

//           createBulkPdfHandler(selection);
//         }}
//       />

//       {showPdfUpload && (
//         <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 px-4 backdrop-blur-sm">
//           <div className="w-full max-w-lg overflow-hidden rounded-3xl bg-white shadow-2xl">
//             {/* Header */}
//             <div className="flex items-start justify-between gap-4 border-b border-slate-200 px-6 py-4">
//               <div className="min-w-0">
//                 <h3 className="text-base font-bold text-slate-800">
//                   Upload saved PDF
//                 </h3>

//                 <p className="mt-1 text-xs leading-5 text-slate-500">
//                   If you saved the PDF from the print window, upload it here to
//                   store it in SharePoint.
//                 </p>
//               </div>

//               <button
//                 type="button"
//                 disabled={pdfUploading}
//                 onClick={closePdfUpload}
//                 className="
//                   flex h-8 w-8 shrink-0 items-center justify-center
//                   rounded-full !border-0 !bg-transparent
//                   !p-0 !text-xl !font-normal !leading-none
//                   !text-slate-400
//                   transition
//                   hover:!bg-slate-100 hover:!text-slate-700
//                   disabled:cursor-not-allowed disabled:opacity-40
//                 "
//                 aria-label="Close PDF upload"
//                 title="Close"
//               >
//                 ×
//               </button>
//             </div>

//             {/* Body */}
//             <div className="p-6">
//               <label
//                 onDragEnter={(event) => {
//                   if (pdfUploading) return;

//                   event.preventDefault();
//                   event.stopPropagation();
//                   setPdfDragActive(true);
//                 }}
//                 onDragOver={(event) => {
//                   if (pdfUploading) return;

//                   event.preventDefault();
//                   event.stopPropagation();
//                   setPdfDragActive(true);
//                 }}
//                 onDragLeave={(event) => {
//                   event.preventDefault();
//                   event.stopPropagation();
//                   setPdfDragActive(false);
//                 }}
//                 onDrop={handlePdfDrop}
//                 className={[
//                   "relative flex min-h-[230px] flex-col items-center justify-center",
//                   "rounded-2xl border-2 border-dashed px-6 text-center transition",
//                   pdfUploading
//                     ? "cursor-default border-slate-200 bg-slate-50"
//                     : pdfDragActive
//                       ? "cursor-pointer border-[#365561] bg-[#365561]/5"
//                       : "cursor-pointer border-slate-300 bg-slate-50 hover:border-[#365561]/60 hover:bg-slate-100",
//                 ].join(" ")}
//               >
//                 <input
//                   type="file"
//                   accept=".pdf,application/pdf"
//                   className="hidden"
//                   disabled={pdfUploading}
//                   onChange={(event) => {
//                     const file = event.target.files?.[0];

//                     selectPdfFile(file);

//                     event.target.value = "";
//                   }}
//                 />

//                 {pdfUploading ? (
//                   /* Uploading state */
//                   <div className="flex flex-col items-center justify-center">
//                     <span
//                       className="
//                         h-10 w-10 animate-spin rounded-full
//                         border-[3px] border-slate-200
//                         border-t-[#365561]
//                       "
//                     />

//                     <p className="mt-4 text-sm font-semibold text-slate-700">
//                       Uploading PDF...
//                     </p>

//                     <p className="mt-1 text-xs text-slate-400">
//                       Saving the file to SharePoint
//                     </p>

//                     {pdfFile?.name && (
//                       <p className="mt-4 max-w-[320px] truncate text-xs font-medium text-slate-500">
//                         {pdfFile.name}
//                       </p>
//                     )}
//                   </div>
//                 ) : pdfFile ? (
//                   /* Selected PDF state */
//                   <>
//                     <div className="relative mb-4 flex h-16 w-14 items-center justify-center">
//                       <FileText
//                         size={52}
//                         strokeWidth={1.35}
//                         className="text-[#365561]"
//                       />

//                       <span
//                         className="
//                           absolute -bottom-1 left-1/2
//                           -translate-x-1/2
//                           rounded-md bg-[#365561]
//                           px-1.5 py-0.5
//                           text-[8px] font-bold tracking-wide text-white
//                         "
//                       >
//                         PDF
//                       </span>
//                     </div>

//                     <p className="max-w-full break-all text-sm font-semibold text-slate-700">
//                       {pdfFile.name}
//                     </p>

//                     <p className="mt-1 text-xs text-slate-400">
//                       {(pdfFile.size / 1024 / 1024).toFixed(2)} MB
//                     </p>

//                     <p className="mt-4 text-xs font-semibold text-[#365561]">
//                       Click or drop another PDF to replace it
//                     </p>
//                   </>
//                 ) : (
//                   /* Empty state */
//                   <>
//                     <FileDown
//                       size={36}
//                       strokeWidth={1.5}
//                       className="mb-3 text-[#365561]"
//                     />

//                     <p className="text-sm font-semibold text-slate-700">
//                       Drag &amp; drop your PDF here
//                     </p>

//                     <p className="my-2 text-xs text-slate-400">
//                       or
//                     </p>

//                     <span
//                       className="
//                         rounded-xl bg-[#365561]
//                         px-4 py-2
//                         text-xs font-semibold text-white shadow-sm
//                       "
//                     >
//                       Select from computer
//                     </span>

//                     <p className="mt-4 text-[10px] text-slate-400">
//                       One PDF file at a time
//                     </p>
//                   </>
//                 )}
//               </label>
//             </div>

//             {/* Footer */}
//             <div className="flex justify-end gap-2 border-t border-slate-200 bg-slate-50 px-6 py-3">
//               <button
//                 type="button"
//                 disabled={pdfUploading}
//                 onClick={closePdfUpload}
//                 className="
//                   rounded-xl
//                   !border !border-slate-200
//                   !bg-white
//                   px-4 py-2
//                   !text-sm !font-semibold !text-slate-600
//                   transition
//                   hover:!border-slate-300 hover:!bg-slate-100 hover:!text-slate-700
//                   disabled:cursor-not-allowed disabled:opacity-40
//                 "
//               >
//                 Skip
//               </button>

//               <button
//                 type="button"
//                 disabled={!pdfFile || pdfUploading}
//                 onClick={uploadPdfToSharePoint}
//                 className="
//                   inline-flex min-w-[120px] items-center justify-center gap-2
//                   rounded-xl
//                   !border-0
//                   !bg-[#365561]
//                   px-4 py-2
//                   !text-sm !font-semibold !text-white
//                   transition
//                   hover:!bg-[#2e4a54] hover:!text-white
//                   disabled:cursor-not-allowed
//                   disabled:!bg-slate-300 disabled:!text-white
//                   disabled:opacity-100
//                 "
//               >
//                 {pdfUploading && (
//                   <span
//                     className="
//                       h-4 w-4 animate-spin rounded-full
//                       border-2 border-white/40 border-t-white
//                     "
//                   />
//                 )}

//                 {pdfUploading ? "Uploading..." : "Upload"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <ClientEnvironmentSelectionModal
//         open={openSelection}
//         mode="create"
//         projectID={project_id}
//         expertIDList={expertIds}
//         projectType={project_type}
//         onClose={() => setOpenSelection(false)}
//         setIsLinkCreated={setIsLinkCreated}
//         getSummaryData={getSummaryData}
//       />

//       <ClientEnvironmentSelectionModal
//         open={openModifySelection}
//         mode="modify"
//         projectID={project_id}
//         expertIDList={expertIds}
//         projectType={project_type}
//         onClose={() => setOpenModifySelection(false)}
//         setIsLinkCreated={setIsLinkCreated}
//         getSummaryData={getSummaryData}
//       />
//     </>
//   );
// }

// function ClientEnvironmentSelectionModal({
//   open,
//   mode,
//   projectID,
//   expertIDList,
//   projectType,
//   onClose,
//   setIsLinkCreated,
//   getSummaryData,
// }) {
//   const { API_URL } = useContext(UrlContext);
//   const isModifyMode = mode === "modify";

//   const [sectionVisibility, setSectionVisibility] = useState(() =>
//     getDefaultClientEnvironmentVisibility(projectType)
//   );
//   const [identityMode, setIdentityMode] = useState("id");
//   const [loadingSelection, setLoadingSelection] = useState(false);
//   const [actionLoading, setActionLoading] = useState(false);
//   const [savingField, setSavingField] = useState("");

//   const applySelectionResponse = (selection = {}) => {
//     const valueOrDefault = (value, fallback) =>
//       value === null || value === undefined ? fallback : Boolean(value);

//     const isNameShared = valueOrDefault(selection.isNameShared, false);
//     const isIdShared = valueOrDefault(selection.isIdShared, true);

//     setIdentityMode(
//       isNameShared ? "name" : isIdShared ? "id" : null
//     );

//     setSectionVisibility({
//       identity: isNameShared || isIdShared,
//       position: valueOrDefault(selection.hasPositionSection, true),
//       location: valueOrDefault(selection.hasLocationSection, true),
//       region: valueOrDefault(selection.hasRegionSection, true),
//       language: valueOrDefault(selection.hasLanguageSection, true),
//       totalExperience: valueOrDefault(
//         selection.hasTotalExperienceSection,
//         true
//       ),
//       availability: valueOrDefault(selection.hasAvailabilitySection, true),
//       rate: valueOrDefault(selection.hasRateSection, true),
//       summary: valueOrDefault(selection.hasSummarySection, true),
//       matching: valueOrDefault(selection.hasMatchingSection, true),
//       experience: valueOrDefault(selection.hasExperienceSection, true),
//       education: valueOrDefault(selection.hasEducationSection, true),
//     });
//   };

//   const fetchCurrentSelection = async () => {
//     setLoadingSelection(true);

//     try {
//       const response = await fetch(
//         `${API_URL}fetch-client-environment-selection`,
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ projectID }),
//         }
//       );

//       const responseData = await response.json();

//       if (!response.ok || responseData.status !== "success") {
//         throw new Error(
//           responseData.text ||
//             responseData.message ||
//             "Failed to load the current client-view selection."
//         );
//       }

//       applySelectionResponse(responseData.selection || {});
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Could not load selection",
//         text:
//           error.message ||
//           "Failed to load the current client-view selection.",
//       });
//       onClose();
//     } finally {
//       setLoadingSelection(false);
//     }
//   };

//   useEffect(() => {
//     if (!open) return;

//     if (isModifyMode) {
//       fetchCurrentSelection();
//       return;
//     }

//     setSectionVisibility(
//       getDefaultClientEnvironmentVisibility(projectType)
//     );
//     setIdentityMode("id");
//     setLoadingSelection(false);
//     setSavingField("");
//   }, [open, isModifyMode, projectID, projectType]);

//   const persistModifyUpdates = async (updates, fieldKey) => {
//     setSavingField(fieldKey);

//     try {
//       const response = await fetch(
//         `${API_URL}modify-information-selection-for-client`,
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             projectID,
//             updates,
//           }),
//         }
//       );

//       const responseData = await response.json();

//       if (!response.ok || responseData.status !== "success") {
//         throw new Error(
//           responseData.text ||
//             responseData.message ||
//             "Failed to update the client-view selection."
//         );
//       }

//       return true;
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Update failed",
//         text:
//           error.message ||
//           "Failed to update the client-view selection.",
//       });
//       return false;
//     } finally {
//       setSavingField("");
//     }
//   };

//   const toggleSection = async (key) => {
//     if (loadingSelection || actionLoading || savingField) return;

//     const projectField = CLIENT_ENVIRONMENT_PROJECT_FIELD_MAP[key];
//     if (!projectField) return;

//     const previousValue = sectionVisibility[key];
//     const nextValue = !previousValue;

//     setSectionVisibility((previous) => ({
//       ...previous,
//       [key]: nextValue,
//     }));

//     if (!isModifyMode) return;

//     const saved = await persistModifyUpdates(
//       { [projectField]: nextValue },
//       key
//     );

//     if (!saved) {
//       setSectionVisibility((previous) => ({
//         ...previous,
//         [key]: previousValue,
//       }));
//     }
//   };

//   const selectIdentity = async (nextMode) => {
//     if (loadingSelection || actionLoading || savingField) return;

//     const previousVisible = sectionVisibility.identity;
//     const previousMode = identityMode;
//     const isAlreadyActive =
//       previousVisible && previousMode === nextMode;

//     const nextVisible = !isAlreadyActive;
//     const resolvedMode = nextVisible ? nextMode : null;

//     setSectionVisibility((previous) => ({
//       ...previous,
//       identity: nextVisible,
//     }));
//     setIdentityMode(resolvedMode);

//     if (!isModifyMode) return;

//     const saved = await persistModifyUpdates(
//       {
//         isNameShared: nextVisible && resolvedMode === "name",
//         isIdShared: nextVisible && resolvedMode === "id",
//       },
//       "identity"
//     );

//     if (!saved) {
//       setSectionVisibility((previous) => ({
//         ...previous,
//         identity: previousVisible,
//       }));
//       setIdentityMode(previousMode);
//     }
//   };

//   const createClientEnvironment = async () => {
//     if (!Array.isArray(expertIDList) || expertIDList.length === 0) {
//       Swal.fire({
//         icon: "warning",
//         title: "No profiles selected",
//         text: "Please select at least one digital profile first.",
//       });
//       return;
//     }

//     setActionLoading(true);

//     try {
//       const tokenObj = localStorage.getItem("eph-token");
//       const token = tokenObj ? JSON.parse(tokenObj)?.value : "";

//       const response = await fetch(`${API_URL}create-link-for-client`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           ...(token ? { "x-access-token": token } : {}),
//         },
//         body: JSON.stringify({
//           projectID,
//           expertList: expertIDList,
//           selection: clientEnvironmentSelectionPayload(
//             sectionVisibility,
//             identityMode
//           ),
//         }),
//       });

//       const responseData = await response.json();

//       if (!response.ok || responseData.status !== "success") {
//         throw new Error(
//           responseData.text ||
//             responseData.message ||
//             "Failed to create the client environment."
//         );
//       }

//       setIsLinkCreated?.(true);
//       await getSummaryData?.(projectID);
//       onClose();

//       Swal.fire({
//         icon: "success",
//         title: "Client environment created",
//         text:
//           responseData.text ||
//           "The selected profiles and client-view selection are ready.",
//         timer: 1800,
//         timerProgressBar: true,
//         showConfirmButton: false,
//       });
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Creation failed",
//         text:
//           error.message ||
//           "Failed to create the client environment.",
//       });
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const informationOptions = [
//     {
//       key: "ephId",
//       label: "EPH ID",
//       description: "EPH_CON_ / EPH_EXP_ identifier",
//       icon: Hash,
//       checked: sectionVisibility.identity && identityMode === "id",
//       onChange: () => selectIdentity("id"),
//     },
//     {
//       key: "name",
//       label: "Name",
//       description: "Consultant name",
//       icon: UserRound,
//       checked: sectionVisibility.identity && identityMode === "name",
//       onChange: () => selectIdentity("name"),
//     },
//     {
//       key: "position",
//       label: "Position",
//       description: "Current role or headline",
//       icon: BriefcaseBusiness,
//       checked: sectionVisibility.position,
//       onChange: () => toggleSection("position"),
//     },
//     {
//       key: "location",
//       label: "Location",
//       description: "Current consultant location",
//       icon: MapPin,
//       checked: sectionVisibility.location,
//       onChange: () => toggleSection("location"),
//     },
//     {
//       key: "region",
//       label: "Region",
//       description: "Regional experience",
//       icon: Globe2,
//       checked: sectionVisibility.region,
//       onChange: () => toggleSection("region"),
//     },
//     {
//       key: "language",
//       label: "Languages",
//       description: "Language capabilities",
//       icon: Languages,
//       checked: sectionVisibility.language,
//       onChange: () => toggleSection("language"),
//     },
//     {
//       key: "totalExperience",
//       label: "Total experience",
//       description: "Years of professional experience",
//       icon: BriefcaseBusiness,
//       checked: sectionVisibility.totalExperience,
//       onChange: () => toggleSection("totalExperience"),
//     },
//     {
//       key: "availability",
//       label: "Availability",
//       description: "Current availability note",
//       icon: CalendarClock,
//       checked: sectionVisibility.availability,
//       onChange: () => toggleSection("availability"),
//     },
//     {
//       key: "rate",
//       label: "Rate",
//       description: "Currency, rate and billing unit",
//       icon: Coins,
//       checked: sectionVisibility.rate,
//       onChange: () => toggleSection("rate"),
//     },
//   ];

//   const contentOptions = [
//     {
//       key: "summary",
//       label: "Professional Summary",
//       description: "Main consultant summary",
//       icon: FileText,
//       checked: sectionVisibility.summary,
//       onChange: () => toggleSection("summary"),
//     },
//     {
//       key: "matching",
//       label: "Requirement Matching",
//       description: "Dimensions and radar matching",
//       icon: Target,
//       checked: sectionVisibility.matching,
//       onChange: () => toggleSection("matching"),
//     },
//     {
//       key: "experience",
//       label: "Relevant Experience",
//       description: "Selected professional experience",
//       icon: BriefcaseBusiness,
//       checked: sectionVisibility.experience,
//       onChange: () => toggleSection("experience"),
//     },
//     {
//       key: "education",
//       label: "Education & Certification",
//       description: "Education and credentials",
//       icon: GraduationCap,
//       checked: sectionVisibility.education,
//       onChange: () => toggleSection("education"),
//     },
//   ];

//   const informationActiveCount = informationOptions.filter(
//     (option) => option.checked
//   ).length;
//   const contentActiveCount = contentOptions.filter(
//     (option) => option.checked
//   ).length;

//   if (typeof document === "undefined") return null;

//   const closeModal = async () => {
//     if (actionLoading || savingField) return;
//     if (isModifyMode) await getSummaryData?.(projectID);
//     onClose();
//   };

//   return createPortal(
//     <AnimatePresence>
//       {open && (
//         <motion.div
//           className="fixed inset-0 z-[10050] flex items-center justify-center bg-slate-950/45 p-4 backdrop-blur-sm sm:p-6"
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           exit={{ opacity: 0 }}
//           transition={{ duration: 0.16 }}
//           role="presentation"
//           data-pdp2-print-hide="true"
//           onMouseDown={(event) => {
//             if (event.target === event.currentTarget) closeModal();
//           }}
//         >
//           <motion.div
//             className="pdp2-section-picker flex max-h-[90vh] w-[min(1080px,calc(100vw-32px))] flex-col overflow-hidden rounded-[26px] border border-slate-200/90 bg-[radial-gradient(circle_at_top,rgba(54,85,97,0.14),transparent_34%),linear-gradient(to_bottom,#f8fafc,#eef2f6)] shadow-[0_28px_90px_rgba(15,23,42,0.34)]"
//             initial={{ opacity: 0, y: 22, scale: 0.975 }}
//             animate={{ opacity: 1, y: 0, scale: 1 }}
//             exit={{ opacity: 0, y: 18, scale: 0.98 }}
//             transition={{
//               type: "spring",
//               stiffness: 340,
//               damping: 30,
//               mass: 0.82,
//             }}
//             role="dialog"
//             aria-modal="true"
//             aria-labelledby="client-environment-section-picker-title"
//             onMouseDown={(event) => event.stopPropagation()}
//           >
//             <div className="pdp2-section-picker-header">
//               <div className="pdp2-section-picker-title-wrap">
//                 <span className="pdp2-section-picker-eyebrow">
//                   Client environment
//                 </span>
//                 <strong id="client-environment-section-picker-title">
//                   {isModifyMode
//                     ? "Modify client-view selection"
//                     : "Choose client-view sections"}
//                 </strong>
//                 <p>
//                   {isModifyMode
//                     ? "Choose which information is visible in the client environment. Changes are saved immediately for this project."
//                     : "Choose which information and content blocks the client should see for this project."}
//                 </p>
//               </div>

//               <button
//                 type="button"
//                 className="pdp2-section-picker-close"
//                 onClick={closeModal}
//                 disabled={actionLoading || Boolean(savingField)}
//                 aria-label="Close client environment selection"
//               >
//                 ×
//               </button>
//             </div>

//             <div className="pdp2-section-picker-body">
//               {loadingSelection ? (
//                 <div className="flex min-h-[360px] items-center justify-center text-[#365561]">
//                   <div className="text-center">
//                     <i className="fa-solid fa-spinner fa-spin text-3xl" />
//                     <p className="mt-3 text-sm font-semibold">
//                       Loading client-view selection...
//                     </p>
//                   </div>
//                 </div>
//               ) : (
//                 <div className="pdp2-section-picker-sections">
//                   <section className="pdp2-section-picker-panel pdp2-section-picker-panel-information">
//                     <div className="pdp2-section-picker-panel-header">
//                       <div className="pdp2-section-picker-panel-title">
//                         <span className="pdp2-section-picker-panel-icon">
//                           <UserRound size={17} strokeWidth={2} />
//                         </span>
//                         <div>
//                           <strong>Information</strong>
//                           <small>Client-facing consultant details</small>
//                         </div>
//                       </div>
//                       <span className="pdp2-section-picker-count">
//                         {informationActiveCount}/{informationOptions.length}
//                       </span>
//                     </div>

//                     <div className="pdp2-section-picker-grid pdp2-section-picker-grid-information">
//                       {informationOptions.map((option) => (
//                         <BulkPdfSectionToggle
//                           key={option.key}
//                           checked={option.checked}
//                           onChange={option.onChange}
//                           icon={option.icon}
//                           label={option.label}
//                           description={option.description}
//                         />
//                       ))}
//                     </div>

//                     <div className="pdp2-section-picker-note">
//                       <Hash size={13} strokeWidth={2} />
//                       <span>
//                         <strong>EPH ID</strong> and <strong>Name</strong> share
//                         the same identity area and are mutually exclusive.
//                       </span>
//                     </div>
//                   </section>

//                   <section className="pdp2-section-picker-panel pdp2-section-picker-panel-content">
//                     <div className="pdp2-section-picker-panel-header">
//                       <div className="pdp2-section-picker-panel-title">
//                         <span className="pdp2-section-picker-panel-icon">
//                           <FileText size={17} strokeWidth={2} />
//                         </span>
//                         <div>
//                           <strong>Content</strong>
//                           <small>Main client-view profile sections</small>
//                         </div>
//                       </div>
//                       <span className="pdp2-section-picker-count">
//                         {contentActiveCount}/{contentOptions.length}
//                       </span>
//                     </div>

//                     <div className="pdp2-section-picker-grid pdp2-section-picker-grid-content">
//                       {contentOptions.map((option) => (
//                         <BulkPdfSectionToggle
//                           key={option.key}
//                           checked={option.checked}
//                           onChange={option.onChange}
//                           icon={option.icon}
//                           label={option.label}
//                           description={option.description}
//                         />
//                       ))}
//                     </div>
//                   </section>
//                 </div>
//               )}
//             </div>

//             <div className="flex shrink-0 items-center justify-between gap-3 border-t border-slate-200/90 bg-white/85 px-5 py-4 backdrop-blur-sm">
//               <p className="min-h-[20px] text-xs font-medium text-slate-500">
//                 {isModifyMode
//                   ? savingField
//                     ? "Saving change..."
//                     : "Changes are saved immediately for the whole project."
//                   : "This selection becomes the default client view for this project."}
//               </p>

//               <div className="flex items-center gap-2">
//                 {!isModifyMode && (
//                   <button
//                     type="button"
//                     className="rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-600 transition hover:bg-slate-50 focus:outline-none"
//                     onClick={closeModal}
//                     disabled={actionLoading}
//                   >
//                     Cancel
//                   </button>
//                 )}

//                 <button
//                   type="button"
//                   className="rounded-xl border-0 bg-[#365561] px-5 py-2 text-sm font-semibold text-white transition hover:bg-[#2e4a54] focus:outline-none disabled:cursor-wait disabled:opacity-60"
//                   onClick={isModifyMode ? closeModal : createClientEnvironment}
//                   disabled={loadingSelection || actionLoading || Boolean(savingField)}
//                 >
//                   {actionLoading ? (
//                     <span className="inline-flex items-center gap-2">
//                       <i className="fa-solid fa-spinner fa-spin" />
//                       Creating...
//                     </span>
//                   ) : isModifyMode ? (
//                     "Close"
//                   ) : (
//                     "Create client environment"
//                   )}
//                 </button>
//               </div>
//             </div>
//           </motion.div>
//         </motion.div>
//       )}
//     </AnimatePresence>,
//     document.body
//   );
// }

// // Contact information is shown in each profile's bottom info bar.
// // Render the popover in a portal so it isn't clipped by the scrolling table.
// const CONTACT_TYPES = {
//   email: {
//     label: "Email",
//     Icon: Mail,
//     // Outlook blue: matching blue border, light-blue background, blue icon.
//     borderColor: "#BBDDF5",
//     colors: "bg-[#EAF4FF] text-[#0078D4] hover:bg-[#DCEEFF]",
//   },
//   phone: {
//     label: "Phone",
//     Icon: Phone,
//     // iPhone call green: matching green border, light-green background.
//     borderColor: "#BCEBC9",
//     colors: "bg-[#EAF9EF] text-[#34C759] hover:bg-[#D8F5E2]",
//   },
//   linkedin: {
//     label: "LinkedIn",
//     Icon: Linkedin,
//     // LinkedIn blue: matching blue border, light-blue background.
//     borderColor: "#BBD8FA",
//     colors: "bg-[#EAF3FE] text-[#0A66C2] hover:bg-[#DAEBFF]",
//   },
// };

// function safeLinkedInUrl(rawValue) {
//   const value = String(rawValue || "").trim();
//   if (!value) return "";

//   try {
//     const url = new URL(
//       /^https?:\/\//i.test(value) ? value : `https://${value}`
//     );
//     const hostname = url.hostname.toLowerCase();
//     // Avoid navigating to arbitrary or dangerous URLs stored in Expert.link.
//     if (hostname !== "linkedin.com" && !hostname.endsWith(".linkedin.com")) {
//       return "";
//     }
//     url.protocol = "https:";
//     return url.href;
//   } catch {
//     return "";
//   }
// }

// function ContactInfoButton({ type, value }) {
//   const { label, Icon, colors, borderColor } = CONTACT_TYPES[type];
//   const [isOpen, setIsOpen] = useState(false);
//   const [copyStatus, setCopyStatus] = useState("");
//   const [position, setPosition] = useState(null);
//   const triggerRef = React.useRef(null);
//   const popoverRef = React.useRef(null);
//   const closeTimerRef = React.useRef(null);

//   const rawValue = String(value || "").trim();
//   const contactValue = type === "linkedin" ? safeLinkedInUrl(rawValue) : rawValue;
//   const isAvailable = Boolean(contactValue);
//   const canEmail = type === "email" && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contactValue);
//   const linkHref = canEmail
//     ? `mailto:${contactValue}`
//     : type === "linkedin" && isAvailable
//       ? contactValue
//       : "";

//   const scheduleClose = () => {
//     window.clearTimeout(closeTimerRef.current);
//     closeTimerRef.current = window.setTimeout(() => {
//       setIsOpen(false);
//       setPosition(null);
//       setCopyStatus("");
//     }, 180);
//   };

//   const showPopover = () => {
//     window.clearTimeout(closeTimerRef.current);
//     setIsOpen(true);
//   };

//   useEffect(() => () => window.clearTimeout(closeTimerRef.current), []);

//   useEffect(() => {
//     if (!isOpen) return;

//     const placePopover = () => {
//       const trigger = triggerRef.current;
//       if (!trigger) return;
//       const rect = trigger.getBoundingClientRect();
//       const popoverWidth = popoverRef.current?.offsetWidth || 280;
//       const popoverHeight = popoverRef.current?.offsetHeight || 92;
//       const margin = 8;
//       const left = Math.max(
//         margin,
//         Math.min(rect.left, window.innerWidth - popoverWidth - margin)
//       );
//       const top = rect.top >= popoverHeight + margin * 2
//         ? rect.top - popoverHeight - margin
//         : rect.bottom + margin;
//       setPosition({ left, top });
//     };

//     placePopover();
//     window.addEventListener("resize", placePopover);
//     // Capture scroll events from the horizontally scrolling project-summary area too.
//     window.addEventListener("scroll", placePopover, true);
//     return () => {
//       window.removeEventListener("resize", placePopover);
//       window.removeEventListener("scroll", placePopover, true);
//     };
//   }, [isOpen, contactValue]);

//   const copyValue = async () => {
//     if (!isAvailable) return;
//     try {
//       if (navigator.clipboard?.writeText) {
//         await navigator.clipboard.writeText(contactValue);
//       } else {
//         // Fallback for local development on non-HTTPS addresses.
//         const textArea = document.createElement("textarea");
//         textArea.value = contactValue;
//         textArea.style.position = "fixed";
//         textArea.style.opacity = "0";
//         document.body.appendChild(textArea);
//         textArea.select();
//         const success = document.execCommand("copy");
//         textArea.remove();
//         if (!success) throw new Error("Copy failed");
//       }
//       setCopyStatus("copied");
//     } catch {
//       setCopyStatus("error");
//     }
//   };

//   const triggerClasses = [
//     // Fixed 20x20 size with zero padding: keeps the Excel-style row compact.
//     // Avoid the generic `border` class: Bootstrap's `.border` may force a gray border with !important.
//     "inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full transition-colors duration-150",
//     isAvailable
//       ? `${colors} focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#365561]`
//       : "cursor-default bg-slate-100 text-slate-400",
//   ].join(" ");

//   const sharedTriggerProps = {
//     ref: triggerRef,
//     className: triggerClasses,
//     // The inline border color is deliberate: it avoids Bootstrap's gray `.border` override
//     // and does not rely on Tailwind discovering dynamic border-color classes.
//     style: { border: `1px solid ${isAvailable ? borderColor : "#E2E8F0"}` },
//     onMouseEnter: showPopover,
//     onMouseLeave: scheduleClose,
//     onFocus: showPopover,
//     onBlur: scheduleClose,
//     "aria-label": isAvailable ? `${label}: ${contactValue}` : `${label} not available`,
//   };

//   return (
//     <>
//       {linkHref ? (
//         <a
//           {...sharedTriggerProps}
//           href={linkHref}
//           target={type === "linkedin" ? "_blank" : undefined}
//           rel={type === "linkedin" ? "noopener noreferrer" : undefined}
//         >
//           <Icon size={12} strokeWidth={2.2} aria-hidden="true" />
//         </a>
//       ) : (
//         <button
//           {...sharedTriggerProps}
//           type="button"
//           onClick={type === "phone" && isAvailable ? copyValue : undefined}
//         >
//           <Icon size={12} strokeWidth={2.2} aria-hidden="true" />
//         </button>
//       )}

//       {isOpen && typeof document !== "undefined" && createPortal(
//         <div
//           ref={popoverRef}
//           role="tooltip"
//           className="fixed z-[10040] w-[280px] max-w-[calc(100vw-16px)] overflow-hidden rounded-2xl border border-slate-200/90 bg-white shadow-[0_20px_50px_rgba(15,23,42,0.16)] backdrop-blur-xl"
//           style={{
//             left: position?.left ?? 8,
//             top: position?.top ?? 0,
//             visibility: position ? "visible" : "hidden",
//           }}
//           onMouseEnter={showPopover}
//           onMouseLeave={scheduleClose}
//           onFocus={showPopover}
//           onBlur={scheduleClose}
//         >
//           {/* Light teal-tinted heading, like the section selection modal. */}
//           <div className="flex items-center gap-2 border-b border-[#365561]/15 bg-[linear-gradient(120deg,rgba(54,85,97,0.14),rgba(54,85,97,0.055))] px-3 py-2 text-[11px] font-bold text-[#365561]">
//             <Icon size={12} strokeWidth={2.2} aria-hidden="true" />
//             <span>{label}</span>
//           </div>
//           {/* Light body matching the navbar and section selection popup. */}
//           <div className="flex items-center gap-2 bg-[linear-gradient(to_bottom,#f8fafc,#eef2f6)] px-3 py-3">
//             <span className="min-w-0 flex-1 break-all text-xs leading-5 text-[#2c4650]">
//               {isAvailable ? contactValue : "Not available"}
//             </span>
//             {isAvailable && (
//               <button
//                 type="button"
//                 onClick={copyValue}
//                 className="inline-flex shrink-0 items-center gap-1 rounded-lg border border-[#365561]/20 bg-white px-2 py-1.5 text-[11px] font-semibold text-[#365561] shadow-sm transition-colors hover:bg-[#365561]/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#365561]"
//                 aria-label={`Copy ${label.toLowerCase()}`}
//               >
//                 {copyStatus === "copied" ? (
//                   <Check size={12} aria-hidden="true" />
//                 ) : (
//                   <Copy size={12} aria-hidden="true" />
//                 )}
//                 {copyStatus === "copied"
//                   ? "Copied"
//                   : copyStatus === "error"
//                     ? "Try again"
//                     : "Copy"}
//               </button>
//             )}
//           </div>
//         </div>,
//         document.body
//       )}
//     </>
//   );
// }

// function SummaryBadge({ icon, label, className = "", isLeftEdge = false, isLastRow = false, isRightEdge = false, logData = [], expert_id, showFeedback, setShowFeedback, }) {
//   const verticalClass = isLastRow
//     ? "bottom-full mb-2"
//     : "top-full mt-2";

//   const horizontalClass = isLeftEdge
//     ? "-left-1 translate-x-0"
//     : isRightEdge
//       ? "right-0 translate-x-0"
//       : "left-1/2 -translate-x-1/2";

//   const arrowVerticalClass = isLastRow
//     ? "top-full -translate-y-1"
//     : "bottom-full translate-y-1";

//   const arrowHorizontalClass = isLeftEdge
//     ? "left-2.5"
//     : isRightEdge
//       ? "right-3"
//       : "left-1/2 -translate-x-1/2";

//   return (
//     <span
//       className={[
//         "group relative inline-flex h-5 items-center gap-1 overflow-visible rounded-full px-1.5 text-[10px] leading-none",
//         className,
//       ].join(" ")}
//       onClick={() => {
//         if (label==='Feedback from client') {
//           setShowFeedback(!showFeedback);
//         }
//       }}
//     >
//       {label==='Client views' ? (
//         <div className="relative flex flex-row items-center justify-end gap-1 text-[#365561] cursor-default">
//           <i className={icon} />
//           <span className="absolute bottom-2 left-4 text-xs">
//             {
//               logData.filter(
//                 (log) =>
//                   log.expert === expert_id &&
//                   log.detail === "Client opened profile"
//               ).length
//             }
//           </span>
//         </div>
//       ) : (<i className={icon} />)}
//       <span 
//         className={[
//           "pointer-events-none absolute z-[70] hidden whitespace-nowrap rounded-xl bg-slate-900 px-2 py-1 text-[10px] font-semibold text-white shadow-lg group-hover:block",
//           verticalClass,
//           horizontalClass,
//         ].join(" ")}
//       >
//         {label}
//         <span 
//           className={[
//             "absolute h-2 w-2 rotate-45 bg-slate-900",
//             arrowVerticalClass,
//             arrowHorizontalClass,
//           ].join(" ")} 
//         />
//       </span>
//     </span>
//   );
// }

// function ClientFeedbackModal({ data, onClose }) {
//   return (
//     <AnimatePresence>
//       <motion.div
//         className="fixed inset-0 z-[150] flex items-center justify-center bg-black/45 px-4 py-6 backdrop-blur-sm"
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         exit={{ opacity: 0 }}
//         onClick={onClose}
//       >
//         <motion.div
//           initial={{ y: 18, opacity: 0, scale: 0.98 }}
//           animate={{ y: 0, opacity: 1, scale: 1 }}
//           exit={{ y: 18, opacity: 0, scale: 0.98 }}
//           transition={{ type: "spring", stiffness: 320, damping: 28 }}
//           className="relative flex max-h-[88vh] w-full max-w-xl flex-col overflow-hidden rounded-3xl bg-[radial-gradient(circle_at_top,rgba(251,146,60,0.16),transparent_36%),linear-gradient(to_bottom,#ffffff,#f8fafc)] shadow-[0_24px_80px_rgba(15,23,42,0.32)]"
//           onClick={(event) => event.stopPropagation()}
//         >
//           <div className="shrink-0 border-b border-slate-200/80 px-5 py-4">
//             <div className="flex items-start justify-between gap-4">
//               <div className="flex min-w-0 items-start gap-3">
//                 <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-orange-50 text-orange-600 shadow-sm">
//                   <i className="fa-regular fa-message" />
//                 </span>
//                 <div className="min-w-0">
//                   <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#365561]">
//                     Client feedback
//                   </p>
//                   <h2 className="mt-1 truncate text-xl font-semibold text-slate-900">
//                     {data?.expertName}
//                   </h2>
//                   <p className="mt-1 text-sm text-slate-500">
//                     Feedback submitted by the client for this declined profile.
//                   </p>
//                 </div>
//               </div>

//               <button
//                 type="button"
//                 className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-500 shadow-sm transition hover:bg-slate-50 hover:text-red-500 focus:outline-none"
//                 onClick={onClose}
//                 aria-label="Close feedback"
//               >
//                 <i className="fa-solid fa-xmark" />
//               </button>
//             </div>
//           </div>

//           <div className="min-h-0 flex-1 space-y-3 overflow-y-auto px-5 py-4">
//             <div className="rounded-3xl border border-slate-200 bg-white/85 p-4 shadow-sm">
//               <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-slate-400">
//                 Reason
//               </p>
//               <p className="mt-2 text-sm leading-6 text-slate-700">
//                 {data?.reason || "No reason provided"}
//               </p>
//             </div>
//             <div className="rounded-3xl border border-slate-200 bg-white/85 p-4 shadow-sm">
//               <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-slate-400">
//                 Feedback
//               </p>
//               <p className="mt-2 text-sm leading-6 text-slate-700">
//                 {data?.feedbackToManager || "No feedback provided"}
//               </p>
//             </div>
//           </div>

//           <div className="shrink-0 rounded-b-3xl border-t border-slate-200 bg-white/80 px-5 py-3 backdrop-blur-xl">
//             <div className="flex justify-end">
//               <button
//                 type="button"
//                 className="rounded-2xl border border-slate-200 bg-white px-4 py-2 text-xs font-semibold text-slate-600 transition hover:bg-slate-50 sm:text-sm"
//                 onClick={onClose}
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </motion.div>
//       </motion.div>
//     </AnimatePresence>
//   );
// }

// function getEventDate(event, point = "start") {
//   const directValue = event?.[`${point}Time`] ?? event?.[point];

//   if (directValue?.toDate && typeof directValue.toDate === "function") {
//     return directValue.toDate();
//   }

//   if (directValue?.value) {
//     return new Date(directValue.value);
//   }

//   if (directValue) {
//     return new Date(directValue);
//   }

//   if (event?.date && event?.[point] !== undefined) {
//     const hourValue = Number(event[point]);
//     const hour = Math.floor(hourValue);
//     const minute = Math.round((hourValue - hour) * 60);
//     return new Date(
//       `${event.date}T${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}:00`
//     );
//   }

//   return null;
// }

// function getEventKey(event, index) {
//   return event?.id || event?.eventID || `${event?.startTime || event?.start}-${event?.endTime || event?.end}-${index}`;
// }

// function getFutureSortedSlots(slotList = [], expertID = null) {
//   const now = new Date();

//   return (slotList || [])
//     .filter((event) => (expertID ? eventBelongsToExpert(event, expertID) : true))
//     .filter((event) => {
//       const startDate = getEventDate(event, "start");
//       return startDate && !Number.isNaN(startDate.getTime()) && startDate >= now;
//     })
//     .slice()
//     .sort((a, b) => getEventDate(a, "start") - getEventDate(b, "start"));
// }

// function eventToDisplayParts(event) {
//   const startDate = getEventDate(event, "start") || new Date();
//   const endDate = getEventDate(event, "end") || startDate;

//   return {
//     weekday: new Intl.DateTimeFormat("en-GB", { weekday: "short" }).format(startDate),
//     weekdayLong: new Intl.DateTimeFormat("en-GB", { weekday: "long" }).format(startDate),
//     day: new Intl.DateTimeFormat("en-GB", { day: "2-digit" }).format(startDate),
//     month: new Intl.DateTimeFormat("en-GB", { month: "short" }).format(startDate),
//     monthLong: new Intl.DateTimeFormat("en-GB", { month: "long" }).format(startDate),
//     year: new Intl.DateTimeFormat("en-GB", { year: "numeric" }).format(startDate),
//     yearShort: new Intl.DateTimeFormat("en-GB", { year: "2-digit" }).format(startDate),
//     startTime: new Intl.DateTimeFormat("en-GB", {
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: false,
//     }).format(startDate),
//     endTime: new Intl.DateTimeFormat("en-GB", {
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: false,
//     }).format(endDate),
//     timezone: event?.timezone || event?.timeZone || "Europe/Berlin",
//   };
// }

// function eventToString(event) {
//   const slot = eventToDisplayParts(event);
//   return `${slot.weekdayLong}, ${slot.day} ${slot.monthLong} ${slot.year}, ${slot.startTime} – ${slot.endTime} (${slot.timezone})`;
// }

// function isRequestedCallSlot(event) {
//   const directFlags = [
//     event?.isRequested,
//     event?.requested,
//     event?.isCallRequested,
//     event?.callRequested,
//     event?.appointmentRequested,
//     event?.requestCall,
//     event?.clientRequested,
//     event?.requestedByClient,
//   ];

//   if (directFlags.some((value) => value === true || value === "true" || value === "yes" || value === 1)) {
//     return true;
//   }

//   const statusText = String(
//     event?.status || event?.requestStatus || event?.appointmentStatus || event?.callStatus || ""
//   ).toLowerCase();

//   return statusText.includes("requested") || statusText.includes("pending");
// }

// function eventBelongsToExpert(event, expertID) {
//   const eventExpertID = event?.expertID ?? event?.expertId ?? event?.expert_id ?? event?.consultantID ?? event?.consultantId;

//   if (eventExpertID === undefined || eventExpertID === null || eventExpertID === "") {
//     return true;
//   }

//   return String(eventExpertID) === String(expertID);
// }

// function AvailabilitySlotCard({ event, selected = false, requested = false, onClick, disabled = false }) {
//   const slot = eventToDisplayParts(event);
//   const isClickable = Boolean(onClick) && !disabled;

//   return (
//     <button
//       type="button"
//       onClick={isClickable ? () => onClick(event) : undefined}
//       disabled={!isClickable}
//       className={[
//         "availability-card relative h-[82px] w-[85px] min-w-[85px] max-w-[85px] overflow-hidden rounded-xl border bg-[#365561]/5 text-left shadow-sm transition-all duration-150 focus:outline-none",
//         isClickable ? "cursor-pointer hover:-translate-y-0.5 hover:shadow-md" : "cursor-default",
//         selected ? "border-[#365561] ring-2 ring-[#365561]/30" : "border-[#365561]/20",
//         requested ? "opacity-90" : "",
//       ].join(" ")}
//       aria-pressed={selected}
//     >
//       <div className="availability-card-top bg-[#365561] px-1 py-1 text-center text-[10px] font-semibold uppercase tracking-wide text-white">
//         {slot.month} {slot.yearShort}
//       </div>

//       <div className="availability-card-body px-2 py-1 text-center">
//         <div className="availability-day text-base font-bold leading-none text-[#365561]">
//           {slot.day}
//         </div>
//         <div className="availability-weekday mt-0.5 text-[10px] font-semibold text-gray-700">
//           {slot.weekday}
//         </div>
//         <div className="availability-time mt-0.5 truncate text-[10px] text-gray-500">
//           {slot.startTime} - {slot.endTime}
//         </div>
//       </div>

//       {selected && (
//         <div className="slot-selected-overlay no-print absolute inset-0 z-[5] flex items-center justify-center bg-[#365561]/20 pointer-events-none">
//           <div className="slot-selected-check flex h-7 w-7 items-center justify-center rounded-full bg-[#365561] text-lg font-extrabold leading-none text-white shadow-md">
//             ✓
//           </div>
//         </div>
//       )}

//       {requested && (
//         <div className="slot-selected-overlay no-print absolute inset-0 z-[5] flex items-center justify-center bg-[#365561]/20 pointer-events-none">
//           <div className="whitespace-nowrap -rotate-45 text-xs font-semibold text-white/80">
//             Call Requested
//           </div>
//         </div>
//       )}
//     </button>
//   );
// }

// function AvailabilitySlotRow({ title, subtitle, slots = [], emptyText, onSlotClick, markRequested = false }) {
//   return (
//     <section className="rounded-3xl border border-slate-200 bg-white/80 p-4 shadow-sm">
//       <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
//         <div>
//           <p className="text-sm font-bold text-slate-800">{title}</p>
//           {subtitle && <p className="mt-0.5 text-xs text-slate-500">{subtitle}</p>}
//         </div>
//         <span className="rounded-full bg-slate-100 px-2.5 py-1 text-xs font-semibold text-slate-500">
//           {slots.length} future slot{slots.length === 1 ? "" : "s"}
//         </span>
//       </div>

//       {slots.length > 0 ? (
//         <div className="availability-grid grid w-full grid-cols-[repeat(auto-fill,85px)] gap-1.5 bg-white">
//           {slots.map((event, index) => (
//             <AvailabilitySlotCard
//               key={getEventKey(event, index)}
//               event={event}
//               requested={markRequested && isRequestedCallSlot(event)}
//               // disabled={markRequested && isRequestedCallSlot(event)}
//               onClick={onSlotClick}
//             />
//           ))}
//         </div>
//       ) : (
//         <div className="flex min-h-[96px] items-center justify-center rounded-2xl border border-dashed border-slate-200 bg-slate-50/80 px-4 text-center text-xs font-medium text-slate-400">
//           {emptyText}
//         </div>
//       )}
//     </section>
//   );
// }

// function RequestCallModal({
//   data,
//   clientEvents = [],
//   expertEvents = [],
//   expertID,
//   mediaLink,
//   databaseLink,
//   onClose,
//   onOpenEmail,
//   onSlotClick,
// }) {
//   const futureExpertEvents = getFutureSortedSlots(expertEvents, expertID);
//   const futureClientEvents = getFutureSortedSlots(clientEvents);
//   const requestedCount = futureExpertEvents.filter(isRequestedCallSlot).length;

//   const profileImage = data?.profilePicture?.includes(mediaLink)
//     ? data?.profilePicture
//     : data?.profilePicture
//       ? `${databaseLink}${data?.profilePicture}`
//       : expertDefaultImg;

//   return (
//     <AnimatePresence>
//       <motion.div
//         className="fixed inset-0 z-[70] flex items-center justify-center bg-black/45 px-4 py-6 backdrop-blur-sm"
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         exit={{ opacity: 0 }}
//         onClick={onClose}
//       >
//         <motion.div
//           initial={{ y: 18, opacity: 0, scale: 0.98 }}
//           animate={{ y: 0, opacity: 1, scale: 1 }}
//           exit={{ y: 18, opacity: 0, scale: 0.98 }}
//           transition={{ type: "spring", stiffness: 320, damping: 28 }}
//           className="relative flex h-[calc(100vh-100px)] top-[35px] sm:h-[calc(88vh-100px)] w-full max-w-4xl flex-col overflow-hidden rounded-3xl bg-[radial-gradient(circle_at_top,rgba(54,85,97,0.16),transparent_35%),linear-gradient(to_bottom,#f8fafc,#eef2f6)] shadow-[0_24px_80px_rgba(15,23,42,0.32)]"
//           onClick={(event) => event.stopPropagation()}
//         >
//           <div className="shrink-0 border-b border-slate-200/80 px-5 py-4">
//             <div className="flex items-start justify-between gap-4">
//               <div className="flex min-w-0 items-start gap-3">
//                 <img
//                   src={profileImage}
//                   onError={(event) => (event.currentTarget.src = expertDefaultImg)}
//                   className="h-11 w-11 shrink-0 rounded-2xl border border-white object-cover shadow-sm"
//                   alt="Profile"
//                 />
//                 <div className="min-w-0">
//                   <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#365561]">
//                     Client call request
//                   </p>
//                   <h2 className="mt-1 truncate text-xl font-semibold text-slate-900">
//                     {data.expertName}
//                   </h2>
//                   <p className="mt-1 text-sm text-slate-500">
//                     Review consultant and client availability. Expert slots use the same request state as the profile view.
//                   </p>
//                 </div>
//               </div>

//               <div className="flex shrink-0 items-center gap-2">
//                 <button
//                   type="button"
//                   className="group relative inline-flex h-9 w-9 items-center justify-center overflow-visible rounded-2xl border border-slate-200 bg-white text-slate-500 shadow-sm transition hover:bg-slate-50 hover:text-[#365561] focus:outline-none"
//                   onClick={onOpenEmail}
//                   aria-label="Send email"
//                 >
//                   <i className="fa-regular fa-envelope" />
//                   <ToggleTooltip label="Send email with available slots" isRightEdge />
//                 </button>
//                 <button
//                   type="button"
//                   className="inline-flex h-9 w-9 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-500 shadow-sm transition hover:bg-slate-50 hover:text-red-500 focus:outline-none"
//                   onClick={onClose}
//                   aria-label="Close"
//                 >
//                   <i className="fa-solid fa-xmark" />
//                 </button>
//               </div>
//             </div>

//             <div className="mt-4 flex flex-wrap items-center gap-2 text-xs font-semibold">
//               <span className="rounded-full bg-white px-3 py-1.5 text-slate-600 shadow-sm">
//                 {futureExpertEvents.length} expert slot{futureExpertEvents.length === 1 ? "" : "s"}
//               </span>
//               <span className="rounded-full bg-white px-3 py-1.5 text-slate-600 shadow-sm">
//                 {futureClientEvents.length} client slot{futureClientEvents.length === 1 ? "" : "s"}
//               </span>
//               {requestedCount > 0 && (
//                 <span className="rounded-full bg-[#365561] px-3 py-1.5 text-white shadow-sm">
//                   {requestedCount} requested
//                 </span>
//               )}
//             </div>
//           </div>

//           <div className="min-h-0 flex-1 space-y-4 overflow-y-auto px-5 py-4">
//             <AvailabilitySlotRow
//               title="Expert availability"
//               subtitle="Future consultant timeslots. Marked slots are selected by client for calls."
//               slots={futureExpertEvents}
//               emptyText="There are no future expert availability slots for this profile."
//               onSlotClick={onSlotClick}
//               markRequested
//             />

//             <AvailabilitySlotRow
//               title="Client availability"
//               subtitle="Future client availability slots saved for this project."
//               slots={futureClientEvents}
//               emptyText="There are no future client availability slots for this project."
//               onSlotClick={onSlotClick}
//             />
//           </div>

//           <div className="shrink-0 rounded-b-3xl border-t border-slate-200 bg-white/80 px-5 py-3 backdrop-blur-xl">
//             <div className="flex flex-col-reverse gap-2 sm:flex-row sm:items-center sm:justify-between">
//               <p className="text-xs text-slate-500">
//                 Clicking a future slot opens the calendar request flow with that time selected.
//               </p>
//               <button
//                 type="button"
//                 className="rounded-2xl border border-slate-200 bg-white px-4 py-2 text-xs font-semibold text-slate-600 transition hover:bg-slate-50 sm:text-sm"
//                 onClick={onClose}
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </motion.div>
//       </motion.div>
//     </AnimatePresence>
//   );
// }

// function ExpertRow({
//   data,
//   index,
//   proj_id,
//   project,
//   expert_id,
//   appendExpertId,
//   removeExpertId,
//   backupData,
//   setBackupData,
//   events,
//   logData,
//   selectedExpertIds = []
// }) {
//   const { API_URL } = useContext(UrlContext);
//   const mediaLink = "https://media.licdn.com/";
//   const databaseLink = "https://images.expertpowerhouse.com";
//   const [openCall, setOpenCall] = useState(false);
//   const [appointmentExist, setAppointmentExist] = useState(null);

//   const isLastRow = index === backupData.length - 1;


//   const [exDigitalID, setExDigitalID] = useState("");
//   const [, setExDigitalIDreturnSuccess] = useState(false);
//   const [, setExDigitalIDreturnError] = useState(false);
//   const [, setExDigitalIDloading] = useState(false);

//   const [exRating1, setExRating1] = useState("");
//   const [, setExRating1returnSuccess] = useState(false);
//   const [, setExRating1returnError] = useState(false);
//   const [, setExRating1loading] = useState(false);

//   const [exRating2, setExRating2] = useState("");
//   const [, setExRating2returnSuccess] = useState(false);
//   const [, setExRating2returnError] = useState(false);
//   const [, setExRating2loading] = useState(false);

//   const [exRating3, setExRating3] = useState("");
//   const [, setExRating3returnSuccess] = useState(false);
//   const [, setExRating3returnError] = useState(false);
//   const [, setExRating3loading] = useState(false);

//   const [exRating4, setExRating4] = useState("");
//   const [, setExRating4returnSuccess] = useState(false);
//   const [, setExRating4returnError] = useState(false);
//   const [, setExRating4loading] = useState(false);

//   const [exRating5, setExRating5] = useState("");
//   const [, setExRating5returnSuccess] = useState(false);
//   const [, setExRating5returnError] = useState(false);
//   const [, setExRating5loading] = useState(false);

//   const [conCurrency, setConCurrency] = useState("");
//   const [exDailyRateToEPH, setExDailyRateToEPH] = useState("");
//   const [conBillingFrequency, setConBillingFrequency] = useState("");
//   const [, setExDailyRateToEPHreturnSuccess] = useState(false);
//   const [, setExDailyRateToEPHreturnError] = useState(false);
//   const [, setExDailyRateToEPHloading] = useState(false);

//   const [exAvailableComment, setExAvailableComment] = useState("");
//   const [, setExAvailableCommentreturnSuccess] = useState(false);
//   const [, setExAvailableCommentreturnError] = useState(false);
//   const [, setExAvailableCommentloading] = useState(false);

//   const [exCurrency, setExCurrency] = useState("");
//   const [exDailyRate, setExDailyRate] = useState("");
//   const [exBillingFrequency, setExBillingFrequency] = useState("");
//   const [, setExCurrencyreturnSuccess] = useState(false);
//   const [, setExCurrencyreturnError] = useState(false);
//   const [, setExCurrencyloading] = useState(false);

//   const [exFootNote, setExFootNote] = useState("");
//   const [, setExFootNoteReturnSuccess] = useState(false);
//   const [, setExFootNoteReturnError] = useState(false);
//   const [, setExFootNoteLoading] = useState(false);

//   const [exRatingPercentage, setExRatingPercentage] = useState(null);
//   const [hideDeletedRow, setHideDeletedRow] = useState(false);

//   const [isOpen, setIsOpen] = useState(false);
//   const toggleModal = () => setIsOpen(!isOpen);
//   const [sortedEvents, setSortedEvents] = useState([]);
//   const [openEmail, setOpenEmail] = useState(false);
//   const [meetingStart, setMeetingStart] = useState(null);
//   const [meetingEnd, setMeetingEnd] = useState(null);
//   const [isSlotSelected, setIsSlotSelected] = useState(false);
//   const [expertEmail, setExpertEmail] = useState("");
//   const [user, setUser] = useState(null);
//   const [isEditingConRate, setIsEditingConRate] = useState(false);
//   const [isEditingClientRate, setIsEditingClientRate] = useState(false);
//   const [defaultTemp, setDefaultTemp] = useState([]);
//   const [showFeedback, setShowFeedback] = useState(false);
//   const [expertEvents, setExpertEvents] = useState([]);

//   useEffect(() => {
//     setExDigitalID(data.expertDigitalID);
//     setExRating1(data.rating1);
//     setExRating2(data.rating2);
//     setExRating3(data.rating3);
//     setExRating4(data.rating4);
//     setExRating5(data.rating5);
//     setExDailyRateToEPH(data.dailyRateToEPH);
//     setExAvailableComment(data.Available_comment);
//     setExCurrency(data.projectCurrency);
//     setExDailyRate(data.daily_rate);
//     setExBillingFrequency(data.billingFrequency);
//     setExFootNote(data.footNote);
//     setExRatingPercentage(data.ratingPercentage);
//     setAppointmentExist(data.eventExist);
//     setConCurrency(data.conCurrency);
//     setConBillingFrequency(data.conBillingFrequency);
//     getEmailDetails();
//   }, [data]);

//   useEffect(() => {
//     const rating1 = parseInt(exRating1);
//     const rating2 = parseInt(exRating2);
//     const rating3 = parseInt(exRating3);
//     const rating4 = parseInt(exRating4);
//     const rating5 = parseInt(exRating5);
//     const ratingPercentage =
//       (rating1 + rating2 + rating3 + rating4 + rating5) * 4 + "%";
//     setExRatingPercentage(ratingPercentage);
//   }, [exRating1, exRating2, exRating3, exRating4, exRating5]);

//   const getExpertAvailabilitySlot = async () => {
//     const requestBody = {
//       expertID: data.expertID,
//       projectID: proj_id,
//     };
//     try {
//       let modifiedUrl = "get-expert-meeting-time-slot";
//       const response = await fetch(`${API_URL}${modifiedUrl}`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(requestBody),
//       });
//       const responseData = await response.json();
//       if (responseData.status === "success") {
//         setExpertEvents(responseData.eventData);
//       } else {
//         console.error("Failed to add selected slot");
//       }
//     } catch (error) {
//       console.error("Error while calling the backend API:", error);
//     }
//   };

//   useEffect(() => {
//     getExpertAvailabilitySlot();
//   }, []);

//   useEffect(() => {
//     const sorted = [...events].sort(
//       (a, b) => new Date(a.startTime) - new Date(b.startTime)
//     );
//     setSortedEvents(sorted);
//   }, [events]);

//   useEffect(() => {
//     if (user && events.length > 0) {
//       const templates = getDefaultTemplate(events);
//       setDefaultTemp(templates);
//     }
//   }, [user, expertEmail, events]);

//   const saveExDigitalID = () => {
//     setExDigitalIDreturnError(false);
//     setExDigitalIDloading(true);
//     const url = `${API_URL}save-ex-digital-id/` + proj_id + "/" + data.expertID;

//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ exDigitalID }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setExDigitalIDloading(false);
//         if (data.status === "success") {
//           setExDigitalIDreturnSuccess(true);
//           setTimeout(() => {
//             setExDigitalIDreturnSuccess(false);
//           }, 1500);
//           setBackupData(
//             backupData.map((item) => {
//               if (item.expertID === expert_id) {
//                 item.expertDigitalID = exDigitalID;
//               }
//               return item;
//             })
//           );
//         } else {
//           setExDigitalIDreturnError(true);
//         }
//       })
//       .catch(() => {
//         setExDigitalIDloading(false);
//         setExDigitalIDreturnError(true);
//       });
//   };

//   const saveExRating1 = () => {
//     setExRating1returnError(false);
//     setExRating1loading(true);
//     const url = `${API_URL}save-ex-rating1/` + proj_id + "/" + data.expertID;
//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ exRating1 }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setExRating1loading(false);
//         if (data.status === "success") {
//           setExRating1returnSuccess(true);
//           setTimeout(() => {
//             setExRating1returnSuccess(false);
//           }, 1500);
//           setBackupData(
//             backupData.map((item) => {
//               if (item.expertID === expert_id) {
//                 item.rating1 = exRating1;
//               }
//               return item;
//             })
//           );
//         } else {
//           setExRating1returnError(true);
//         }
//       })
//       .catch(() => {
//         setExRating1loading(false);
//         setExRating1returnError(true);
//       });
//   };

//   const saveExRating2 = () => {
//     setExRating2returnError(false);
//     setExRating2loading(true);
//     const url = `${API_URL}save-ex-rating2/` + proj_id + "/" + data.expertID;
//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ exRating2 }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setExRating2loading(false);
//         if (data.status === "success") {
//           setExRating2returnSuccess(true);
//           setTimeout(() => {
//             setExRating2returnSuccess(false);
//           }, 1500);
//           setBackupData(
//             backupData.map((item) => {
//               if (item.expertID === expert_id) {
//                 item.rating2 = exRating2;
//               }
//               return item;
//             })
//           );
//         } else {
//           setExRating2returnError(true);
//         }
//       })
//       .catch(() => {
//         setExRating2loading(false);
//         setExRating2returnError(true);
//       });
//   };

//   const saveExRating3 = () => {
//     setExRating3returnError(false);
//     setExRating3loading(true);
//     const url = `${API_URL}save-ex-rating3/` + proj_id + "/" + data.expertID;
//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ exRating3 }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setExRating3loading(false);
//         if (data.status === "success") {
//           setExRating3returnSuccess(true);
//           setTimeout(() => {
//             setExRating3returnSuccess(false);
//           }, 1500);
//           setBackupData(
//             backupData.map((item) => {
//               if (item.expertID === expert_id) {
//                 item.rating3 = exRating3;
//               }
//               return item;
//             })
//           );
//         } else {
//           setExRating3returnError(true);
//         }
//       })
//       .catch(() => {
//         setExRating3loading(false);
//         setExRating3returnError(true);
//       });
//   };

//   const saveExRating4 = () => {
//     setExRating4returnError(false);
//     setExRating4loading(true);
//     const url = `${API_URL}save-ex-rating4/` + proj_id + "/" + data.expertID;
//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ exRating4 }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setExRating4loading(false);
//         if (data.status === "success") {
//           setExRating4returnSuccess(true);
//           setTimeout(() => {
//             setExRating4returnSuccess(false);
//           }, 1500);
//           setBackupData(
//             backupData.map((item) => {
//               if (item.expertID === expert_id) {
//                 item.rating4 = exRating4;
//               }
//               return item;
//             })
//           );
//         } else {
//           setExRating4returnError(true);
//         }
//       })
//       .catch(() => {
//         setExRating4loading(false);
//         setExRating4returnError(true);
//       });
//   };

//   const saveExRating5 = () => {
//     setExRating5returnError(false);
//     setExRating5loading(true);
//     const url = `${API_URL}save-ex-rating5/` + proj_id + "/" + data.expertID;
//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ exRating5 }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setExRating5loading(false);
//         if (data.status === "success") {
//           setExRating5returnSuccess(true);
//           setTimeout(() => {
//             setExRating5returnSuccess(false);
//           }, 1500);
//           setBackupData(
//             backupData.map((item) => {
//               if (item.expertID === expert_id) {
//                 item.rating5 = exRating5;
//               }
//               return item;
//             })
//           );
//         } else {
//           setExRating5returnError(true);
//         }
//       })
//       .catch(() => {
//         setExRating5loading(false);
//         setExRating5returnError(true);
//       });
//   };

//   const saveExDailyRateToEPH = () => {
//     setExDailyRateToEPHreturnError(false);
//     setExDailyRateToEPHloading(true);
//     const url =
//       `${API_URL}save-ex-daily-rate-to-eph/` + proj_id + "/" + data.expertID;
//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ exDailyRateToEPH }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setExDailyRateToEPHloading(false);
//         if (data.status === "success") {
//           setExDailyRateToEPHreturnSuccess(true);
//           setTimeout(() => {
//             setExDailyRateToEPHreturnSuccess(false);
//           }, 1500);
//           setBackupData(
//             backupData.map((item) => {
//               if (item.expertID === expert_id) {
//                 item.dailyRateToEPH = exDailyRateToEPH;
//               }
//               return item;
//             })
//           );
//         } else {
//           setExDailyRateToEPHreturnError(true);
//         }
//       })
//       .catch(() => {
//         setExDailyRateToEPHloading(false);
//         setExDailyRateToEPHreturnError(true);
//       });
//   };

//   const saveConCurrency = (value) => {
//     setExDailyRateToEPHreturnError(false);
//     setExDailyRateToEPHloading(true);
//     const url =
//       `${API_URL}save-consultant-currency/` + proj_id + "/" + data.expertID;
//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ conCurrency: value }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setExDailyRateToEPHloading(false);
//         if (data.status === "success") {
//           setExDailyRateToEPHreturnSuccess(true);
//           setTimeout(() => {
//             setExDailyRateToEPHreturnSuccess(false);
//           }, 1500);
//           setBackupData(
//             backupData.map((item) => {
//               if (item.expertID === expert_id) {
//                 item.conCurrency = value;
//               }
//               return item;
//             })
//           );
//         } else {
//           setExDailyRateToEPHreturnError(true);
//         }
//       })
//       .catch(() => {
//         setExDailyRateToEPHloading(false);
//         setExDailyRateToEPHreturnError(true);
//       });
//   };

//   const saveConBillingFrequency = (value) => {
//     setExDailyRateToEPHreturnError(false);
//     setExDailyRateToEPHloading(true);
//     const url =
//       `${API_URL}save-consultant-billing-frequency/` +
//       proj_id +
//       "/" +
//       data.expertID;
//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ conBillingFrequency: value }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setExDailyRateToEPHloading(false);
//         if (data.status === "success") {
//           setExDailyRateToEPHreturnSuccess(true);
//           setTimeout(() => {
//             setExDailyRateToEPHreturnSuccess(false);
//           }, 1500);
//           setBackupData(
//             backupData.map((item) => {
//               if (item.expertID === expert_id) {
//                 item.conCurrency = value;
//               }
//               return item;
//             })
//           );
//         } else {
//           setExDailyRateToEPHreturnError(true);
//         }
//       })
//       .catch(() => {
//         setExDailyRateToEPHloading(false);
//         setExDailyRateToEPHreturnError(true);
//       });
//   };

//   const saveExAvailableComment = () => {
//     setExAvailableCommentreturnError(false);
//     setExAvailableCommentloading(true);
//     const url =
//       `${API_URL}save-ex-available-comment/` + proj_id + "/" + data.expertID;
//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ exAvailableComment }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setExAvailableCommentloading(false);
//         if (data.status === "success") {
//           setExAvailableCommentreturnSuccess(true);
//           setTimeout(() => {
//             setExAvailableCommentreturnSuccess(false);
//           }, 1500);
//           setBackupData(
//             backupData.map((item) => {
//               if (item.expertID === expert_id) {
//                 item.Available_comment = exAvailableComment;
//               }
//               return item;
//             })
//           );
//         } else {
//           setExAvailableCommentreturnError(true);
//         }
//       })
//       .catch(() => {
//         setExAvailableCommentloading(false);
//         setExAvailableCommentreturnError(true);
//       });
//   };

//   const saveExCurrency = (exCurrency) => {
//     setExCurrencyreturnError(false);
//     setExCurrencyloading(true);
//     const url = `${API_URL}save-ex-currency/` + proj_id + "/" + data.expertID;
//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ exCurrency }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setExCurrencyloading(false);
//         if (data.status === "success") {
//           setExCurrencyreturnSuccess(true);
//           setTimeout(() => {
//             setExCurrencyreturnSuccess(false);
//           }, 1500);
//           setBackupData(
//             backupData.map((item) => {
//               if (item.expertID === expert_id) {
//                 item.projectCurrency = exCurrency;
//               }
//               return item;
//             })
//           );
//         } else {
//           setExCurrencyreturnError(true);
//         }
//       })
//       .catch(() => {
//         setExCurrencyloading(false);
//         setExCurrencyreturnError(true);
//       });
//   };

//   const saveExDailyRate = () => {
//     setExCurrencyreturnError(false);
//     setExCurrencyloading(true);
//     const url = `${API_URL}save-ex-daily-rate/` + proj_id + "/" + data.expertID;
//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ exDailyRate }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setExCurrencyloading(false);
//         if (data.status === "success") {
//           setExCurrencyreturnSuccess(true);
//           setTimeout(() => {
//             setExCurrencyreturnSuccess(false);
//           }, 1500);
//           setBackupData(
//             backupData.map((item) => {
//               if (item.expertID === expert_id) {
//                 item.daily_rate = exDailyRate;
//               }
//               return item;
//             })
//           );
//         } else {
//           setExCurrencyreturnError(true);
//         }
//       })
//       .catch(() => {
//         setExCurrencyloading(false);
//         setExCurrencyreturnError(true);
//       });
//   };

//   const saveExBillingFrequency = (exBillingFrequency) => {
//     setExCurrencyreturnError(false);
//     setExCurrencyloading(true);
//     const url =
//       `${API_URL}save-ex-billing-frequency/` + proj_id + "/" + data.expertID;
//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ exBillingFrequency }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setExCurrencyloading(false);
//         if (data.status === "success") {
//           setExCurrencyreturnSuccess(true);
//           setTimeout(() => {
//             setExCurrencyreturnSuccess(false);
//           }, 1500);
//           setBackupData(
//             backupData.map((item) => {
//               if (item.expertID === expert_id) {
//                 item.billingFrequency = exBillingFrequency;
//               }
//               return item;
//             })
//           );
//         } else {
//           setExCurrencyreturnError(true);
//         }
//       })
//       .catch(() => {
//         setExCurrencyloading(false);
//         setExCurrencyreturnError(true);
//       });
//   };

//   const saveExFootNote = (exFootNote) => {
//     setExFootNoteReturnError(false);
//     setExFootNoteLoading(true);
//     const url = `${API_URL}save-ex-foot-note/` + proj_id + "/" + data.expertID;
//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ exFootNote }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setExFootNoteLoading(false);
//         if (data.status === "success") {
//           setExFootNoteReturnSuccess(true);
//           setTimeout(() => {
//             setExFootNoteReturnSuccess(false);
//           }, 1500);
//           setBackupData(
//             backupData.map((item) => {
//               if (item.expertID === expert_id) {
//                 item.footNote = exFootNote;
//               }
//               return item;
//             })
//           );
//         } else {
//           setExFootNoteReturnError(true);
//         }
//       })
//       .catch(() => {
//         setExFootNoteLoading(false);
//         setExFootNoteReturnError(true);
//       });
//   };

//   const handleProfileDelete = async () => {
//     const result = await Swal.fire({
//       icon: "warning",
//       title: "Remove profile?",
//       html: "<p>This profile will be removed from the project summary.</p><p class='mt-1 text-sm text-slate-500'>This action cannot be undone from this page.</p>",
//       showCancelButton: true,
//       confirmButtonText: "Remove",
//       cancelButtonText: "Cancel",
//       confirmButtonColor: "#dc2626",
//       cancelButtonColor: "#64748b",
//       reverseButtons: true,
//       focusCancel: true,
//     });

//     if (!result.isConfirmed) return;

//     Swal.fire({
//       title: "Removing profile...",
//       text: "Please wait while the profile is removed.",
//       allowOutsideClick: false,
//       allowEscapeKey: false,
//       didOpen: () => Swal.showLoading(),
//     });

//     const url =
//       `${API_URL}prjsumm-delete-profile/` + proj_id + "/" + data.expertID;

//     try {
//       const response = await fetch(url, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//       });
//       const responseData = await response.json();

//       if (responseData.status === "success") {
//         setHideDeletedRow(true);
//         Swal.fire({
//           icon: "success",
//           title: "Profile removed",
//           text: "Profile has been removed successfully.",
//           showConfirmButton: false,
//           timer: 1500,
//         });
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Could not remove profile",
//           text: responseData.text || "Something went wrong!",
//         });
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Could not remove profile",
//         text: "Something went wrong!",
//       });
//     }
//   };

//   if (hideDeletedRow) {
//     return null;
//   }

//   const eventToString = (selectedEvent) => {
//     const date = new Date(selectedEvent.startTime);
//     const endDate = new Date(selectedEvent.endTime);

//     return {
//       weekday: new Intl.DateTimeFormat("en-GB", { weekday: "long" }).format(
//         date
//       ),
//       day: new Intl.DateTimeFormat("en-GB", { day: "2-digit" }).format(date),
//       month: new Intl.DateTimeFormat("en-GB", { month: "long" }).format(date),
//       year: new Intl.DateTimeFormat("en-GB", { year: "numeric" }).format(date),
//       startTime: new Intl.DateTimeFormat("en-GB", {
//         hour: "2-digit",
//         minute: "2-digit",
//         hour12: false,
//       }).format(date),
//       endTime: new Intl.DateTimeFormat("en-GB", {
//         hour: "2-digit",
//         minute: "2-digit",
//         hour12: false,
//       }).format(endDate),
//       timezone: selectedEvent.timezone,
//     };
//   };

//   // const convertToEventSlot = (selectedEvent) => {
//   //   const startDate = new Date(selectedEvent.startTime);
//   //   const endDate = new Date(selectedEvent.endTime);

//   //   const formatDateTime = (date) => {
//   //     const pad = (n) => String(n).padStart(2, '0');
//   //     return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
//   //   };

//   //   return {
//   //     startDateTime: formatDateTime(startDate),
//   //     endDateTime: formatDateTime(endDate),
//   //   };
//   // };

//   const convertToEventSlot = (selectedEvent) => {
//     const startDate = new Date(selectedEvent.startTime);
//     const endDate = new Date(selectedEvent.endTime);

//     const formatDateTime = (date) => {
//       const pad = (n) => String(n).padStart(2, "0");
//       return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
//         date.getDate()
//       )}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
//         date.getSeconds()
//       )}`;
//     };

//     return {
//       startDateTime: formatDateTime(startDate),
//       endDateTime: formatDateTime(endDate),
//     };
//   };

//   const handleCalendarOpen = (selectedEvent) => {
//     console.log("selected event: ", selectedEvent);
//     const eventTimes = convertToEventSlot(selectedEvent);
//     setMeetingStart(eventTimes.startDateTime);
//     setMeetingEnd(eventTimes.endDateTime);
//     setIsOpen(false);
//     setIsSlotSelected(true);
//   };

//   const sortEvents = (events) => {
//     const sorted = [...events].sort(
//       (a, b) => new Date(a.startTime) - new Date(b.startTime)
//     );
//     return sorted;
//   };

//   // Get current user
//   const getEmailDetails = async () => {
//     const tokenObj = localStorage.getItem("eph-token");
//     const token = JSON.parse(tokenObj).value;
//     try {
//       const response = await fetch(`${API_URL}get-email-details`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           token,
//           expertID: data.expertID,
//         }),
//       });

//       if (response.status === 200) {
//         const result = await response.json();
//         if (result.status === "success") {
//           setUser(result.user);
//           setExpertEmail(result.expert.email);
//         }
//       } else {
//         console.log("Response error!");
//       }
//     } catch (error) {
//       console.log("error while fetching current user!");
//     }
//   };


//   // const getDefaultTemplate = (events) => {
//   //   const sortedEvents = sortEvents(events);
//   //   const slotItems = sortedEvents
//   //     .map((event) => {
//   //       const slot = eventToString(event);
//   //       return `<li>${slot.weekday}, ${slot.day} ${slot.month} ${slot.year}, ${slot.startTime} – ${slot.endTime} (${slot.timezone})</li>`;
//   //     })
//   //     .join("");

//   //   const templates = generateTemplates(data.expertName, user.name, slotItems);

//   //   return templates;
//   // };

//   const getDefaultTemplate = (events) => {
//     const sortedEvents = sortEvents(events);

//     const now = new Date();
//     const futureEvents = sortedEvents.filter((event) => {
//       const eventDate = new Date(event.startTime);
//       return eventDate >= now;
//     });

//     let slotItems;
//     if (futureEvents.length > 0) {
//       slotItems = futureEvents
//         .map((event) => {
//           const slot = eventToString(event);
//           return `<li>${slot.weekday}, ${slot.day} ${slot.month} ${slot.year}, ${slot.startTime} – ${slot.endTime} (${slot.timezone})</li>`;
//         })
//         .join("");
//     } else {
//       slotItems = `<li><em>There are no future timeslots provided by the client.</em></li>`;
//     }

//     const templates = generateTemplates(data.expertName, user.name, slotItems);

//     return templates;
//   };

//   const generateTemplates = (expertName, userName, slotsHTML) => [
//     {
//       lang: "en",
//       label: "English",
//       name: "Client timeslots for call",
//       subject: "expertpowerhouse | Client call",
//       value: `
//         <div>Dear ${expertName},</div>
//         <div><br></div>
//         <div>The client is interested in your profile and would like to schedule a discussion. They are suggesting the following slots:</div>
//         <ul>${slotsHTML}</ul>
//         <div>Does one of the above fit?</div>
//         <div><br></div>
//         <div>Once confirmed, we will set up the discussion via Teams.</div>
//         <div><br></div>
//         <div>Best regards,</div>
//         <div>${userName}</div>
//       `,
//     },
//     {
//       lang: "de",
//       label: "German",
//       name: "Zeitvorschläge für das Kundengespräch",
//       subject: "expertpowerhouse | Client call",
//       value: `
//         <div>Sehr geehrte/r ${expertName},</div>
//         <div><br></div>
//         <div>Der Kunde möchte ein Gespräch führen. Hier sind die möglichen Zeiten:</div>
//         <ul>${slotsHTML}</ul>
//         <div>Bitte teilen Sie uns mit, ob einer der Termine passt.</div>
//         <div><br></div>
//         <div>Wir setzen dann ein Gespräch per Teams auf und schicken entsprechende Einwahldaten.</div>
//         <div><br></div>
//         <div>Mit freundlichen Grüßen,</div>
//         <div>${userName}</div>
//       `,
//     },
//   ];

//   // useEffect(() => {
//   //   if (data.isDeclined) {
//   //     setIsShaking(true);
//   //     const timer = setTimeout(() => setIsShaking(false), 1000);
//   //     return () => clearTimeout(timer);
//   //   }
//   // }, [data.isDeclined]);

//   const ratingValues = [exRating1, exRating2, exRating3, exRating4, exRating5];
//   const ratingSetters = [setExRating1, setExRating2, setExRating3, setExRating4, setExRating5];
//   const ratingSavers = [saveExRating1, saveExRating2, saveExRating3, saveExRating4, saveExRating5];

//   const badges = [
//     data.sharedWithClient === "yes" && {
//       icon: "fa-regular fa-file-powerpoint",
//       label: "PowerPoint generated",
//       className: "bg-orange-50 text-orange-700",
//     },
//     data.sharedViaLink && {
//       icon: "fa-solid fa-share-nodes",
//       label: "Shared via link",
//       className: "bg-blue-50 text-blue-700",
//     },
//     data.isSelected && {
//       icon: "fa-solid fa-star",
//       label: "Shortlisted",
//       className: "bg-emerald-50 text-emerald-700",
//     },
//     data.removedFromClient && {
//       icon: "fa-solid fa-user-slash",
//       label: "Removed from client environment",
//       className: "bg-rose-50 text-rose-700",
//     },
//     data.isCallRequested && {
//       icon: "fa-solid fa-phone-volume",
//       label: "Call requested",
//       className: "bg-[#365561]/10 text-[#365561]",
//     },
//     data.isDeclined && {
//       icon: "fa-solid fa-ban",
//       label: "Declined",
//       className: "bg-red-50 text-red-700",
//     },
//     data.isDeclined && {
//       icon: "fa-solid fa-message",
//       label: "Feedback from client",
//       className: "bg-orange-50 text-orange-700 cursor-pointer",
//     },
//     data.sharedViaLink && {
//       icon: "fa-solid fa-eye",
//       label: "Client views",
//       className: "bg-[#365561]/10 text-[#365561]",
//     },
//   ].filter(Boolean);

//   return (
//     <>
//       <div
//         className="grid min-w-[1340px] items-start gap-2 border-b border-slate-200 px-3 py-2 text-sm relative overflow-visible transition hover:bg-slate-50/60"
//         style={{ gridTemplateColumns: rowGridTemplateColumns }}
//       >
//         {(data.isSelected || data.isDeclined) && (
//           <div
//             className="pointer-events-none absolute inset-y-0 left-0 z-0 w-[350px]"
//             style={{
//               background: data.isDeclined
//                 ? "linear-gradient(90deg, rgba(244,63,94,0.34) 0%, rgba(244,63,94,0.16) 48%, rgba(244,63,94,0) 100%)"
//                 : "linear-gradient(90deg, rgba(16,185,129,0.34) 0%, rgba(16,185,129,0.16) 48%, rgba(16,185,129,0) 100%)",
//             }}
//           />
//         )}
//         {/* Name */}
//         <div className="flex flex-col min-w-0 pr-2">
//           <div className="flex items-center gap-2">
//             <input
//               type="checkbox"
//               checked={selectedExpertIds.some((id) => String(id) === String(data.expertID))}
//               onChange={(e) =>
//                 e.target.checked
//                   ? appendExpertId(data.expertID)
//                   : removeExpertId(data.expertID)
//               }
//               className="h-4 w-4 rounded-full border-slate-300 accent-[#365561]"
//             />
//             <a
//               href={`/app/PreviewDigitalPPT/${proj_id}/${data.expertID}/null`}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="text-[#365561] font-semibold hover:no-underline"
//             >
//               {data.expertName}
//             </a>
//             {data.isCallRequested && (
//               <i
//                 className="fa-solid fa-phone-volume fa-shake cursor-pointer text-[#365561]"
//                 onClick={toggleModal}
//               ></i>
//             )}
//           </div>
//           {/* bottom info bar */}
//           <div className="absolute bottom-2 flex flex-row items-center gap-2">
//             {/* <SharedInfoSelection
//               projectID={proj_id}
//               expertID={expert_id}
//               onDisplayIDChange={handleDisplayIDChnage}
//               onIsShareNameChange={handleIsShareNameChange}
//             /> */}

//             <div className="flex flex-wrap items-center gap-1.5">
//               <ContactInfoButton type="email" value={data.expertEmail || expertEmail} />
//               <ContactInfoButton type="phone" value={data.expertPhone} />
//               <ContactInfoButton type="linkedin" value={data.expertLinkedIn} />
//               {badges.length > 0 && (
//                 <span
//                   role="separator"
//                   aria-orientation="vertical"
//                   className="mx-0.5 h-4 w-px shrink-0 rounded-full bg-[#365561]/30"
//                 />
//               )}
//               {badges.map((badge, badgeIndex) => (
//                 <SummaryBadge
//                   key={badge.label}
//                   icon={badge.icon}
//                   label={badge.label}
//                   className={badge.className}
//                   isLeftEdge={badgeIndex === 0 || badgeIndex === 1}
//                   isRightEdge={false}
//                   isLastRow={isLastRow}
//                   logData={logData}
//                   expert_id={expert_id}
//                   showFeedback={showFeedback}
//                   setShowFeedback={setShowFeedback}
//                 />
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* ID */}
//         <div className="flex items-center justify-center">
//           <span className="mr-1 -mt-[1px]">
//             {project.projectType === "exp" ? "EPH_EXP_" : "EPH_CON_"}
//           </span>
//           <input
//             type="text"
//             value={exDigitalID}
//             placeholder="ID#"
//             maxLength={3}
//             onChange={(e) => setExDigitalID(e.target.value)}
//             onBlur={saveExDigitalID}
//             className="border-b text-sm w-[25px] focus:outline-none"
//           />
//         </div>

//         {/* Dimensions */}
//         {ratingValues.map((val, i) => (
//           <input
//             key={i}
//             type="number"
//             className="w-[50px] shrink-0 border-b text-center"
//             value={val}
//             onChange={(e) => {
//               const v = e.target.value;
//               if (v >= 0 && v <= 5) ratingSetters[i](v);
//             }}
//             onBlur={() => ratingSavers[i]()}
//           />
//         ))}

//         {/* In % */}
//         <div className="text-center">
//           {exRatingPercentage}
//         </div>

//         {/* Consultant rate */}
//         <div
//           className={`flex min-w-0 items-center justify-center ${
//             isEditingConRate ? "" : "cursor-pointer"
//           }`}
//         >
//           {!isEditingConRate ? (
//             <div
//               className="flex items-center gap-1 text-sm truncate group"
//               onClick={() => {
//                 if (!isEditingConRate) setIsEditingConRate(true);
//               }}
//             >
//               <span className="text-gray-700">{conCurrency || "---"}</span>
//               <span className="text-gray-800">{exDailyRateToEPH || "0"}</span>
//               <span className="text-gray-600 text-xs">
//                 / {conBillingFrequency?.replace("per ", "") || "--"}
//               </span>
//               {/* Tooltip */}
//               <div className="absolute -top-6 mt-1 w-max bg-black text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition pointer-events-none">
//                 Click to edit consultant rate
//               </div>
//             </div>
//           ) : (
//             <div className="flex justify-center items-center gap-1 w-full">
//               <div className="flex items-center gap-1">
//                 <div className="relative">
//                   <select
//                     className="w-[50px] cursor-pointer text-sm focus:outline-none"
//                     value={conCurrency}
//                     onChange={(e) => {
//                       setConCurrency(e.target.value);
//                       saveConCurrency(e.target.value);
//                     }}
//                   >
//                     <option value="">---</option>
//                     <option value="EUR">EUR</option>
//                     <option value="USD">USD</option>
//                     <option value="GBP">GBP</option>
//                     <option value="CHF">CHF</option>
//                     <option value="AUD">AUD</option>
//                     <option value="AED">AED</option>
//                     <option value="INR">INR</option>
//                   </select>
//                 </div>

//                 <input
//                   type="text"
//                   // autoFocus
//                   className="flex-1 max-w-[90px] border-b text-sm bg-gray-100 px-1"
//                   value={exDailyRateToEPH}
//                   onChange={(e) => setExDailyRateToEPH(e.target.value)}
//                   onBlur={() => {
//                     saveExDailyRateToEPH();
//                     setIsEditingConRate(false);
//                   }}
//                 />

//                 <select
//                   className="w-[50px] text-sm focus:outline-none cursor-pointer"
//                   value={conBillingFrequency}
//                   onChange={(e) => {
//                     setConBillingFrequency(e.target.value);
//                     saveConBillingFrequency(e.target.value);
//                   }}
//                   onBlur={() => setIsEditingConRate(false)}
//                 >
//                   <option value="">---</option>
//                   <option value="per hour">hour</option>
//                   <option value="per day">day</option>
//                   <option value="per month">month</option>
//                 </select>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Client rate */}
//         <div className="relative flex min-w-0 items-center justify-center">
//           {!isEditingClientRate ? (
//             <div className="flex flex-col items-center justify-center w-full">
//               <div
//                 className="flex items-center gap-1 text-sm truncate cursor-pointer group"
//                 onClick={() => {
//                   if (!isEditingClientRate) setIsEditingClientRate(true);
//                 }}
//               >
//                 <span className="text-gray-700">{exCurrency || "---"}</span>
//                 <span className="text-gray-800">{exDailyRate || "0"}</span>
//                 <span className="text-gray-600 text-xs">
//                   / {exBillingFrequency?.replace("per ", "") || "--"}
//                 </span>

//                 {/* Tooltip */}
//                 <div className="absolute -top-8 mt-1 w-max bg-black text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition pointer-events-none">
//                   Click to edit client rate
//                 </div>
//               </div>

//               <div className="absolute top-full flex items-center space-x-1 mt-[10px]">
//                 <input
//                   type="checkbox"
//                   checked={exFootNote === "yes"}
//                   onChange={(e) => {
//                     setExFootNote(e.target.checked ? "yes" : "no");
//                     saveExFootNote(e.target.checked ? "yes" : "no");
//                   }}
//                   className="accent-[#365561]"
//                 />
//                 <label className="text-xs mt-2">
//                   *rate includes EPH service
//                 </label>
//               </div>
//             </div>
//           ) : (
//             <div className="flex flex-col justify-center items-center w-full">
//               <div className="flex items-center gap-1">
//                 <div className="relative">
//                   <select
//                     className="w-[50px] cursor-pointer text-sm focus:outline-none"
//                     value={exCurrency}
//                     onChange={(e) => {
//                       setExCurrency(e.target.value);
//                       saveExCurrency(e.target.value);
//                     }}
//                   >
//                     <option value="">---</option>
//                     <option value="EUR">EUR</option>
//                     <option value="USD">USD</option>
//                     <option value="GBP">GBP</option>
//                     <option value="CHF">CHF</option>
//                     <option value="AUD">AUD</option>
//                     <option value="AED">AED</option>
//                     <option value="INR">INR</option>
//                   </select>
//                 </div>

//                 <input
//                   type="text"
//                   className="flex-1 max-w-[90px] border-b text-sm bg-gray-100 px-1"
//                   value={exDailyRate}
//                   onChange={(e) => setExDailyRate(e.target.value)}
//                   onBlur={() => {
//                     saveExDailyRate();
//                     setIsEditingClientRate(false);
//                   }}
//                 />

//                 <select
//                   className="w-[50px] text-sm focus:outline-none cursor-pointer"
//                   value={exBillingFrequency}
//                   onChange={(e) => {
//                     setExBillingFrequency(e.target.value);
//                     saveExBillingFrequency(e.target.value);
//                   }}
//                   onBlur={() => setIsEditingClientRate(false)}
//                 >
//                   <option value="">---</option>
//                   <option value="per hour">hour</option>
//                   <option value="per day">day</option>
//                   <option value="per month">month</option>
//                 </select>
//               </div>

//               <div className="absolute top-full flex items-center space-x-1 mt-[10px]">
//                 <input
//                   type="checkbox"
//                   checked={exFootNote === "yes"}
//                   onChange={(e) => {
//                     setExFootNote(e.target.checked ? "yes" : "no");
//                     saveExFootNote(e.target.checked ? "yes" : "no");
//                   }}
//                   className="accent-[#365561]"
//                 />
//                 <label className="text-xs mt-2">
//                   *rate includes EPH service
//                 </label>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Availability */}
//         <div className="min-w-0">
//           <textarea
//             className="w-full border rounded px-2 py-1 text-sm resize-none"
//             value={exAvailableComment}
//             onChange={(e) => setExAvailableComment(e.target.value)}
//             onBlur={saveExAvailableComment}
//           />
//         </div>

//         {/* Call icon + delete */}
//         <div className="flex flex-col items-center gap-2 relative">
//           <button
//             onClick={() => setOpenCall(true)}
//             className="flex items-center justify-center focus:outline-none"
//           >
//             {appointmentExist ? (
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 x="0px"
//                 y="0px"
//                 width="20"
//                 height="20"
//                 viewBox="0 0 55 55"
//                 fill="#365561"
//               >
//                 <path d="M 27.5 5 C 24.08 5 21.269531 7.64 21.019531 11 L 24 11 C 26.76 11 29 13.24 29 16 L 29 17.820312 C 31.87 17.150312 34 14.57 34 11.5 C 34 7.91 31.09 5 27.5 5 z M 42.5 9 A 4.5 4.5 0 0 0 42.5 18 A 4.5 4.5 0 0 0 42.5 9 z M 6 13 C 4.346 13 3 14.346 3 16 L 3 34 C 3 35.654 4.346 37 6 37 L 24 37 C 25.654 37 27 35.654 27 34 L 27 16 C 27 14.346 25.654 13 24 13 L 6 13 z M 10 19 L 20 19 L 20 21 L 16 21 L 16 31 L 14 31 L 14 21 L 10 21 L 10 19 z M 29 21 L 29 34 C 29 36.76 26.76 39 24 39 L 18.199219 39 C 18.599219 40.96 19.569688 42.710313 20.929688 44.070312 C 22.739688 45.880312 25.24 47 28 47 C 33.52 47 38 42.52 38 37 L 38 21 L 29 21 z M 40 21 L 40 37 C 40 37.82 39.919531 38.620625 39.769531 39.390625 C 40.599531 39.780625 41.52 40 42.5 40 C 46.09 40 49 37.09 49 33.5 L 49 21 L 40 21 z"></path>
//               </svg>
//             ) : (
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 x="0px"
//                 y="0px"
//                 width="20"
//                 height="20"
//                 viewBox="0 0 55 55"
//                 fill="#365561"
//               >
//                 <path d="M 27 4 C 23.145666 4 20 7.1456661 20 11 C 20 11.694215 20.109343 12.364062 20.298828 13 L 5 13 C 3.3550302 13 2 14.35503 2 16 L 2 34 C 2 35.64497 3.3550302 37 5 37 L 16.050781 37 C 16.558532 42.596375 21.274041 47 27 47 C 32.119276 47 36.240954 43.409081 37.460938 38.664062 C 38.643436 39.440841 39.984387 40 41.5 40 C 45.63039 40 49 36.63039 49 32.5 L 49 21 A 1.0001 1.0001 0 0 0 48 20 L 37 20 L 26 20 L 26 17.923828 C 26.327632 17.970927 26.660365 18 27 18 C 30.854334 18 34 14.854334 34 11 C 34 7.1456661 30.854334 4 27 4 z M 27 6 C 29.773666 6 32 8.2263339 32 11 C 32 13.773666 29.773666 16 27 16 C 26.651336 16 26.315457 15.955685 25.988281 15.888672 C 25.927569 14.29544 24.606899 13 23 13 L 22.421875 13 C 22.153458 12.388243 22 11.715897 22 11 C 22 8.2263339 24.226334 6 27 6 z M 42 8 C 40.416667 8 39.101892 8.6297556 38.251953 9.5859375 C 37.402014 10.542119 37 11.777778 37 13 C 37 14.222222 37.402014 15.457881 38.251953 16.414062 C 39.101892 17.370244 40.416667 18 42 18 C 43.583333 18 44.898108 17.370244 45.748047 16.414062 C 46.597986 15.457881 47 14.222222 47 13 C 47 11.777778 46.597986 10.542119 45.748047 9.5859375 C 44.898108 8.6297556 43.583333 8 42 8 z M 42 10 C 43.083333 10 43.768559 10.370244 44.251953 10.914062 C 44.735347 11.457882 45 12.222222 45 13 C 45 13.777778 44.735347 14.542119 44.251953 15.085938 C 43.768559 15.629755 43.083333 16 42 16 C 40.916667 16 40.231441 15.629756 39.748047 15.085938 C 39.264653 14.542118 39 13.777778 39 13 C 39 12.222222 39.264653 11.457881 39.748047 10.914062 C 40.231441 10.370245 40.916667 10 42 10 z M 5 15 L 21.757812 15 L 23 15 C 23.56503 15 24 15.43497 24 16 L 24 16.365234 A 1.0001 1.0001 0 0 0 24 16.919922 L 24 20.832031 A 1.0001 1.0001 0 0 0 24 21.158203 L 24 34 C 24 34.56503 23.56503 35 23 35 L 17.167969 35 A 1.0001 1.0001 0 0 0 16.841797 35 L 5 35 C 4.4349698 35 4 34.56503 4 34 L 4 16 C 4 15.43497 4.4349698 15 5 15 z M 9 19 L 9 21 L 13 21 L 13 31 L 15 31 L 15 21 L 19 21 L 19 19 L 9 19 z M 26 22 L 36 22 L 36 36 C 36 40.982593 31.982593 45 27 45 C 22.356014 45 18.554378 41.508579 18.058594 37 L 23 37 C 24.64497 37 26 35.64497 26 34 L 26 22 z M 38 22 L 47 22 L 47 32.5 C 47 35.54961 44.54961 38 41.5 38 C 40.097088 38 38.851397 37.45098 37.880859 36.591797 C 37.89251 36.384961 38 36.209688 38 36 L 38 22 z"></path>
//               </svg>
//             )}
//           </button>
//           <button
//             onClick={handleProfileDelete}
//             className="mt-[5px] focus:outline-none"
//           >
//             <i className="text-[#365561] cursor-pointer fa fa-trash hover:text-red-500 transition duration-100 ease-in-out" />
//           </button>
//         </div>
//       </div>

//       {showFeedback && (
//         <ClientFeedbackModal
//           data={data}
//           onClose={() => setShowFeedback(false)}
//         />
//       )}

//       {/* Popup Components */}
//       {openCall && (
//         <div className="fixed inset-0 z-50 flex items-end justify-center bg-black bg-opacity-30">
//           {/* <AppointmentScheduler
//             projectID={proj_id}
//             expertID={data.expertID}
//             setAppointmentExist={setAppointmentExist}
//             openCall={openCall}
//             setOpenCall={setOpenCall}
//           /> */}
//           <EphCalendar 
//             projectID={proj_id}
//             expertID={data.expertID}
//             setOpenCall={setOpenCall}
//             setAppointmentExist={setAppointmentExist}
//           />
//         </div>
//       )}

//       {isSlotSelected && (
//         // <AppointmentScheduler
//         //   projectID={proj_id}
//         //   expertID={data.expertID}
//         //   setAppointmentExist={setAppointmentExist}
//         //   openCall={isSlotSelected}
//         //   setOpenCall={setIsSlotSelected}
//         //   selectedStartTime={meetingStart}
//         //   selectedEndTime={meetingEnd}
//         // />
//         <div className="fixed inset-0 z-50 flex items-end justify-center bg-black bg-opacity-30">
//           <EphCalendar 
//             projectID={proj_id}
//             expertID={data.expertID}
//             setOpenCall={setIsSlotSelected}
//             setAppointmentExist={setAppointmentExist}
//           />
//         </div>
//       )}

//       {isOpen && (
//         <RequestCallModal
//           data={data}
//           clientEvents={sortedEvents}
//           expertEvents={expertEvents}
//           expertID={data.expertID}
//           mediaLink={mediaLink}
//           databaseLink={databaseLink}
//           onClose={() => setIsOpen(false)}
//           onOpenEmail={() => {
//             setOpenEmail(true);
//             setIsOpen(false);
//           }}
//           onSlotClick={handleCalendarOpen}
//         />
//       )}

//       {openEmail && (
//         <ComposeNewEmail
//           onClose={() => setOpenEmail(false)}
//           defaultTo={[expertEmail]}
//           defaultTemplates={defaultTemp}
//         />
//       )}
//     </>
//   );
// }

// export default function ProjectSummary() {
//   useEffect(() => {
//     document.title = "Project Summary";
//   }, []);
//   const { API_URL } = useContext(UrlContext);
//   const { userData } = useContext(UserContext);
//   const proj_id = useParams().id;
//   const [project, setProject] = useState({});
//   const [allDigitalData, setAllDigitalData] = useState([]);
//   const [backupData, setBackupData] = useState([]);
//   const [profileFilter, setProfileFilter] = useState("all");
//   const [loading, setLoading] = useState(true);
//   const [dimension1, setDimension1] = useState("");
//   const [dimension1returnSuccess, setDimension1returnSuccess] = useState(false);
//   const [dimension1returnError, setDimension1returnError] = useState(false);
//   const [dimension1loading, setDimension1loading] = useState(false);
//   const [dimension2, setDimension2] = useState("");
//   const [dimension2returnSuccess, setDimension2returnSuccess] = useState(false);
//   const [dimension2returnError, setDimension2returnError] = useState(false);
//   const [dimension2loading, setDimension2loading] = useState(false);
//   const [dimension3, setDimension3] = useState("");
//   const [dimension3returnSuccess, setDimension3returnSuccess] = useState(false);
//   const [dimension3returnError, setDimension3returnError] = useState(false);
//   const [dimension3loading, setDimension3loading] = useState(false);
//   const [dimension4, setDimension4] = useState("");
//   const [dimension4returnSuccess, setDimension4returnSuccess] = useState(false);
//   const [dimension4returnError, setDimension4returnError] = useState(false);
//   const [dimension4loading, setDimension4loading] = useState(false);
//   const [dimension5, setDimension5] = useState("");
//   const [dimension5returnSuccess, setDimension5returnSuccess] = useState(false);
//   const [dimension5returnError, setDimension5returnError] = useState(false);
//   const [dimension5loading, setDimension5loading] = useState(false);
//   const [clientLogo, setClientLogo] = useState(false);
//   const [addLogoPopUp, setAddLogoPopUp] = useState(false);
//   const [continueWithoutLogo, setContinueWithoutLogo] = useState(false);
//   const [clientid, setClientid] = useState(null);
//   const [isLinkCreated, setIsLinkCreated] = useState(null);
//   const [expertIds, setExpertIds] = useState([]);
//   const [showButtons, setShowButtons] = useState(false);
//   const [events, setEvents] = useState([]);
//   const [clientLogs, setClientLogs] = useState([]);
//   const [showLogs, setShowLogs] = useState(false);
//   const [editingIndex, setEditingIndex] = useState(null);
//   const [openEmailClient, setOpenEmailClient] = useState(false);
//   const [projectSupporters, setProjectSupporters] = useState([]);

//   const appendExpertId = (id) => {
//     setExpertIds((prev) => {
//       if (prev.some((expertId) => String(expertId) === String(id))) return prev;
//       return [...prev, id];
//     });
//   };
//   const removeExpertId = (id) => {
//     setExpertIds((prev) => prev.filter((expertId) => String(expertId) !== String(id)));
//   };

//   useEffect(() => {
//     const url = `${API_URL}project-title/` + proj_id;
//     fetch(url, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//       },
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setProject(data.project);
//         setDimension1(data.project.dimension1);
//         setDimension2(data.project.dimension2);
//         setDimension3(data.project.dimension3);
//         setDimension4(data.project.dimension4);
//         setDimension5(data.project.dimension5);
//       })
//       .catch((err) => console.log(err));
//   }, []);

//   useEffect(() => {
//     const url = `${API_URL}get-client-logs/` + proj_id;
//     fetch(url, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//       },
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status == "success") {
//           setClientLogs(data.response);
//         } else {
//           setClientLogs([]);
//         }
//       })
//       .catch((err) => console.log(err));
//   }, []);

//   const getSummaryData = (proj_id) => {
//     const url = `${API_URL}project-summary-info/` + proj_id;
//     fetch(url, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//       },
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setIsLinkCreated(data.linkCreated);
//         setProjectSupporters(data.projectSupporters);
//         let digitalDataWithNoID = [];
//         let digitalData = [];
//         for (let i = 0; i < data.allDigitalData.length; i++) {
//           if (data.allDigitalData[i].expertDigitalID === "") {
//             digitalDataWithNoID.push(data.allDigitalData[i]);
//           } else {
//             digitalData.push(data.allDigitalData[i]);
//           }
//         }
//         digitalData = digitalData.concat(digitalDataWithNoID);
//         setAllDigitalData(digitalData);
//         setBackupData(digitalData);
//         setLoading(false);
//       })
//       .catch((err) => console.log(err));
//   };

//   useEffect(() => {
//     getSummaryData(proj_id);
//   }, []);

//   const saveDimension1 = () => {
//     setDimension1returnError(false);
//     setDimension1loading(true);
//     const url = `${API_URL}save-dimension1/` + proj_id;
//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ dimension1 }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setDimension1loading(false);
//         if (data.status === "success") {
//           setDimension1returnSuccess(true);
//           setTimeout(() => {
//             setDimension1returnSuccess(false);
//           }, 1500);
//         } else {
//           setDimension1returnError(true);
//         }
//       })
//       .catch(() => {
//         setDimension1loading(false);
//         setDimension1returnError(true);
//       });
//   };

//   const saveDimension2 = () => {
//     setDimension2returnError(false);
//     setDimension2loading(true);
//     const url = `${API_URL}save-dimension2/` + proj_id;
//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ dimension2 }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setDimension2loading(false);
//         if (data.status === "success") {
//           setDimension2returnSuccess(true);
//           setTimeout(() => {
//             setDimension2returnSuccess(false);
//           }, 1500);
//         } else {
//           setDimension2returnError(true);
//         }
//       })
//       .catch(() => {
//         setDimension2loading(false);
//         setDimension2returnError(true);
//       });
//   };

//   const saveDimension3 = () => {
//     setDimension3returnError(false);
//     setDimension3loading(true);
//     const url = `${API_URL}save-dimension3/` + proj_id;
//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ dimension3 }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setDimension3loading(false);
//         if (data.status === "success") {
//           setDimension3returnSuccess(true);
//           setTimeout(() => {
//             setDimension3returnSuccess(false);
//           }, 1500);
//         } else {
//           setDimension3returnError(true);
//         }
//       })
//       .catch(() => {
//         setDimension3loading(false);
//         setDimension3returnError(true);
//       });
//   };

//   const saveDimension4 = () => {
//     setDimension4returnError(false);
//     setDimension4loading(true);
//     const url = `${API_URL}save-dimension4/` + proj_id;
//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ dimension4 }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setDimension4loading(false);
//         if (data.status === "success") {
//           setDimension4returnSuccess(true);
//           setTimeout(() => {
//             setDimension4returnSuccess(false);
//           }, 1500);
//         } else {
//           setDimension4returnError(true);
//         }
//       })
//       .catch(() => {
//         setDimension4loading(false);
//         setDimension4returnError(true);
//       });
//   };

//   const saveDimension5 = () => {
//     setDimension5returnError(false);
//     setDimension5loading(true);
//     const url = `${API_URL}save-dimension5/` + proj_id;
//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ dimension5 }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setDimension5loading(false);
//         if (data.status === "success") {
//           setDimension5returnSuccess(true);
//           setTimeout(() => {
//             setDimension5returnSuccess(false);
//           }, 1500);
//         } else {
//           setDimension5returnError(true);
//         }
//       })
//       .catch(() => {
//         setDimension5loading(false);
//         setDimension5returnError(true);
//       });
//   };

//   useEffect(() => {
//     if (expertIds.length > 0) {
//       setShowButtons(true);
//     } else {
//       setShowButtons(false);
//     }
//   }, [expertIds]);

//   useEffect(() => {
//     if (profileFilter === "ppt") {
//       const filteredData = backupData.filter((item) => {
//         return item?.sharedWithClient === "yes";
//       });
//       setAllDigitalData(filteredData);
//       return;
//     }

//     if (profileFilter === "sharedViaLink") {
//       const filteredData = backupData.filter((item) => {
//         return item?.sharedViaLink === true || item?.sharedViaLink === "true" || item?.sharedViaLink === "yes";
//       });
//       setAllDigitalData(filteredData);
//       return;
//     }

//     setAllDigitalData(backupData);
//   }, [profileFilter, backupData]);

//   const profileTypeCounts = {
//     all: backupData.length,
//     ppt: backupData.filter((item) => item?.sharedWithClient === "yes").length,
//     sharedViaLink: backupData.filter((item) => item?.sharedViaLink === true || item?.sharedViaLink === "true" || item?.sharedViaLink === "yes").length,
//   };

//   useEffect(() => {
//     const url = `${API_URL}account-details/` + proj_id;
//     fetch(url, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//       },
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setClientid(data.account.id);
//         if (data.account.clientLogo) {
//           setClientLogo(true);
//         }
//       })
//       .catch((err) => console.log(err));
//   }, []);

//   // API for fetching meeting timeslots
//   const getClientAvailabilitySlot = async () => {
//     const requestBody = {
//       projectID: proj_id,
//     };
//     try {
//       let modifiedUrl = "get-client-availability-slots";
//       const response = await fetch(`${API_URL}${modifiedUrl}`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(requestBody),
//       });
//       const responseData = await response.json();
//       if (responseData.status === "success") {
//         setEvents(responseData.eventData);
//       } else {
//         console.error("Failed to add selected slot");
//       }
//     } catch (error) {
//       console.error("Error while calling the backend API:", error);
//     }
//   };

//   useEffect(() => {
//     if (allDigitalData.length > 0) {
//       getClientAvailabilitySlot();
//     }
//   }, [allDigitalData]);

//   const dimensionValues = [dimension1, dimension2, dimension3, dimension4, dimension5];
//   const dimensionSetters = [setDimension1, setDimension2, setDimension3, setDimension4, setDimension5];
//   const dimensionSavers = [saveDimension1, saveDimension2, saveDimension3, saveDimension4, saveDimension5];
//   const dimensionSaveStates = [
//     { loading: dimension1loading, success: dimension1returnSuccess, error: dimension1returnError },
//     { loading: dimension2loading, success: dimension2returnSuccess, error: dimension2returnError },
//     { loading: dimension3loading, success: dimension3returnSuccess, error: dimension3returnError },
//     { loading: dimension4loading, success: dimension4returnSuccess, error: dimension4returnError },
//     { loading: dimension5loading, success: dimension5returnSuccess, error: dimension5returnError },
//   ];

//   const isAdmin = userData?.roles?.includes("Admin");
//   const isProjectSupporter = projectSupporters?.some(
//     (supporter) =>
//       String(supporter || "").trim().toLowerCase() ===
//       String(userData?.username || "").trim().toLowerCase()
//   );

//   const canOpenClientEmails = isAdmin || isProjectSupporter;

//   const projectClientName =
//     typeof project?.clientName === "string"
//       ? project.clientName
//       : typeof project?.client_name === "string"
//         ? project.client_name
//         : typeof project?.client === "string"
//           ? project.client
//           : typeof project?.client?.name === "string"
//             ? project.client.name
//             : typeof project?.accountName === "string"
//               ? project.accountName
//               : "";

//   return (
//     <>
//       {addLogoPopUp && !continueWithoutLogo ? (
//         <AddLogo
//           project_id={proj_id}
//           setContinueWithoutLogo={setContinueWithoutLogo}
//           clientId={clientid}
//         />
//       ) : null}

//       <ProjectTitle project={project} />

//       {!loading ? (
//         <div className="p-4">
//           <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
//             <div className="flex flex-wrap items-center gap-2">
//               <MSbuttonsSummery
//                 clientLogo={clientLogo}
//                 project_id={proj_id}
//                 expertIds={expertIds}
//                 continueWithoutLogo={continueWithoutLogo}
//                 setContinueWithoutLogo={setContinueWithoutLogo}
//                 setAddLogoPopUp={setAddLogoPopUp}
//                 isLinkCreated={isLinkCreated}
//                 setIsLinkCreated={setIsLinkCreated}
//                 getSummaryData={getSummaryData}
//                 showButtons={showButtons}
//                 project_name={project?.name || ""}
//                 client_name={projectClientName}
//                 project_type={project?.projectType || ""}
//               />
//               {clientLogs.length ? (
//                 <MSActionButton
//                   icon="fa-regular fa-file"
//                   shortLabel="Logs"
//                   isLeftEdge={!isLinkCreated && !showButtons}
//                   label="Open client activity logs"
//                   onClick={() => setShowLogs(true)}
//                 />
//               ) : null}
//             </div>
            
//             <div className="flex flex-row items-center justify-center gap-2">
//               <ProfileTypeToggle
//                 value={profileFilter}
//                 onChange={setProfileFilter}
//                 counts={profileTypeCounts}
//               />

//               {/* <button
//                 type="button"
//                 onClick={() => setOpenEmailClient(true)}
//                 className={[
//                   "group relative inline-flex h-10 items-center gap-1.5 overflow-visible rounded-xl px-2.5 text-[11px] font-semibold transition focus:outline-none",
//                   "border border-slate-200 bg-white text-slate-600 shadow-sm",
//                   "hover:border-[#365561]/25 hover:bg-[#365561]/10 hover:text-[#365561]",
//                   "disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-slate-200 disabled:hover:bg-white disabled:hover:text-slate-600",
//                 ].join(" ")}
//                 aria-label="Client emails"
//                 disabled={!canOpenClientEmails}
//               >
//                 <i class="fa-solid fa-envelopes-bulk text-[14px]"></i>
//                 <span>{'Client emails'}</span>
//                 <ToggleTooltip label={'Client emails log for this project'} isLeftEdge={false} isRightEdge={true} />
//               </button> */}
//             </div>
//           </div>
        
//           <div className="w-full space-y-2 overflow-x-auto overflow-y-visible pb-2">
//             {/* Header */}
//             <div
//               className="grid min-w-[1340px] items-center gap-2 rounded-2xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm font-semibold text-slate-600 shadow-sm"
//               style={{ gridTemplateColumns: rowGridTemplateColumns }}
//             >
//               <div>Name</div>
//               <div className="text-center">ID#</div>

//               <div className="relative col-span-5 min-w-0">
//                 {editingIndex === null ? (
//                   <div className="grid grid-cols-5 gap-2">
//                     {dimensionValues.map((value, i) => (
//                       <div key={i} className="relative min-w-0 text-left text-sm">
//                         <button
//                           type="button"
//                           className="group w-full truncate rounded-lg px-1 py-0.5 text-left hover:bg-white focus:outline-none"
//                           onClick={() => setEditingIndex(i)}
//                         >
//                           {value || <span className="text-gray-400">{`Dimension${i + 1}`}</span>}
//                           <span className="pointer-events-none absolute left-0 top-full z-[70] mt-2 hidden whitespace-nowrap rounded-xl bg-slate-900 px-2 py-1 text-xs text-white shadow-lg group-hover:block">
//                             {value || "Click to edit"}
//                             <span className="absolute bottom-full left-4 h-2 w-2 translate-y-1 rotate-45 bg-slate-900" />
//                           </span>
//                         </button>

//                         {dimensionSaveStates[i].loading && (
//                           <img className="absolute right-1 top-1 w-4 h-4" src={LoadingIcon} alt="loading" title="Loading..." />
//                         )}
//                         {dimensionSaveStates[i].success && (
//                           <img className="absolute right-1 top-1 w-4 h-4" src={successIcon} alt="success" title="Success" />
//                         )}
//                         {dimensionSaveStates[i].error && (
//                           <img className="absolute right-1 top-1 w-4 h-4" src={errorIcon} alt="error" title="Error! Please reload" />
//                         )}
//                       </div>
//                     ))}
//                   </div>
//                 ) : (
//                   <div className="relative w-full">
//                     <input
//                       type="text"
//                       autoFocus
//                       placeholder={`Dimension ${editingIndex + 1}`}
//                       value={dimensionValues[editingIndex] || ""}
//                       onChange={(e) => {
//                         dimensionSetters[editingIndex](e.target.value);
//                       }}
//                       onBlur={() => {
//                         dimensionSavers[editingIndex]();
//                         setEditingIndex(null);
//                       }}
//                       className="w-full rounded-lg border border-slate-200 bg-white px-2 py-1 text-sm focus:border-[#365561]/40 focus:outline-none"
//                     />
//                   </div>
//                 )}
//               </div>

//               <div className="text-center">In %</div>
//               <div className="text-center">Consultant rate</div>
//               <div className="text-center">Client rate</div>
//               <div className="text-center">Availability</div>
//               <div className="text-center">Call</div>
//             </div>

//             {/* Rows */}
//             {allDigitalData.map((data, index) => (
//               <ExpertRow
//                 key={data?.expertID || index}
//                 data={data}
//                 index={index}
//                 proj_id={proj_id}
//                 project={project}
//                 expert_id={data?.expertID}
//                 appendExpertId={appendExpertId}
//                 removeExpertId={removeExpertId}
//                 backupData={backupData}
//                 setBackupData={setBackupData}
//                 events={events}
//                 logData={clientLogs}
//                 selectedExpertIds={expertIds}
//               />
//             ))}
//           </div>
//         </div>
//       ) : (
//         <div className="text-center mt-6">
//           <img src={LoadingIcon} alt="Loading..." className="h-[50px] inline-block" />
//         </div>
//       )}

//       {showLogs && (
//         <ClientLog
//           showLogs={setShowLogs}
//           logs={clientLogs}
//           data={allDigitalData}
//         />
//       )}

//       {openEmailClient && (
//         <ProjectClientEmail
//           projectID={proj_id}
//           projectName={`${project?.name}`}
//           isLinkCreated={isLinkCreated}
//           onClose={() => setOpenEmailClient(false)}
//         />
//       )}
//     </>
//   );
// }




// this section will be deleted and above code will be uncommented when we move forward with global client environment selection.

import React, { useContext, useEffect, useState } from "react";
import { createPortal, flushSync } from "react-dom";
import { createRoot } from "react-dom/client";
import {
  BriefcaseBusiness,
  CalendarClock,
  Coins,
  FileDown,
  FileText,
  Globe2,
  GraduationCap,
  Hash,
  ImagePlus,
  Languages,
  Mail,
  Phone,
  Linkedin,
  Copy,
  Check,
  MapPin,
  Target,
  UserRound,
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useParams } from "react-router-dom";
import ProjectTitle from "../components/ProjectDetails/ProjectTitle";
import "../styles/projectSummary.css";
import LoadingIcon from "../images/Loading_icon.gif";
import successIcon from "../images/successGreenIcon.png";
import errorIcon from "../images/errorRedIcon.png";
import Swal from "sweetalert2";
import AddLogo from "../components/ProjectDetails/AddLogo";
import AppointmentScheduler from "../components/ProjectDetails/AppointmentCreator";
import { UrlContext } from "../contexts/UrlContext";
import { UserContext } from "../contexts/UserContext";
import ClientLog from "../components/ProjectSummary/ClientLog";
import expertDefaultImg from "../images/expert-default.png";
import ComposeNewEmail from "../components/EmailUI/ComposeNewEmail";
import EphCalendar from "../components/ProjectDetails/EphCalendar";
import ProjectClientEmail from "../components/EmailUI/ProjectClientEmail";
import bulkPdfFirstPage from "../images/bulk_pdf_first_page.png";
import bulkPdfLastPage from "../images/bulk_pdf_last_page.png";
import DigitalProfileSlide from "../components/PreviewDigitalPPT/DigitalProfileSlide";
import "../styles/previewDigitalPPTBrowser.css";
import "react-quill/dist/quill.snow.css";

const rowGridTemplateColumns =
  "250px 100px repeat(5, 50px) 60px minmax(120px, 1fr) minmax(120px, 1fr) minmax(140px, 1fr) 48px";

function ToggleTooltip({ label, isLeftEdge = false, isRightEdge = false, isTop = false }) {
  const verticalClass = isTop ? "bottom-full mb-2" : "top-full mt-2";
  const horizontalClass = isLeftEdge
    ? "left-0 translate-x-0"
    : isRightEdge
      ? "right-0 translate-x-0"
      : "left-1/2 -translate-x-1/2";
  const arrowVerticalClass = isTop ? "top-full -translate-y-1" : "bottom-full translate-y-1";
  const arrowHorizontalClass = isLeftEdge
    ? "left-3"
    : isRightEdge
      ? "right-3"
      : "left-1/2 -translate-x-1/2";

  return (
    <span
      className={[
        "pointer-events-none absolute z-[80] hidden whitespace-nowrap rounded-xl bg-slate-900 px-2.5 py-1.5 text-[11px] font-semibold text-white shadow-xl group-hover:block",
        verticalClass,
        horizontalClass,
      ].join(" ")}
    >
      {label}
      <span
        className={[
          "absolute h-2 w-2 rotate-45 bg-slate-900",
          arrowVerticalClass,
          arrowHorizontalClass,
        ].join(" ")}
      />
    </span>
  );
}

function ProfileTypeToggle({ value, onChange, counts = {} }) {
  const options = [
    {
      value: "all",
      label: "All profiles",
      shortLabel: "All",
      count: counts.all || 0,
      icon: "fa-users",
      activeBg: "bg-[#365561]",
      inactiveText: "text-[#365561]",
      hoverBg: "hover:bg-[#365561]/10",
    },
    {
      value: "ppt",
      label: "PowerPoint generated",
      shortLabel: "PPT",
      count: counts.ppt || 0,
      icon: "fa-file-powerpoint",
      activeBg: "bg-orange-500",
      inactiveText: "text-orange-700",
      hoverBg: "hover:bg-orange-50",
    },
    {
      value: "sharedViaLink",
      label: "Shared via link",
      shortLabel: "Link",
      count: counts.sharedViaLink || 0,
      icon: "fa-share-nodes",
      activeBg: "bg-blue-500",
      inactiveText: "text-blue-700",
      hoverBg: "hover:bg-blue-50",
    },
  ];

  return (
    <div className="relative z-30 inline-flex w-fit max-w-full overflow-visible rounded-2xl border border-slate-200 bg-white p-1 shadow-[0_10px_30px_rgba(15,23,42,0.05)]">
      {options.map((option, optionIndex) => {
        const isActive = value === option.value;

        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={[
              "group relative z-10 inline-flex shrink-0 items-center gap-1 rounded-xl px-2 py-2 text-[11px] font-semibold transition-colors duration-200 focus:outline-none sm:px-2.5",
              isActive ? "text-white" : `${option.inactiveText} ${option.hoverBg}`,
            ].join(" ")}
          >
            {isActive && (
              <motion.span
                layoutId="project-summary-profile-type-toggle-pill"
                className={[
                  "absolute inset-0 -z-10 rounded-xl shadow-[0_10px_24px_rgba(54,85,97,0.18)]",
                  option.activeBg,
                ].join(" ")}
                transition={{ type: "spring", stiffness: 420, damping: 32 }}
              />
            )}

            <i className={`fa-solid ${option.icon} text-[10px]`} />
            <span>{option.shortLabel}</span>
            <span
              className={[
                "rounded-full px-1.5 py-0.5 text-[10px] leading-none",
                isActive ? "bg-white/20 text-white" : "bg-slate-100 text-slate-500",
              ].join(" ")}
            >
              {option.count}
            </span>
            <ToggleTooltip
              label={`${option.label}: ${option.count}`}
              isLeftEdge={optionIndex === 0}
              isRightEdge={optionIndex === options.length - 1}
            />
          </button>
        );
      })}
    </div>
  );
}


function MSActionButton({
  icon,
  label,
  shortLabel,
  onClick,
  primary = false,
  loading = false,
  disabled = false,
  isLeftEdge = false,
  isRightEdge = false,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || loading}
      className={[
        "group relative inline-flex h-8 items-center gap-1 overflow-visible rounded-xl px-2.5 text-[11px] font-semibold transition focus:outline-none disabled:cursor-wait disabled:opacity-60",
        primary
          ? "bg-[#365561] text-white shadow-[0_8px_20px_rgba(54,85,97,0.18)] hover:bg-[#2c4650]"
          : "border border-slate-200 bg-white text-slate-600 shadow-sm hover:border-[#365561]/25 hover:bg-[#365561]/10 hover:text-[#365561]",
      ].join(" ")}
      aria-label={label}
    >
      <i className={loading ? "fa-solid fa-spinner fa-spin text-[14px]" : `${icon} text-[14px]`} />
      <span>{shortLabel}</span>
      <ToggleTooltip label={label} isLeftEdge={isLeftEdge} isRightEdge={isRightEdge} />
    </button>
  );
}

function LoadingOverlay({ text }) {
  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/35 backdrop-blur-sm">
      <div className="rounded-3xl border border-slate-200 bg-white px-8 py-7 text-center shadow-[0_24px_70px_rgba(15,23,42,0.28)]">
        <i className="fa-solid fa-spinner fa-spin text-4xl text-[#365561]" />
        <p className="mt-3 text-sm font-semibold text-slate-700">{text}</p>
      </div>
    </div>
  );
}


const DEFAULT_BULK_PDF_SECTION_VISIBILITY = {
  profilePicture: true,
  identity: true,
  position: true,
  location: true,
  region: false,
  language: true,
  totalExperience: true,
  availability: true,
  rate: true,
  summary: true,
  matching: true,
  experience: true,
  education: true,
};

function BulkPdfSectionToggle({
  checked,
  onChange,
  icon: Icon,
  label,
  description,
  showDescription = true,
}) {
  return (
    <button
      type="button"
      className={`pdp2-section-option${checked ? " is-active" : ""}`}
      onClick={onChange}
      aria-pressed={checked}
    >
      <span className="pdp2-section-option-icon" aria-hidden="true">
        <Icon size={17} strokeWidth={2} />
      </span>

      <span className="pdp2-section-option-copy">
        <strong>{label}</strong>
        {showDescription && description ? <small>{description}</small> : null}
      </span>

      <span className="pdp2-section-option-switch" aria-hidden="true">
        <span />
      </span>
    </button>
  );
}

function BulkPdfLivePreview({
  profiles,
  loading,
  error,
  sectionVisibility,
  identityMode,
  projectName,
  clientName,
  contactName,
  contactEmail,
}) {
  if (loading) {
    return (
      <div className="flex h-full min-h-[420px] items-center justify-center rounded-2xl border border-slate-200 bg-white/80">
        <div className="text-center">
          <i className="fa-solid fa-spinner fa-spin text-3xl text-[#365561]" />
          <p className="mt-3 text-sm font-semibold text-slate-600">Loading PDF preview...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex h-full min-h-[420px] items-center justify-center rounded-2xl border border-rose-200 bg-rose-50/70 p-6 text-center">
        <div>
          <p className="text-sm font-semibold text-rose-700">Preview unavailable</p>
          <p className="mt-1 max-w-md text-xs leading-5 text-rose-600">{error}</p>
        </div>
      </div>
    );
  }

  if (!Array.isArray(profiles) || profiles.length === 0) {
    return (
      <div className="flex h-full min-h-[420px] items-center justify-center rounded-2xl border border-slate-200 bg-white/80 p-6 text-center">
        <p className="text-sm text-slate-500">Select at least one profile to load a preview.</p>
      </div>
    );
  }

  const previewScale = 0.62;
  const pageCount = profiles.length + 2;
  const pageGap = 18;
  const unscaledDeckHeight = pageCount * 720 + Math.max(pageCount - 1, 0) * pageGap;

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-[0_10px_34px_rgba(15,23,42,0.08)]">
      <div className="flex shrink-0 items-start justify-between gap-4 border-b border-slate-200 px-4 py-3">
        <div>
          <p className="text-sm font-bold text-slate-800">Full PDF preview</p>
          <p className="mt-0.5 text-xs text-slate-500">
            Scroll through the cover, all selected profiles, and the closing page. Changes on the left are reflected immediately.
          </p>
        </div>
        <span className="shrink-0 rounded-full bg-[#365561]/10 px-2.5 py-1 text-[10px] font-bold text-[#365561]">
          {pageCount} pages
        </span>
      </div>

      <div className="bulk-pdf-live-preview min-h-0 flex-1 overflow-auto bg-slate-100/80 p-4">
        <style>{`
          .bulk-pdf-live-preview .pdp2-page-shell.pdp2-bulk-pdf-deck {
            width: 1280px !important;
            min-height: 0 !important;
            margin: 0 !important;
            padding: 0 !important;
            display: flex !important;
            flex-direction: column !important;
            gap: ${pageGap}px !important;
            overflow: visible !important;
            background: transparent !important;
          }

          .bulk-pdf-live-preview .pdp2-bulk-pdf-deck > .pdp2-slide,
          .bulk-pdf-live-preview .pdp2-bulk-pdf-deck > [data-pdp2-bulk-static-page] {
            flex: 0 0 720px !important;
            width: 1280px !important;
            height: 720px !important;
            margin: 0 !important;
            box-shadow: 0 12px 34px rgba(15, 23, 42, 0.14) !important;
          }
        `}</style>

        <div
          className="mx-auto"
          style={{
            width: `${1280 * previewScale}px`,
            height: `${unscaledDeckHeight * previewScale}px`,
          }}
        >
          <div
            style={{
              width: "1280px",
              height: `${unscaledDeckHeight}px`,
              transform: `scale(${previewScale})`,
              transformOrigin: "top left",
            }}
          >
            <BulkDigitalProfileDeck
              profiles={profiles}
              projectName={projectName}
              clientName={clientName}
              contactName={contactName}
              contactEmail={contactEmail}
              projectType={profiles?.[0]?.projectType}
              sectionVisibility={sectionVisibility}
              identityMode={identityMode}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function BulkPdfSectionSelectionModal({
  open,
  sectionVisibility,
  identityMode,
  previewProfiles,
  previewLoading,
  previewError,
  projectName,
  clientName,
  contactName,
  contactEmail,
  onToggleSection,
  onIdentitySelection,
  onClose,
  onConfirm,
}) {
  if (typeof document === "undefined") return null;

  const informationOptions = [
    { key: "profilePicture", label: "Profile picture", description: "Consultant profile photo", icon: ImagePlus, checked: sectionVisibility.profilePicture, onChange: () => onToggleSection("profilePicture") },
    { key: "ephId", label: "EPH ID", description: "EPH_CON_ / EPH_EXP_ identifier", icon: Hash, checked: sectionVisibility.identity && identityMode === "id", onChange: () => onIdentitySelection("id") },
    { key: "name", label: "Name", description: "Consultant name", icon: UserRound, checked: sectionVisibility.identity && identityMode === "name", onChange: () => onIdentitySelection("name") },
    { key: "position", label: "Position", description: "Current role or headline", icon: BriefcaseBusiness, checked: sectionVisibility.position, onChange: () => onToggleSection("position") },
    { key: "location", label: "Location", description: "Current consultant location", icon: MapPin, checked: sectionVisibility.location, onChange: () => onToggleSection("location") },
    { key: "region", label: "Region", description: "Regional experience", icon: Globe2, checked: sectionVisibility.region, onChange: () => onToggleSection("region") },
    { key: "language", label: "Languages", description: "Language capabilities", icon: Languages, checked: sectionVisibility.language, onChange: () => onToggleSection("language") },
    { key: "totalExperience", label: "Total experience", description: "Years of professional experience", icon: BriefcaseBusiness, checked: sectionVisibility.totalExperience, onChange: () => onToggleSection("totalExperience") },
    { key: "availability", label: "Availability", description: "Current availability note", icon: CalendarClock, checked: sectionVisibility.availability, onChange: () => onToggleSection("availability") },
    { key: "rate", label: "Rate", description: "Currency, rate and billing unit", icon: Coins, checked: sectionVisibility.rate, onChange: () => onToggleSection("rate") },
  ];

  const contentOptions = [
    { key: "summary", label: "Professional Summary", description: "Main consultant summary", icon: FileText, checked: sectionVisibility.summary, onChange: () => onToggleSection("summary") },
    { key: "matching", label: "Requirement Matching", description: "Dimensions and radar matching", icon: Target, checked: sectionVisibility.matching, onChange: () => onToggleSection("matching") },
    { key: "experience", label: "Relevant Experience", description: "Selected professional experience", icon: BriefcaseBusiness, checked: sectionVisibility.experience, onChange: () => onToggleSection("experience") },
    { key: "education", label: "Education & Certification", description: "Education and credentials", icon: GraduationCap, checked: sectionVisibility.education, onChange: () => onToggleSection("education") },
  ];

  const informationActiveCount = informationOptions.filter((option) => option.checked).length;
  const contentActiveCount = contentOptions.filter((option) => option.checked).length;

  return createPortal(
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[10050] flex items-center justify-center bg-slate-950/45 p-4 backdrop-blur-sm sm:p-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.16 }}
          role="presentation"
          data-pdp2-print-hide="true"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) onClose();
          }}
        >
          <motion.div
            className="pdp2-section-picker flex h-[94vh] max-h-[94vh] w-[min(900px,calc(100vw-24px))] flex-col overflow-hidden rounded-[26px] border border-slate-200/90 bg-[radial-gradient(circle_at_top,rgba(54,85,97,0.14),transparent_34%),linear-gradient(to_bottom,#f8fafc,#eef2f6)] shadow-[0_28px_90px_rgba(15,23,42,0.34)] lg:w-[min(1720px,calc(100vw-24px))]"
            initial={{ opacity: 0, y: 22, scale: 0.975 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 18, scale: 0.98 }}
            transition={{ type: "spring", stiffness: 340, damping: 30, mass: 0.82 }}
            role="dialog"
            aria-modal="true"
            aria-labelledby="bulk-pdf-section-picker-title"
            onMouseDown={(event) => event.stopPropagation()}
          >
            <div className="pdp2-section-picker-header">
              <div className="pdp2-section-picker-title-wrap">
                <span className="pdp2-section-picker-eyebrow">Bulk PDF layout</span>
                <strong id="bulk-pdf-section-picker-title">Choose visible sections</strong>
                <p>Choose which information and content blocks should appear on every selected digital profile in this PDF. This selection is used only for the PDF and is not saved to the profile.</p>
              </div>
              <button type="button" className="pdp2-section-picker-close" onClick={onClose} aria-label="Close bulk PDF section picker">×</button>
            </div>

            <div className="pdp2-section-picker-body min-h-0 overflow-hidden" style={{ overflow: "hidden" }}>
              <div
                className="grid h-full min-h-0 grid-cols-1 gap-4 p-3 sm:p-4 lg:grid-cols-[minmax(420px,620px)_minmax(0,1fr)] xl:grid-cols-[720px_minmax(0,1fr)]"
                style={{ gridTemplateRows: "minmax(0, 1fr)" }}
              >
                <div className="h-full min-h-0 space-y-4 overflow-y-auto overscroll-contain pr-2">
                  <section className="pdp2-section-picker-panel pdp2-section-picker-panel-information">
                    <div className="pdp2-section-picker-panel-header">
                      <div className="pdp2-section-picker-panel-title">
                        <span className="pdp2-section-picker-panel-icon"><UserRound size={17} strokeWidth={2} /></span>
                        <div><strong>Information</strong></div>
                      </div>
                      <span className="pdp2-section-picker-count">{informationActiveCount}/{informationOptions.length}</span>
                    </div>
                    <div className="pdp2-section-picker-grid grid-cols-1 sm:grid-cols-2">
                      {informationOptions.map((option) => (
                        <BulkPdfSectionToggle
                          key={option.key}
                          checked={option.checked}
                          onChange={option.onChange}
                          icon={option.icon}
                          label={option.label}
                          description={option.description}
                          showDescription={false}
                        />
                      ))}
                    </div>
                    <div className="pdp2-section-picker-note">
                      <Hash size={13} strokeWidth={2} />
                      <span><strong>EPH ID</strong> and <strong>Name</strong> share the same profile area and are mutually exclusive.</span>
                    </div>
                  </section>

                  <section className="pdp2-section-picker-panel pdp2-section-picker-panel-content">
                    <div className="pdp2-section-picker-panel-header">
                      <div className="pdp2-section-picker-panel-title">
                        <span className="pdp2-section-picker-panel-icon"><FileText size={17} strokeWidth={2} /></span>
                        <div><strong>Content</strong></div>
                      </div>
                      <span className="pdp2-section-picker-count">{contentActiveCount}/{contentOptions.length}</span>
                    </div>
                    <div className="pdp2-section-picker-grid grid-cols-1 sm:grid-cols-2">
                      {contentOptions.map((option) => (
                        <BulkPdfSectionToggle
                          key={option.key}
                          checked={option.checked}
                          onChange={option.onChange}
                          icon={option.icon}
                          label={option.label}
                          description={option.description}
                          showDescription={false}
                        />
                      ))}
                    </div>
                  </section>
                </div>

                <div className="hidden min-h-0 lg:block">
                  <BulkPdfLivePreview
                    profiles={previewProfiles}
                    loading={previewLoading}
                    error={previewError}
                    sectionVisibility={sectionVisibility}
                    identityMode={sectionVisibility.identity ? identityMode || "id" : null}
                    projectName={projectName}
                    clientName={clientName}
                    contactName={contactName}
                    contactEmail={contactEmail}
                  />
                </div>
              </div>
            </div>

            <div className="flex shrink-0 items-center justify-end gap-2 border-t border-slate-200/90 bg-white/85 px-5 py-4 backdrop-blur-sm">
              <button type="button" className="rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-600 transition hover:bg-slate-50 focus:outline-none" onClick={onClose}>Cancel</button>
              <button type="button" className="rounded-xl border-0 bg-[#365561] px-5 py-2 text-sm font-semibold text-white transition hover:bg-[#2e4a54] focus:outline-none" onClick={onConfirm}>Generate PDF</button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  );
}

function BulkPdfCoverPage({
  projectName,
  clientName,
  projectType,
}) {
  const monthYear = new Intl.DateTimeFormat("en-US", {
    month: "long",
    year: "numeric",
  })
    .format(new Date())
    .toUpperCase();

  const deckTitle =
    projectType === "exp"
      ? "Selected Expert Profiles"
      : "Selected Consulting Profiles";

  return (
    <div
      className="pdp2-bulk-print-page relative h-[720px] w-[1280px] shrink-0 overflow-hidden bg-white"
      data-pdp2-bulk-static-page="cover"
    >
      {/*
        Use a real <img> rather than CSS background-image so the first
        page is always included by the browser print engine even when
        "Background graphics" is disabled.
      */}
      <img
        src={bulkPdfFirstPage}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full select-none object-fill"
        draggable="false"
      />

      <div
        className="absolute text-white"
        style={{
          left: "10.2%",
          top: "62.0%",
          width: "64%",
          fontFamily: "Arial, Helvetica, sans-serif",
        }}
      >
        <div
          style={{
            fontSize: "32px",
            lineHeight: 1.12,
            fontWeight: 700,
            letterSpacing: "-0.4px",
          }}
        >
          {deckTitle}
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "0px",
            marginTop: "17px",
            fontSize: "23px",
            lineHeight: 1.18,
            fontWeight: 400,
            width: "100%",
          }}
        >
          <span
            className="shrink-0"
            style={{ minWidth: "66px" }}
          >
            Topic:
          </span>

          <span
            style={{
              display: "block",
              width: "50ch",
              maxWidth: "50ch",
              flex: "0 0 50ch",
              fontWeight: 400,
              whiteSpace: "normal",
              overflowWrap: "break-word",
              wordBreak: "normal",
            }}
          >
            {projectName || ""}
          </span>
        </div>
      </div>

      <div
        className="absolute text-white"
        style={{
          left: "10.2%",
          top: "82.4%",
          width: "64%",
          fontFamily: "Arial, Helvetica, sans-serif",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            gap: "6px",
            fontSize: "20px",
            lineHeight: 1.2,
            whiteSpace: "nowrap",
          }}
        >
          <span style={{ fontWeight: 700 }}>
            Prepared for
          </span>
          <span
            style={{
              fontWeight: 600,
              minWidth: 0,
              whiteSpace: "nowrap",
            }}
          >
            {clientName || ""}
          </span>
        </div>
      </div>

      <div
        className="absolute text-[#365561]"
        style={{
          left: "10.2%",
          top: "93.5%",
          width: "50%",
          fontFamily: "Arial, Helvetica, sans-serif",
          fontSize: "17px",
          lineHeight: 1.2,
          fontWeight: 700,
        }}
      >
        {monthYear}
      </div>
    </div>
  );
}

function BulkPdfLastPage({
  contactName,
  contactEmail,
}) {
  return (
    <div
      className="pdp2-bulk-print-page relative h-[720px] w-[1280px] shrink-0 overflow-hidden bg-[#365561]"
      data-pdp2-bulk-static-page="outro"
    >
      <img
        src={bulkPdfLastPage}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full select-none object-fill"
        draggable="false"
      />

      <div
        className="absolute text-white"
        style={{
          left: "60.7%",
          top: "4.0%",
          width: "34.5%",
          fontFamily: "Arial, Helvetica, sans-serif",
        }}
      >
        <div
          style={{
            fontSize: "28px",
            lineHeight: 1.24,
            fontWeight: 700,
            letterSpacing: "-0.35px",
          }}
        >
          Let us find the right expertise
          <br />
          for your project
        </div>

        <div
          style={{
            marginTop: "31px",
            fontSize: "17px",
            lineHeight: 1.25,
            fontWeight: 400,
          }}
        >
          Reach out to your Contact
        </div>

        <div
          style={{
            marginTop: "6px",
            fontSize: "17px",
            lineHeight: 1.28,
            fontWeight: 600,
            overflowWrap: "anywhere",
          }}
        >
          {contactName || ""}
        </div>

        <div
          style={{
            marginTop: "1px",
            fontSize: "17px",
            lineHeight: 1.28,
            fontWeight: 600,
            overflowWrap: "anywhere",
          }}
        >
          {contactEmail || ""}
        </div>

        <div
          style={{
            marginTop: "66px",
            fontSize: "17px",
            lineHeight: 1.2,
            fontWeight: 700,
          }}
        >
          Cologne | Düsseldorf | Mumbai
        </div>
      </div>
    </div>
  );
}

function BulkDigitalProfileDeck({
  profiles,
  projectName,
  clientName,
  contactName,
  contactEmail,
  projectType,
  sectionVisibility,
  identityMode,
}) {
  return (
    <div className="pdp2-page-shell pdp2-bulk-pdf-deck">
      <BulkPdfCoverPage
        projectName={projectName}
        clientName={clientName}
        projectType={projectType}
      />

      {profiles.map((profile, index) => (
        <DigitalProfileSlide
          key={profile?.ID || profile?.expertID || index}
          readOnly
          previewPrintLayout
          showProposedRates={false}
          sectionVisibility={sectionVisibility}
          expertID={profile?.expertID || profile?.ID}
          powerPointID={
            profile?.powerPointID ||
            profile?.powerpointID ||
            profile?.PowerPointID ||
            null
          }
          experienceData={
            Array.isArray(profile?.expertExperience)
              ? profile.expertExperience
              : []
          }
          data={{
            identityMode,
            projectType: profile?.projectType,
            profilePicture: profile?.profilePicture,
            expertDigitalID: profile?.expertDigitalID,
            expertName: profile?.expertName,
            position: profile?.position,
            location: profile?.location,
            region: profile?.region,
            language: profile?.language,
            totalExperience: profile?.totalExperience,
            availableComment: profile?.Available_comment,
            projectCurrency: profile?.projectCurrency,
            dailyRate: profile?.daily_rate,
            billingFrequency: profile?.billingFrequency,
            footNote: profile?.footNote,
            summary: profile?.summ,
            education: profile?.education,
            dimensions: [
              profile?.dimension1,
              profile?.dimension2,
              profile?.dimension3,
              profile?.dimension4,
              profile?.dimension5,
            ],
            ratings: [
              Number(profile?.rating1) || 0,
              Number(profile?.rating2) || 0,
              Number(profile?.rating3) || 0,
              Number(profile?.rating4) || 0,
              Number(profile?.rating5) || 0,
            ],
          }}
        />
      ))}

      <BulkPdfLastPage
        contactName={contactName}
        contactEmail={contactEmail}
      />
    </div>
  );
}

function waitForBulkImages(root) {
  const images = Array.from(
    root?.querySelectorAll?.("img") || []
  );

  return Promise.all(
    images.map((image) => {
      if (image.complete) {
        return Promise.resolve();
      }

      return new Promise((resolve) => {
        image.onload = resolve;
        image.onerror = resolve;
      });
    })
  );
}

function waitForBulkStyles(doc) {
  const stylesheetLinks = Array.from(
    doc.querySelectorAll('link[rel="stylesheet"]')
  );

  return Promise.all(
    stylesheetLinks.map((link) => {
      if (link.sheet) {
        return Promise.resolve();
      }

      return new Promise((resolve) => {
        const done = () => resolve();

        link.addEventListener("load", done, {
          once: true,
        });
        link.addEventListener("error", done, {
          once: true,
        });

        setTimeout(done, 3000);
      });
    })
  );
}

function copyBulkDocumentStyles(printWindow) {
  Array.from(
    document.querySelectorAll(
      'style, link[rel="stylesheet"]'
    )
  ).forEach((node) => {
    try {
      const clone = node.cloneNode(true);

      if (
        node.tagName === "LINK" &&
        node.href
      ) {
        clone.href = node.href;
      }

      printWindow.document.head.appendChild(clone);
    } catch (error) {
      console.error(
        "Failed to copy stylesheet into bulk PDF window:",
        error
      );
    }
  });
}

const BULK_PDF_PRINT_STYLE = `
  @page {
    size: 13.333333333in 7.5in;
    margin: 0;
  }

  html,
  body {
    width: auto !important;
    height: auto !important;
    min-height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
    background: #ffffff !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  #pdp2-bulk-print-root {
    width: auto !important;
    height: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
  }

  .pdp2-screen-only,
  [data-pdp2-print-hide="true"] {
    display: none !important;
  }

  .pdp2-print-only {
    display: block !important;
  }

  /* The normal Preview stylesheet fixes .pdp2-page-shell to one print page.
     The bulk deck is the only exception: it must be allowed to contain many
     otherwise-standard DigitalProfileSlide pages. */
  .pdp2-page-shell.pdp2-bulk-pdf-deck {
    width: auto !important;
    height: auto !important;
    min-height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
    background: #ffffff !important;
  }

  .pdp2-bulk-pdf-deck > .pdp2-slide,
  .pdp2-bulk-pdf-deck > [data-pdp2-bulk-static-page] {
    width: 13.333333333in !important;
    height: 7.5in !important;
    min-width: 13.333333333in !important;
    min-height: 7.5in !important;
    max-width: 13.333333333in !important;
    max-height: 7.5in !important;
    margin: 0 !important;
    box-shadow: none !important;
    overflow: hidden !important;
    break-after: page !important;
    page-break-after: always !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  .pdp2-bulk-pdf-deck > :last-child {
    break-after: auto !important;
    page-break-after: auto !important;
  }

  .pdp2-bulk-pdf-deck
    [data-pdp2-bulk-static-page]
    > img {
    position: absolute !important;
    inset: 0 !important;
    width: 100% !important;
    height: 100% !important;
    max-width: none !important;
    max-height: none !important;
    object-fit: fill !important;
  }
`;

function freezeBulkSlideGeometry(sourceDeck, clonedDeck) {
  const sourceSlides = Array.from(
    sourceDeck.querySelectorAll(":scope > .pdp2-slide")
  );
  const clonedSlides = Array.from(
    clonedDeck.querySelectorAll(":scope > .pdp2-slide")
  );

  const sectionSelectors = [
    ".pdp2-summary-section",
    ".pdp2-matching-section",
    ".pdp2-experience-section",
    ".pdp2-education-section",
  ];

  sourceSlides.forEach((sourceSlide, slideIndex) => {
    const clonedSlide = clonedSlides[slideIndex];
    if (!clonedSlide) return;

    // The standard Preview slide is already laid out correctly in the active
    // document. Freeze those calculated section heights onto the clone so the
    // multi-page print wrapper cannot make Flexbox recalculate them differently.
    sectionSelectors.forEach((selector) => {
      const sourceSection = sourceSlide.querySelector(selector);
      const clonedSection = clonedSlide.querySelector(selector);

      if (!sourceSection || !clonedSection) return;

      const height = sourceSection.getBoundingClientRect().height;
      if (!Number.isFinite(height) || height <= 0) return;

      clonedSection.style.height = `${height}px`;
      clonedSection.style.flex = `0 0 ${height}px`;
    });

    // Keep the two 600px content columns at the exact same runtime height as
    // PreviewDigitalPPT as well. This is only a snapshot of the shared layout;
    // it does not introduce any new design dimensions.
    [".pdp2-center-column", ".pdp2-right-column"].forEach(
      (selector) => {
        const sourceColumn = sourceSlide.querySelector(selector);
        const clonedColumn = clonedSlide.querySelector(selector);

        if (!sourceColumn || !clonedColumn) return;

        const height = sourceColumn.getBoundingClientRect().height;
        if (!Number.isFinite(height) || height <= 0) return;

        clonedColumn.style.height = `${height}px`;
      }
    );
  });
}

async function prepareBulkPdfPrintWindow(
  printWindow,
  sourceHost,
  title
) {
  printWindow.document.open();
  printWindow.document.write(`
    <!doctype html>
    <html>
      <head>
        <meta charset="utf-8" />
        <title></title>
      </head>
      <body>
        <div id="pdp2-bulk-print-root"></div>
      </body>
    </html>
  `);
  printWindow.document.close();

  printWindow.document.title = title;

  copyBulkDocumentStyles(printWindow);

  const printStyle =
    printWindow.document.createElement("style");

  printStyle.textContent = BULK_PDF_PRINT_STYLE;
  printWindow.document.head.appendChild(printStyle);

  const sourceDeck = sourceHost.querySelector(
    ".pdp2-bulk-pdf-deck"
  );

  if (!sourceDeck) {
    throw new Error(
      "Bulk digital profile slides could not be rendered."
    );
  }

  const clonedDeck = sourceDeck.cloneNode(true);

  // Preserve the exact section allocation that the shared DigitalProfileSlide
  // calculated in the parent document before the multi-page deck is mounted in
  // the print window.
  freezeBulkSlideGeometry(sourceDeck, clonedDeck);

  const sourceFields = sourceDeck.querySelectorAll(
    "input, textarea, select"
  );
  const clonedFields = clonedDeck.querySelectorAll(
    "input, textarea, select"
  );

  sourceFields.forEach((sourceField, index) => {
    const clonedField = clonedFields[index];

    if (!clonedField) return;

    clonedField.value = sourceField.value;

    if (clonedField.tagName === "TEXTAREA") {
      clonedField.textContent = sourceField.value;
    }

    if (
      sourceField.type === "checkbox" ||
      sourceField.type === "radio"
    ) {
      clonedField.checked = sourceField.checked;
    }
  });

  // Match PreviewDigitalPPT.handleBrowserPdf(): the normal single-profile
  // PDF removes editing-only DOM before mounting the print snapshot instead
  // of merely relying on @media print to hide it. Doing the same here keeps
  // the Bulk snapshot structurally identical to the standard Preview PDF.
  clonedDeck
    .querySelectorAll(
      '[data-pdp2-print-hide="true"], .pdp2-screen-only'
    )
    .forEach((node) => node.remove());

  clonedDeck
    .querySelectorAll(".pdp2-print-only")
    .forEach((node) => {
      node.style.display = "block";
    });

  const printRoot =
    printWindow.document.getElementById(
      "pdp2-bulk-print-root"
    );

  printRoot.appendChild(clonedDeck);

  await waitForBulkStyles(printWindow.document);
  await waitForBulkImages(printWindow.document);

  if (printWindow.document.fonts?.ready) {
    try {
      await printWindow.document.fonts.ready;
    } catch (error) {
      console.error(
        "Could not wait for print fonts:",
        error
      );
    }
  }
}

function MSbuttonsSummery({
  project_id,
  expertIds,
  clientLogo,
  setAddLogoPopUp,
  continueWithoutLogo,
  setContinueWithoutLogo,
  isLinkCreated,
  setIsLinkCreated,
  getSummaryData,
  showButtons,
  project_name = "",
  client_name = "",
  project_type = "",
}) {
  const urlContextValue = useContext(UrlContext);
  const { API_URL } = urlContextValue;
  const { userData } = useContext(UserContext);

  const [pptDownloading, setPptDownloading] = useState(false);
  const [wordDownloading, setWordDownloading] = useState(false);
  const [excelDownloading, setExcelDownloading] = useState(false);
  const [openSelection, setOpenSelection] = useState(false);
  const [openModifySelection, setOpenModifySelection] = useState(false);
  const [addToExisting, setAddToExisting] = useState(false);
  const [showPdfUpload, setShowPdfUpload] = useState(false);
  const [pdfFile, setPdfFile] = useState(null);
  const [pdfDragActive, setPdfDragActive] = useState(false);
  const [pdfUploading, setPdfUploading] = useState(false);
  const [showBulkPdfSelection, setShowBulkPdfSelection] = useState(false);
  const [bulkPdfSectionVisibility, setBulkPdfSectionVisibility] = useState(
    () => ({ ...DEFAULT_BULK_PDF_SECTION_VISIBILITY })
  );
  const [bulkPdfIdentityMode, setBulkPdfIdentityMode] = useState("id");
  const [bulkPdfPreviewProfiles, setBulkPdfPreviewProfiles] = useState([]);
  const [bulkPdfPreviewLoading, setBulkPdfPreviewLoading] = useState(false);
  const [bulkPdfPreviewError, setBulkPdfPreviewError] = useState("");

  const checkForLogo = () => {
    setAddLogoPopUp(true);
  };

  const fileCreationHandler = (format) => {
    const authToken = localStorage.getItem("accesstoken");
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const url = `${API_URL}create-full-${format}-from-ps/`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ expertIds, project_id, authToken }),
    })
      .then((res) => res.json())
      .then(async (data) => {
        if (data.status === "success") {
          window.open(data.filePath, "_blank", "rel=noopener noreferrer");
          await getSummaryData?.(project_id);
        } else if (data.status === "error") {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: data.message,
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: `${err.message}`,
        });
      })
      .finally(() => {
        if (format === "word") setWordDownloading(false);
        else if (format === "ppt") setPptDownloading(false);
        else setExcelDownloading(false);
      });
  };

  const createWordHandler = () => {
    setWordDownloading(true);
    fileCreationHandler("word");
  };

  const createExcelHandler = () => {
    setExcelDownloading(true);
    fileCreationHandler("excel");
  };

  const createPPTHandler = () => {
    if (clientLogo || continueWithoutLogo) {
      setPptDownloading(true);
      fileCreationHandler("ppt");
    } else {
      checkForLogo();
    }
  };

  const toggleBulkPdfSection = (key) => {
    setBulkPdfSectionVisibility((previous) => ({
      ...previous,
      [key]: !previous[key],
    }));
  };

  const handleBulkPdfIdentitySelection = (mode) => {
    const isAlreadyActive =
      bulkPdfSectionVisibility.identity && bulkPdfIdentityMode === mode;

    if (isAlreadyActive) {
      setBulkPdfIdentityMode(null);
      setBulkPdfSectionVisibility((previous) => ({
        ...previous,
        identity: false,
      }));
      return;
    }

    setBulkPdfIdentityMode(mode);
    setBulkPdfSectionVisibility((previous) => ({
      ...previous,
      identity: true,
    }));
  };

  const openBulkPdfSelection = async () => {
    if (!Array.isArray(expertIds) || expertIds.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No profiles selected",
        text: "Please select at least one digital profile first.",
      });
      return;
    }

    setShowBulkPdfSelection(true);
    setBulkPdfPreviewProfiles([]);
    setBulkPdfPreviewError("");
    setBulkPdfPreviewLoading(true);

    try {
      const tokenObj = localStorage.getItem("eph-token");
      const token = tokenObj ? JSON.parse(tokenObj).value : null;

      // Fetch all selected profiles for the full live PDF preview. Experience is
      // explicitly requested so turning that section on never requires another
      // round-trip while the user is adjusting the layout.
      const previewSectionVisibility = Object.fromEntries(
        Object.keys(DEFAULT_BULK_PDF_SECTION_VISIBILITY).map((key) => [key, true])
      );

      const response = await fetch(
        `${API_URL}fetch-digital-profiles-for-pdf`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token ? { "x-access-token": token } : {}),
          },
          body: JSON.stringify({
            projectID: project_id,
            expertIDs: expertIds,
            sectionVisibility: previewSectionVisibility,
            identityMode: bulkPdfIdentityMode || "id",
          }),
        }
      );

      const data = await response.json();

      if (!response.ok || data.status !== "success") {
        throw new Error(
          data.text || data.message || "Failed to load the PDF preview profile."
        );
      }

      const previewProfiles = Array.isArray(data.powerpointData)
        ? data.powerpointData
        : [];

      if (!previewProfiles.length) {
        throw new Error("No digital profiles were returned for the preview.");
      }

      setBulkPdfPreviewProfiles(previewProfiles);
    } catch (error) {
      console.error("Error loading bulk PDF live preview:", error);
      setBulkPdfPreviewError(
        error.message || "The live preview could not be loaded."
      );
    } finally {
      setBulkPdfPreviewLoading(false);
    }
  };

  const selectPdfFile = (file) => {
    if (!file) return;

    const isPdf =
      file.type === "application/pdf" ||
      file.name?.toLowerCase().endsWith(".pdf");

    if (!isPdf) {
      Swal.fire({
        icon: "warning",
        title: "PDF required",
        text: "Please select a PDF file.",
      });
      return;
    }

    setPdfFile(file);
  };

  const handlePdfDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setPdfDragActive(false);

    if (pdfUploading) return;

    const files = Array.from(event.dataTransfer.files || []);

    if (files.length > 1) {
      Swal.fire({
        icon: "warning",
        title: "One PDF at a time",
        text: "Please upload only one PDF file.",
      });
      return;
    }

    selectPdfFile(files[0]);
  };

  const closePdfUpload = () => {
    if (pdfUploading) return;

    setShowPdfUpload(false);
    setPdfFile(null);
    setPdfDragActive(false);
  };

  const uploadPdfToSharePoint = async () => {
    if (!pdfFile) {
      Swal.fire({
        icon: "warning",
        title: "No PDF selected",
        text: "Please select or drop the PDF file first.",
      });
      return;
    }

    const authToken = localStorage.getItem("accesstoken");
    const formData = new FormData();

    formData.append("file", pdfFile);
    formData.append("fileName", pdfFile.name);
    formData.append("authToken", authToken || "");
    formData.append("projectID", String(project_id));

    try {
      setPdfUploading(true);

      const response = await fetch(
        `${API_URL}upload-file-to-sharePoint`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      if (
        !response.ok ||
        data.status !== "success"
      ) {
        throw new Error(
          data.text ||
            data.message ||
            "Failed to upload PDF to SharePoint."
        );
      }

      setShowPdfUpload(false);
      setPdfFile(null);
      setPdfDragActive(false);

      Swal.fire({
        icon: "success",
        title: "PDF uploaded",
        text: "The PDF has been uploaded to SharePoint.",
      });
    } catch (error) {
      console.error(
        "Error uploading PDF to SharePoint:",
        error
      );

      Swal.fire({
        icon: "error",
        title: "Upload failed",
        text:
          error.message ||
          "Failed to upload the PDF to SharePoint.",
      });
    } finally {
      setPdfUploading(false);
    }
  };

  const createBulkPdfHandler = async (pdfSelection) => {
    if (!Array.isArray(expertIds) || expertIds.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No profiles selected",
        text: "Please select at least one digital profile first.",
      });
      return;
    }

    const selectedSectionVisibility = {
      ...DEFAULT_BULK_PDF_SECTION_VISIBILITY,
      ...(pdfSelection?.sectionVisibility || {}),
    };
    const selectedIdentityMode = selectedSectionVisibility.identity
      ? pdfSelection?.identityMode || "id"
      : null;

    Swal.fire({
      title: "Generating bulk PDF",
      text: `Preparing ${expertIds.length} digital profile${
        expertIds.length === 1 ? "" : "s"
      }...`,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    let renderHost = null;
    let renderRoot = null;

    try {
      const tokenObj =
        localStorage.getItem("eph-token");
      const token = tokenObj
        ? JSON.parse(tokenObj).value
        : null;

      /*
       * 1. Fetch everything first while the parent page remains active.
       */
      const response = await fetch(
        `${API_URL}fetch-digital-profiles-for-pdf`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token
              ? { "x-access-token": token }
              : {}),
          },
          body: JSON.stringify({
            projectID: project_id,
            expertIDs: expertIds,
            sectionVisibility: selectedSectionVisibility,
            identityMode: selectedIdentityMode,
          }),
        }
      );

      const data = await response.json();

      if (
        !response.ok ||
        data.status !== "success"
      ) {
        throw new Error(
          data.text ||
            data.message ||
            "Failed to fetch digital profiles."
        );
      }

      const profiles = Array.isArray(
        data.powerpointData
      )
        ? data.powerpointData
        : [];

      if (!profiles.length) {
        throw new Error(
          "No digital profiles were returned."
        );
      }

      /*
       * 2. Render the full read-only PDF deck in the CURRENT page first.
       *
       * The previous implementation opened the new tab before this step.
       * Browsers pause/throttle requestAnimationFrame in a background tab,
       * which meant this parent-page render could remain suspended until
       * the user returned to the parent tab.
       *
       * flushSync commits the hidden deck immediately while this tab is
       * active, so there is no background-tab dependency.
       */
      renderHost = document.createElement("div");
      renderHost.setAttribute(
        "data-pdp2-bulk-render-host",
        "true"
      );

      Object.assign(renderHost.style, {
        position: "fixed",
        left: "-100000px",
        top: "0",
        width: "1280px",
        visibility: "hidden",
        pointerEvents: "none",
        zIndex: "-1",
      });

      document.body.appendChild(renderHost);

      renderRoot = createRoot(renderHost);

      flushSync(() => {
        renderRoot.render(
          <UrlContext.Provider value={urlContextValue}>
            <BulkDigitalProfileDeck
              profiles={profiles}
              projectName={project_name}
              clientName={client_name}
              contactName={userData?.fullname || ""}
              contactEmail={userData?.email || ""}
              projectType={profiles?.[0]?.projectType}
              sectionVisibility={selectedSectionVisibility}
              identityMode={selectedIdentityMode}
            />
          </UrlContext.Provider>
        );
      });

      // Let shared-slide effects (notably Education auto-sizing) commit before
      // cloning the rendered deck into the print window.
      await new Promise((resolve) => {
        requestAnimationFrame(() => requestAnimationFrame(resolve));
      });

      await waitForBulkImages(renderHost);

      if (document.fonts?.ready) {
        try {
          await document.fonts.ready;
        } catch (error) {
          console.error(
            "Could not wait for PDF fonts:",
            error
          );
        }
      }

      const makeSafePdfFilePart = (value, fallback) => {
        const cleaned = String(value || fallback || "")
          .replace(/[\\/:*?"<>|]+/g, " ")
          .replace(/\s+/g, " ")
          .trim();

        return cleaned;
      };

      const now = new Date();
      const dateMonthYear = `${String(now.getDate()).padStart(2, "0")}${new Intl.DateTimeFormat(
        "en-US",
        { month: "short" }
      ).format(now)}${String(now.getFullYear()).slice(-2)}`;

      const bulkPdfFileName = `expertpowerhouse_${makeSafePdfFilePart(
        client_name,
        "Client"
      )}_${makeSafePdfFilePart(
        project_name,
        "Project"
      )}_${dateMonthYear}`;

      /*
       * 3. At this point the backend data, React deck and images are ready.
       *
       * Ask for one explicit click before opening the print window.
       * This prevents browser popup blockers from rejecting window.open()
       * after the asynchronous fetch/render work.
       */
      const readyResult = await Swal.fire({
        icon: "success",
        title: "Bulk PDF ready",
        text: `${profiles.length} digital profile${
          profiles.length === 1 ? "" : "s"
        } prepared and ready to print.`,
        confirmButtonText: "Open PDF",
        showCancelButton: true,
        cancelButtonText: "Cancel",
        reverseButtons: true,
      });

      if (!readyResult.isConfirmed) {
        renderRoot.unmount();
        renderRoot = null;

        renderHost.remove();
        renderHost = null;

        return;
      }

      /*
       * 4. Only now open the new window.
       * This click is a direct user action, so popup blockers should allow it.
       */
      const printWindow = window.open(
        "",
        "_blank",
        "width=1400,height=900"
      );

      if (!printWindow) {
        throw new Error(
          "The PDF window was blocked. Please allow popups for this site and try again."
        );
      }

      Swal.fire({
        title: "Opening PDF",
        text: "Preparing the print window...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        await prepareBulkPdfPrintWindow(
          printWindow,
          renderHost,
          bulkPdfFileName
        );

        renderRoot.unmount();
        renderRoot = null;

        renderHost.remove();
        renderHost = null;

        Swal.close();

        printWindow.onafterprint = () => {
          setPdfFile(null);
          setPdfDragActive(false);
          setShowPdfUpload(true);

          try {
            printWindow.close();
          } catch (error) {
            console.error(
              "Could not close bulk PDF window:",
              error
            );
          }
        };

        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
        }, 250);
      } catch (printError) {
        try {
          printWindow.close();
        } catch (closeError) {
          console.error(
            "Could not close failed bulk PDF window:",
            closeError
          );
        }

        throw printError;
      }
    } catch (error) {
      console.error(
        "Error generating bulk digital profile PDF:",
        error
      );

      if (renderRoot) {
        renderRoot.unmount();
      }

      if (renderHost?.isConnected) {
        renderHost.remove();
      }

      Swal.fire({
        icon: "error",
        title: "Bulk PDF generation failed",
        text:
          error.message ||
          "Failed to generate the bulk PDF.",
      });
    }
  };

  useEffect(() => {
    if (continueWithoutLogo) {
      createPPTHandler();
      setContinueWithoutLogo(false);
      setAddLogoPopUp(false);
    }
  }, [continueWithoutLogo]);

  return (
    <>
      {isLinkCreated && (
        <>
          <MSActionButton
            icon="fa-regular fa-eye"
            shortLabel="View"
            isLeftEdge
            label="View client environment"
            onClick={() => window.open(`/app/SharedProfiles/${project_id}`, "_blank")}
          />

          <MSActionButton
            icon="fa-regular fa-pen-to-square"
            shortLabel="Modify"
            label="Modify shared information selection"
            onClick={() => setOpenModifySelection(true)}
          />
        </>
      )}

      {showButtons && (
        <>
          {isLinkCreated ? (
            <MSActionButton
              icon="fa-solid fa-file-circle-plus"
              shortLabel="Add"
              isLeftEdge={!isLinkCreated}
              label="Add selected profiles to client environment"
              primary
              onClick={() => setAddToExisting(true)}
            />
          ) : (
            <MSActionButton
              icon="fa-solid fa-globe"
              shortLabel="Create"
              isLeftEdge={!isLinkCreated}
              label="Create client environment from selected profiles"
              primary
              onClick={() => setOpenSelection(true)}
            />
          )}

          <MSActionButton
            icon="fa-regular fa-file-word"
            shortLabel="Word"
            label="Generate Word document"
            loading={wordDownloading}
            onClick={createWordHandler}
          />
          <MSActionButton
            icon="fa-regular fa-file-powerpoint"
            shortLabel="PPTX"
            label="Generate PowerPoint document"
            loading={pptDownloading}
            onClick={createPPTHandler}
          />
          <MSActionButton
            icon="fa-regular fa-file-excel"
            shortLabel="Excel"
            label="Generate Excel document"
            loading={excelDownloading}
            onClick={createExcelHandler}
          />
          <MSActionButton
            icon="fa-regular fa-file-pdf"
            shortLabel="PDF"
            label="Generate bulk PDF"
            onClick={openBulkPdfSelection}
          />
        </>
      )}

      {pptDownloading && <LoadingOverlay text="Generating PowerPoint..." />}
      {wordDownloading && <LoadingOverlay text="Generating Word document..." />}
      {excelDownloading && <LoadingOverlay text="Generating Excel file..." />}

      <BulkPdfSectionSelectionModal
        open={showBulkPdfSelection}
        sectionVisibility={bulkPdfSectionVisibility}
        identityMode={bulkPdfIdentityMode}
        previewProfiles={bulkPdfPreviewProfiles}
        previewLoading={bulkPdfPreviewLoading}
        previewError={bulkPdfPreviewError}
        projectName={project_name}
        clientName={client_name}
        contactName={userData?.fullname || ""}
        contactEmail={userData?.email || ""}
        onToggleSection={toggleBulkPdfSection}
        onIdentitySelection={handleBulkPdfIdentitySelection}
        onClose={() => setShowBulkPdfSelection(false)}
        onConfirm={() => {
          const selection = {
            sectionVisibility: { ...bulkPdfSectionVisibility },
            identityMode: bulkPdfSectionVisibility.identity
              ? bulkPdfIdentityMode || "id"
              : null,
          };

          flushSync(() => {
            setShowBulkPdfSelection(false);
          });

          createBulkPdfHandler(selection);
        }}
      />

      {showPdfUpload && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 px-4 backdrop-blur-sm">
          <div className="w-full max-w-lg overflow-hidden rounded-3xl bg-white shadow-2xl">
            {/* Header */}
            <div className="flex items-start justify-between gap-4 border-b border-slate-200 px-6 py-4">
              <div className="min-w-0">
                <h3 className="text-base font-bold text-slate-800">
                  Upload saved PDF
                </h3>

                <p className="mt-1 text-xs leading-5 text-slate-500">
                  If you saved the PDF from the print window, upload it here to
                  store it in SharePoint.
                </p>
              </div>

              <button
                type="button"
                disabled={pdfUploading}
                onClick={closePdfUpload}
                className="
                  flex h-8 w-8 shrink-0 items-center justify-center
                  rounded-full !border-0 !bg-transparent
                  !p-0 !text-xl !font-normal !leading-none
                  !text-slate-400
                  transition
                  hover:!bg-slate-100 hover:!text-slate-700
                  disabled:cursor-not-allowed disabled:opacity-40
                "
                aria-label="Close PDF upload"
                title="Close"
              >
                ×
              </button>
            </div>

            {/* Body */}
            <div className="p-6">
              <label
                onDragEnter={(event) => {
                  if (pdfUploading) return;

                  event.preventDefault();
                  event.stopPropagation();
                  setPdfDragActive(true);
                }}
                onDragOver={(event) => {
                  if (pdfUploading) return;

                  event.preventDefault();
                  event.stopPropagation();
                  setPdfDragActive(true);
                }}
                onDragLeave={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  setPdfDragActive(false);
                }}
                onDrop={handlePdfDrop}
                className={[
                  "relative flex min-h-[230px] flex-col items-center justify-center",
                  "rounded-2xl border-2 border-dashed px-6 text-center transition",
                  pdfUploading
                    ? "cursor-default border-slate-200 bg-slate-50"
                    : pdfDragActive
                      ? "cursor-pointer border-[#365561] bg-[#365561]/5"
                      : "cursor-pointer border-slate-300 bg-slate-50 hover:border-[#365561]/60 hover:bg-slate-100",
                ].join(" ")}
              >
                <input
                  type="file"
                  accept=".pdf,application/pdf"
                  className="hidden"
                  disabled={pdfUploading}
                  onChange={(event) => {
                    const file = event.target.files?.[0];

                    selectPdfFile(file);

                    event.target.value = "";
                  }}
                />

                {pdfUploading ? (
                  /* Uploading state */
                  <div className="flex flex-col items-center justify-center">
                    <span
                      className="
                        h-10 w-10 animate-spin rounded-full
                        border-[3px] border-slate-200
                        border-t-[#365561]
                      "
                    />

                    <p className="mt-4 text-sm font-semibold text-slate-700">
                      Uploading PDF...
                    </p>

                    <p className="mt-1 text-xs text-slate-400">
                      Saving the file to SharePoint
                    </p>

                    {pdfFile?.name && (
                      <p className="mt-4 max-w-[320px] truncate text-xs font-medium text-slate-500">
                        {pdfFile.name}
                      </p>
                    )}
                  </div>
                ) : pdfFile ? (
                  /* Selected PDF state */
                  <>
                    <div className="relative mb-4 flex h-16 w-14 items-center justify-center">
                      <FileText
                        size={52}
                        strokeWidth={1.35}
                        className="text-[#365561]"
                      />

                      <span
                        className="
                          absolute -bottom-1 left-1/2
                          -translate-x-1/2
                          rounded-md bg-[#365561]
                          px-1.5 py-0.5
                          text-[8px] font-bold tracking-wide text-white
                        "
                      >
                        PDF
                      </span>
                    </div>

                    <p className="max-w-full break-all text-sm font-semibold text-slate-700">
                      {pdfFile.name}
                    </p>

                    <p className="mt-1 text-xs text-slate-400">
                      {(pdfFile.size / 1024 / 1024).toFixed(2)} MB
                    </p>

                    <p className="mt-4 text-xs font-semibold text-[#365561]">
                      Click or drop another PDF to replace it
                    </p>
                  </>
                ) : (
                  /* Empty state */
                  <>
                    <FileDown
                      size={36}
                      strokeWidth={1.5}
                      className="mb-3 text-[#365561]"
                    />

                    <p className="text-sm font-semibold text-slate-700">
                      Drag &amp; drop your PDF here
                    </p>

                    <p className="my-2 text-xs text-slate-400">
                      or
                    </p>

                    <span
                      className="
                        rounded-xl bg-[#365561]
                        px-4 py-2
                        text-xs font-semibold text-white shadow-sm
                      "
                    >
                      Select from computer
                    </span>

                    <p className="mt-4 text-[10px] text-slate-400">
                      One PDF file at a time
                    </p>
                  </>
                )}
              </label>
            </div>

            {/* Footer */}
            <div className="flex justify-end gap-2 border-t border-slate-200 bg-slate-50 px-6 py-3">
              <button
                type="button"
                disabled={pdfUploading}
                onClick={closePdfUpload}
                className="
                  rounded-xl
                  !border !border-slate-200
                  !bg-white
                  px-4 py-2
                  !text-sm !font-semibold !text-slate-600
                  transition
                  hover:!border-slate-300 hover:!bg-slate-100 hover:!text-slate-700
                  disabled:cursor-not-allowed disabled:opacity-40
                "
              >
                Skip
              </button>

              <button
                type="button"
                disabled={!pdfFile || pdfUploading}
                onClick={uploadPdfToSharePoint}
                className="
                  inline-flex min-w-[120px] items-center justify-center gap-2
                  rounded-xl
                  !border-0
                  !bg-[#365561]
                  px-4 py-2
                  !text-sm !font-semibold !text-white
                  transition
                  hover:!bg-[#2e4a54] hover:!text-white
                  disabled:cursor-not-allowed
                  disabled:!bg-slate-300 disabled:!text-white
                  disabled:opacity-100
                "
              >
                {pdfUploading && (
                  <span
                    className="
                      h-4 w-4 animate-spin rounded-full
                      border-2 border-white/40 border-t-white
                    "
                  />
                )}

                {pdfUploading ? "Uploading..." : "Upload"}
              </button>
            </div>
          </div>
        </div>
      )}

      {openSelection && (
        <SelectionInfoModal
          projectID={project_id}
          expertIDList={expertIds}
          setOpenSelection={setOpenSelection}
          apiType="newLink"
          setIsLinkCreated={setIsLinkCreated}
          getSummaryData={getSummaryData}
        />
      )}
      {openModifySelection && (
        <SelectionInfoModal
          projectID={project_id}
          expertIDList={expertIds}
          setOpenSelection={setOpenModifySelection}
          apiType="modifyInfo"
          setIsLinkCreated={setIsLinkCreated}
          getSummaryData={getSummaryData}
        />
      )}
      {addToExisting && (
        <SelectionInfoModal
          projectID={project_id}
          expertIDList={expertIds}
          setOpenSelection={setAddToExisting}
          apiType="addToExisting"
          setIsLinkCreated={setIsLinkCreated}
          getSummaryData={getSummaryData}
        />
      )}
    </>
  );
}

function ShareInfoToggle({ checked, onChange, icon, label, description }) {
  return (
    <button
      type="button"
      onClick={() => onChange(!checked)}
      className={[
        "flex items-center gap-3 rounded-2xl border px-3 py-2 text-left transition focus:outline-none",
        checked
          ? "border-[#365561]/30 bg-[#365561]/10 text-[#365561]"
          : "border-slate-200 bg-white text-slate-500 hover:border-slate-300 hover:bg-slate-50",
      ].join(" ")}
    >
      <span
        className={[
          "flex h-8 w-8 shrink-0 items-center justify-center rounded-xl",
          checked ? "bg-[#365561] text-white" : "bg-slate-100 text-slate-500",
        ].join(" ")}
      >
        <i className={icon} />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-semibold">{label}</span>
        <span className="block truncate text-xs opacity-70">{description}</span>
      </span>
      <span
        className={[
          "relative h-5 w-9 rounded-full transition",
          checked ? "bg-[#365561]" : "bg-slate-200",
        ].join(" ")}
      >
        <span
          className={[
            "absolute top-0.5 h-4 w-4 rounded-full bg-white shadow-sm transition",
            checked ? "left-4" : "left-0.5",
          ].join(" ")}
        />
      </span>
    </button>
  );
}

function SelectionInfoModal({ projectID, expertIDList, apiType, setOpenSelection, setIsLinkCreated, getSummaryData }) {
  const { API_URL } = useContext(UrlContext);

  const [hasLanguage, setHasLanguage] = useState(true);
  const [hasRegion, setHasRegion] = useState(true);
  const [hasMatching, setHasMatching] = useState(true);
  const [hasEducation, setHasEducation] = useState(true);
  const [hasScreening, setHasScreening] = useState(true);
  const [hasName, setHasName] = useState(true);
  const [hasLocation, setHasLocation] = useState(true);
  const [loadingSelection, setLoadingSelection] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);

  const modalCopy = {
    newLink: {
      title: "Create client environment",
      description: "Choose which profile information should be visible to the client.",
      confirmTitle: "Create client environment with selected profiles?",
      confirmText: "Create",
      endpoint: "create-link-for-client",
      successTitle: "Created!",
      successText: "Client environment has been created.",
      loadingText: "Creating client environment...",
    },
    modifyInfo: {
      title: "Modify shared information",
      description: "Adjust which fields are visible in the client environment.",
      confirmTitle: "Modify shared information selection?",
      confirmText: "Modify",
      endpoint: "modify-information-selection-for-client",
      successTitle: "Selection modified!",
      successText: "Shared information selection has been adjusted.",
      loadingText: "Updating shared information...",
    },
    addToExisting: {
      title: "Add to client environment",
      description: "Choose which information should be visible for the selected added profiles.",
      confirmTitle: "Add selected profiles to client environment?",
      confirmText: "Add",
      endpoint: "add-to-existing-link",
      successTitle: "Added!",
      successText: "Selected profiles have been added to the client environment.",
      loadingText: "Adding profiles to client environment...",
    },
  }[apiType] || {};

  const applyNullableBoolean = (value, fallback = false) => {
    if (value === null || value === undefined) return fallback;
    return value;
  };

  const getSlideData = async () => {
    setLoadingSelection(true);
    try {
      const response = await fetch(`${API_URL}fetch-selection-share-info`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ projectID }),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        const slideData = responseData.slideData || {};
        setHasLanguage(applyNullableBoolean(slideData.hasLanguage));
        setHasRegion(applyNullableBoolean(slideData.hasRegion));
        setHasEducation(applyNullableBoolean(slideData.hasEducation));
        setHasMatching(applyNullableBoolean(slideData.hasMatching));
        setHasScreening(applyNullableBoolean(slideData.hasScreening));
        setHasName(applyNullableBoolean(slideData.hasName));
        setHasLocation(applyNullableBoolean(slideData.hasLocation));
      } else {
        Swal.fire({ title: "Error!", text: responseData.text, icon: "error", confirmButtonText: "OK" });
      }
    } catch (error) {
      Swal.fire({ title: "Error!", text: "Unexpected error!", icon: "error", confirmButtonText: "OK" });
    } finally {
      setLoadingSelection(false);
    }
  };

  const getShareNameInfo = async () => {
    setLoadingSelection(true);
    try {
      const response = await fetch(`${API_URL}fetch-name-share-info`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ projectID }),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setHasName(applyNullableBoolean(responseData.nameShared));
        if (responseData.projectType === "exp") {
          setHasMatching(false);
          setHasEducation(false);
        }
      } else {
        Swal.fire({ title: "Error!", text: responseData.text, icon: "error", confirmButtonText: "OK" });
      }
    } catch (error) {
      Swal.fire({ title: "Error!", text: "Unexpected error!", icon: "error", confirmButtonText: "OK" });
    } finally {
      setLoadingSelection(false);
    }
  };

  useEffect(() => {
    if (apiType === "newLink") getShareNameInfo();
    else getSlideData();
  }, [apiType]);

  const runAction = async () => {
    const result = await Swal.fire({
      title: modalCopy.confirmTitle,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#365561",
      cancelButtonColor: "#d33",
      confirmButtonText: modalCopy.confirmText,
    });

    if (!result.isConfirmed) return;

    const requestBody = {
      projectID,
      expertList: expertIDList,
      hasEducation,
      hasLanguage,
      hasRegion,
      hasScreening,
      hasMatching,
      hasName,
      hasLocation,
    };

    setActionLoading(true);
    try {
      const tokenObj = localStorage.getItem("eph-token");
      const token = tokenObj ? JSON.parse(tokenObj)?.value : "";
      const response = await fetch(`${API_URL}${modalCopy.endpoint}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(apiType === "newLink" && token ? { "x-access-token": token } : {}),
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();

      if (responseData.status === "success") {
        if (apiType === "newLink") setIsLinkCreated?.(true);
        await getSummaryData?.(projectID);
        setActionLoading(false);
        setOpenSelection(false);
        Swal.fire({
          title: modalCopy.successTitle,
          text: responseData.text || modalCopy.successText,
          icon: "success",
          timer: 1600,
          timerProgressBar: true,
          showConfirmButton: false,
        });
      } else {
        setActionLoading(false);
        Swal.fire({ title: "Error!", text: responseData.text, icon: "error", confirmButtonText: "OK" });
      }
    } catch (error) {
      setActionLoading(false);
      Swal.fire({ title: "Error!", text: "Unexpected error!", icon: "error", confirmButtonText: "OK" });
    }
  };

  const options = [
    { key: "name", label: "Name", description: "Expert name visibility", icon: "fa-regular fa-id-badge", value: hasName, setValue: setHasName },
    { key: "language", label: "Language", description: "Language skills", icon: "fa-solid fa-language", value: hasLanguage, setValue: setHasLanguage },
    { key: "location", label: "Location", description: "Current location", icon: "fa-solid fa-location-dot", value: hasLocation, setValue: setHasLocation },
    { key: "region", label: "Region", description: "Regional experience", icon: "fa-solid fa-globe", value: hasRegion, setValue: setHasRegion },
    { key: "matching", label: "Matching", description: "Matching arguments", icon: "fa-solid fa-bullseye", value: hasMatching, setValue: setHasMatching },
    { key: "education", label: "Education", description: "Education details", icon: "fa-solid fa-graduation-cap", value: hasEducation, setValue: setHasEducation },
    { key: "screening", label: "Screening questions", description: "Screening answers", icon: "fa-regular fa-circle-question", value: hasScreening, setValue: setHasScreening },
  ];

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 z-[70] flex items-center justify-center bg-black/45 px-4 py-6 backdrop-blur-sm"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.div
          initial={{ y: 18, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 18, opacity: 0 }}
          transition={{ type: "spring", stiffness: 320, damping: 28 }}
          className="relative flex max-h-[88vh] w-full max-w-2xl flex-col overflow-hidden rounded-3xl bg-[radial-gradient(circle_at_top,rgba(54,85,97,0.16),transparent_35%),linear-gradient(to_bottom,#f8fafc,#eef2f6)] shadow-[0_24px_80px_rgba(15,23,42,0.32)]"
        >
          <div className="shrink-0 border-b border-slate-200/80 px-5 py-4">
            <div className="flex items-start justify-between gap-4">
              <div className="min-w-0">
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#365561]">Client environment</p>
                <h2 className="mt-1 text-xl font-semibold text-slate-900">{modalCopy.title}</h2>
                <p className="mt-1 text-sm text-slate-500">{modalCopy.description}</p>
              </div>
              <button
                type="button"
                disabled={actionLoading}
                className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-500 shadow-sm transition hover:bg-slate-50 hover:text-red-500 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
                onClick={() => setOpenSelection(false)}
              >
                <i className="fa-solid fa-xmark" />
              </button>
            </div>
          </div>

          <div className="min-h-0 flex-1 overflow-y-auto px-5 py-4">
            {loadingSelection ? (
              <div className="flex min-h-[260px] items-center justify-center text-[#365561]">
                <i className="fa-solid fa-spinner fa-spin text-3xl" />
              </div>
            ) : (
              <div className="grid gap-2 sm:grid-cols-2">
                {options.map((option) => (
                  <ShareInfoToggle
                    key={option.key}
                    checked={option.value}
                    onChange={option.setValue}
                    icon={option.icon}
                    label={option.label}
                    description={option.description}
                  />
                ))}
              </div>
            )}
          </div>

          <div className="shrink-0 rounded-b-3xl border-t border-slate-200 bg-white/80 px-5 py-3 backdrop-blur-xl">
            <div className="flex flex-col-reverse gap-2 sm:flex-row sm:items-center sm:justify-end">
              <button
                type="button"
                disabled={actionLoading}
                className="rounded-2xl border border-slate-200 bg-white px-4 py-2 text-xs font-semibold text-slate-600 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50 sm:text-sm"
                onClick={() => setOpenSelection(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                disabled={actionLoading || loadingSelection}
                className="rounded-2xl bg-[#365561] px-4 py-2 text-xs font-semibold text-white shadow-[0_10px_24px_rgba(54,85,97,0.22)] transition hover:bg-[#2c4650] disabled:cursor-wait disabled:opacity-60 sm:text-sm"
                onClick={runAction}
              >
                {actionLoading ? (
                  <span className="inline-flex items-center gap-2">
                    <i className="fa-solid fa-spinner fa-spin" /> Processing...
                  </span>
                ) : modalCopy.confirmText}
              </button>
            </div>
          </div>

          {actionLoading && <LoadingOverlay text={modalCopy.loadingText} />}
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}


// Contact information is shown in each profile's bottom info bar.
// Render the popover in a portal so it isn't clipped by the scrolling table.
const CONTACT_TYPES = {
  email: {
    label: "Email",
    Icon: Mail,
    // Outlook blue: matching blue border, light-blue background, blue icon.
    borderColor: "#BBDDF5",
    colors: "bg-[#EAF4FF] text-[#0078D4] hover:bg-[#DCEEFF]",
  },
  phone: {
    label: "Phone",
    Icon: Phone,
    // iPhone call green: matching green border, light-green background.
    borderColor: "#BCEBC9",
    colors: "bg-[#EAF9EF] text-[#34C759] hover:bg-[#D8F5E2]",
  },
  linkedin: {
    label: "LinkedIn",
    Icon: Linkedin,
    // LinkedIn blue: matching blue border, light-blue background.
    borderColor: "#BBD8FA",
    colors: "bg-[#EAF3FE] text-[#0A66C2] hover:bg-[#DAEBFF]",
  },
};

function safeLinkedInUrl(rawValue) {
  const value = String(rawValue || "").trim();
  if (!value) return "";

  try {
    const url = new URL(
      /^https?:\/\//i.test(value) ? value : `https://${value}`
    );
    const hostname = url.hostname.toLowerCase();
    // Avoid navigating to arbitrary or dangerous URLs stored in Expert.link.
    if (hostname !== "linkedin.com" && !hostname.endsWith(".linkedin.com")) {
      return "";
    }
    url.protocol = "https:";
    return url.href;
  } catch {
    return "";
  }
}

function ContactInfoButton({ type, value }) {
  const { label, Icon, colors, borderColor } = CONTACT_TYPES[type];
  const [isOpen, setIsOpen] = useState(false);
  const [copyStatus, setCopyStatus] = useState("");
  const [position, setPosition] = useState(null);
  const triggerRef = React.useRef(null);
  const popoverRef = React.useRef(null);
  const closeTimerRef = React.useRef(null);

  const rawValue = String(value || "").trim();
  const contactValue = type === "linkedin" ? safeLinkedInUrl(rawValue) : rawValue;
  const isAvailable = Boolean(contactValue);
  const canEmail = type === "email" && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contactValue);
  const linkHref = canEmail
    ? `mailto:${contactValue}`
    : type === "linkedin" && isAvailable
      ? contactValue
      : "";

  const scheduleClose = () => {
    window.clearTimeout(closeTimerRef.current);
    closeTimerRef.current = window.setTimeout(() => {
      setIsOpen(false);
      setPosition(null);
      setCopyStatus("");
    }, 180);
  };

  const showPopover = () => {
    window.clearTimeout(closeTimerRef.current);
    setIsOpen(true);
  };

  useEffect(() => () => window.clearTimeout(closeTimerRef.current), []);

  useEffect(() => {
    if (!isOpen) return;

    const placePopover = () => {
      const trigger = triggerRef.current;
      if (!trigger) return;
      const rect = trigger.getBoundingClientRect();
      const popoverWidth = popoverRef.current?.offsetWidth || 280;
      const popoverHeight = popoverRef.current?.offsetHeight || 92;
      const margin = 8;
      const left = Math.max(
        margin,
        Math.min(rect.left, window.innerWidth - popoverWidth - margin)
      );
      const top = rect.top >= popoverHeight + margin * 2
        ? rect.top - popoverHeight - margin
        : rect.bottom + margin;
      setPosition({ left, top });
    };

    placePopover();
    window.addEventListener("resize", placePopover);
    // Capture scroll events from the horizontally scrolling project-summary area too.
    window.addEventListener("scroll", placePopover, true);
    return () => {
      window.removeEventListener("resize", placePopover);
      window.removeEventListener("scroll", placePopover, true);
    };
  }, [isOpen, contactValue]);

  const copyValue = async () => {
    if (!isAvailable) return;
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(contactValue);
      } else {
        // Fallback for local development on non-HTTPS addresses.
        const textArea = document.createElement("textarea");
        textArea.value = contactValue;
        textArea.style.position = "fixed";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.select();
        const success = document.execCommand("copy");
        textArea.remove();
        if (!success) throw new Error("Copy failed");
      }
      setCopyStatus("copied");
    } catch {
      setCopyStatus("error");
    }
  };

  const triggerClasses = [
    // Fixed 20x20 size with zero padding: keeps the Excel-style row compact.
    // Avoid the generic `border` class: Bootstrap's `.border` may force a gray border with !important.
    "inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full transition-colors duration-150",
    isAvailable
      ? `${colors} focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#365561]`
      : "cursor-default bg-slate-100 text-slate-400",
  ].join(" ");

  const sharedTriggerProps = {
    ref: triggerRef,
    className: triggerClasses,
    // The inline border color is deliberate: it avoids Bootstrap's gray `.border` override
    // and does not rely on Tailwind discovering dynamic border-color classes.
    style: { border: `1px solid ${isAvailable ? borderColor : "#E2E8F0"}` },
    onMouseEnter: showPopover,
    onMouseLeave: scheduleClose,
    onFocus: showPopover,
    onBlur: scheduleClose,
    "aria-label": isAvailable ? `${label}: ${contactValue}` : `${label} not available`,
  };

  return (
    <>
      {linkHref ? (
        <a
          {...sharedTriggerProps}
          href={linkHref}
          target={type === "linkedin" ? "_blank" : undefined}
          rel={type === "linkedin" ? "noopener noreferrer" : undefined}
        >
          <Icon size={12} strokeWidth={2.2} aria-hidden="true" />
        </a>
      ) : (
        <button
          {...sharedTriggerProps}
          type="button"
          onClick={type === "phone" && isAvailable ? copyValue : undefined}
        >
          <Icon size={12} strokeWidth={2.2} aria-hidden="true" />
        </button>
      )}

      {isOpen && typeof document !== "undefined" && createPortal(
        <div
          ref={popoverRef}
          role="tooltip"
          className="fixed z-[10040] w-[280px] max-w-[calc(100vw-16px)] overflow-hidden rounded-2xl border border-slate-200/90 bg-white shadow-[0_20px_50px_rgba(15,23,42,0.16)] backdrop-blur-xl"
          style={{
            left: position?.left ?? 8,
            top: position?.top ?? 0,
            visibility: position ? "visible" : "hidden",
          }}
          onMouseEnter={showPopover}
          onMouseLeave={scheduleClose}
          onFocus={showPopover}
          onBlur={scheduleClose}
        >
          {/* Light teal-tinted heading, like the section selection modal. */}
          <div className="flex items-center gap-2 border-b border-[#365561]/15 bg-[linear-gradient(120deg,rgba(54,85,97,0.14),rgba(54,85,97,0.055))] px-3 py-2 text-[11px] font-bold text-[#365561]">
            <Icon size={12} strokeWidth={2.2} aria-hidden="true" />
            <span>{label}</span>
          </div>
          {/* Light body matching the navbar and section selection popup. */}
          <div className="flex items-center gap-2 bg-[linear-gradient(to_bottom,#f8fafc,#eef2f6)] px-3 py-3">
            <span className="min-w-0 flex-1 break-all text-xs leading-5 text-[#2c4650]">
              {isAvailable ? contactValue : "Not available"}
            </span>
            {isAvailable && (
              <button
                type="button"
                onClick={copyValue}
                className="inline-flex shrink-0 items-center gap-1 rounded-lg border border-[#365561]/20 bg-white px-2 py-1.5 text-[11px] font-semibold text-[#365561] shadow-sm transition-colors hover:bg-[#365561]/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#365561]"
                aria-label={`Copy ${label.toLowerCase()}`}
              >
                {copyStatus === "copied" ? (
                  <Check size={12} aria-hidden="true" />
                ) : (
                  <Copy size={12} aria-hidden="true" />
                )}
                {copyStatus === "copied"
                  ? "Copied"
                  : copyStatus === "error"
                    ? "Try again"
                    : "Copy"}
              </button>
            )}
          </div>
        </div>,
        document.body
      )}
    </>
  );
}

function SummaryBadge({ icon, label, className = "", isLeftEdge = false, isLastRow = false, isRightEdge = false, logData = [], expert_id, showFeedback, setShowFeedback, }) {
  const verticalClass = isLastRow
    ? "bottom-full mb-2"
    : "top-full mt-2";

  const horizontalClass = isLeftEdge
    ? "-left-1 translate-x-0"
    : isRightEdge
      ? "right-0 translate-x-0"
      : "left-1/2 -translate-x-1/2";

  const arrowVerticalClass = isLastRow
    ? "top-full -translate-y-1"
    : "bottom-full translate-y-1";

  const arrowHorizontalClass = isLeftEdge
    ? "left-2.5"
    : isRightEdge
      ? "right-3"
      : "left-1/2 -translate-x-1/2";

  return (
    <span
      className={[
        "group relative inline-flex h-5 items-center gap-1 overflow-visible rounded-full px-1.5 text-[10px] leading-none",
        className,
      ].join(" ")}
      onClick={() => {
        if (label==='Feedback from client') {
          setShowFeedback(!showFeedback);
        }
      }}
    >
      {label==='Client views' ? (
        <div className="relative flex flex-row items-center justify-end gap-1 text-[#365561] cursor-default">
          <i className={icon} />
          <span className="absolute bottom-2 left-4 text-xs">
            {
              logData.filter(
                (log) =>
                  log.expert === expert_id &&
                  log.detail === "Client opened profile"
              ).length
            }
          </span>
        </div>
      ) : (<i className={icon} />)}
      <span 
        className={[
          "pointer-events-none absolute z-[70] hidden whitespace-nowrap rounded-xl bg-slate-900 px-2 py-1 text-[10px] font-semibold text-white shadow-lg group-hover:block",
          verticalClass,
          horizontalClass,
        ].join(" ")}
      >
        {label}
        <span 
          className={[
            "absolute h-2 w-2 rotate-45 bg-slate-900",
            arrowVerticalClass,
            arrowHorizontalClass,
          ].join(" ")} 
        />
      </span>
    </span>
  );
}

function ClientFeedbackModal({ data, onClose }) {
  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 z-[150] flex items-center justify-center bg-black/45 px-4 py-6 backdrop-blur-sm"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          initial={{ y: 18, opacity: 0, scale: 0.98 }}
          animate={{ y: 0, opacity: 1, scale: 1 }}
          exit={{ y: 18, opacity: 0, scale: 0.98 }}
          transition={{ type: "spring", stiffness: 320, damping: 28 }}
          className="relative flex max-h-[88vh] w-full max-w-xl flex-col overflow-hidden rounded-3xl bg-[radial-gradient(circle_at_top,rgba(251,146,60,0.16),transparent_36%),linear-gradient(to_bottom,#ffffff,#f8fafc)] shadow-[0_24px_80px_rgba(15,23,42,0.32)]"
          onClick={(event) => event.stopPropagation()}
        >
          <div className="shrink-0 border-b border-slate-200/80 px-5 py-4">
            <div className="flex items-start justify-between gap-4">
              <div className="flex min-w-0 items-start gap-3">
                <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-orange-50 text-orange-600 shadow-sm">
                  <i className="fa-regular fa-message" />
                </span>
                <div className="min-w-0">
                  <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#365561]">
                    Client feedback
                  </p>
                  <h2 className="mt-1 truncate text-xl font-semibold text-slate-900">
                    {data?.expertName}
                  </h2>
                  <p className="mt-1 text-sm text-slate-500">
                    Feedback submitted by the client for this declined profile.
                  </p>
                </div>
              </div>

              <button
                type="button"
                className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-500 shadow-sm transition hover:bg-slate-50 hover:text-red-500 focus:outline-none"
                onClick={onClose}
                aria-label="Close feedback"
              >
                <i className="fa-solid fa-xmark" />
              </button>
            </div>
          </div>

          <div className="min-h-0 flex-1 space-y-3 overflow-y-auto px-5 py-4">
            <div className="rounded-3xl border border-slate-200 bg-white/85 p-4 shadow-sm">
              <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-slate-400">
                Reason
              </p>
              <p className="mt-2 text-sm leading-6 text-slate-700">
                {data?.reason || "No reason provided"}
              </p>
            </div>
            <div className="rounded-3xl border border-slate-200 bg-white/85 p-4 shadow-sm">
              <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-slate-400">
                Feedback
              </p>
              <p className="mt-2 text-sm leading-6 text-slate-700">
                {data?.feedbackToManager || "No feedback provided"}
              </p>
            </div>
          </div>

          <div className="shrink-0 rounded-b-3xl border-t border-slate-200 bg-white/80 px-5 py-3 backdrop-blur-xl">
            <div className="flex justify-end">
              <button
                type="button"
                className="rounded-2xl border border-slate-200 bg-white px-4 py-2 text-xs font-semibold text-slate-600 transition hover:bg-slate-50 sm:text-sm"
                onClick={onClose}
              >
                Close
              </button>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}

function getEventDate(event, point = "start") {
  const directValue = event?.[`${point}Time`] ?? event?.[point];

  if (directValue?.toDate && typeof directValue.toDate === "function") {
    return directValue.toDate();
  }

  if (directValue?.value) {
    return new Date(directValue.value);
  }

  if (directValue) {
    return new Date(directValue);
  }

  if (event?.date && event?.[point] !== undefined) {
    const hourValue = Number(event[point]);
    const hour = Math.floor(hourValue);
    const minute = Math.round((hourValue - hour) * 60);
    return new Date(
      `${event.date}T${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}:00`
    );
  }

  return null;
}

function getEventKey(event, index) {
  return event?.id || event?.eventID || `${event?.startTime || event?.start}-${event?.endTime || event?.end}-${index}`;
}

function getFutureSortedSlots(slotList = [], expertID = null) {
  const now = new Date();

  return (slotList || [])
    .filter((event) => (expertID ? eventBelongsToExpert(event, expertID) : true))
    .filter((event) => {
      const startDate = getEventDate(event, "start");
      return startDate && !Number.isNaN(startDate.getTime()) && startDate >= now;
    })
    .slice()
    .sort((a, b) => getEventDate(a, "start") - getEventDate(b, "start"));
}

function eventToDisplayParts(event) {
  const startDate = getEventDate(event, "start") || new Date();
  const endDate = getEventDate(event, "end") || startDate;

  return {
    weekday: new Intl.DateTimeFormat("en-GB", { weekday: "short" }).format(startDate),
    weekdayLong: new Intl.DateTimeFormat("en-GB", { weekday: "long" }).format(startDate),
    day: new Intl.DateTimeFormat("en-GB", { day: "2-digit" }).format(startDate),
    month: new Intl.DateTimeFormat("en-GB", { month: "short" }).format(startDate),
    monthLong: new Intl.DateTimeFormat("en-GB", { month: "long" }).format(startDate),
    year: new Intl.DateTimeFormat("en-GB", { year: "numeric" }).format(startDate),
    yearShort: new Intl.DateTimeFormat("en-GB", { year: "2-digit" }).format(startDate),
    startTime: new Intl.DateTimeFormat("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(startDate),
    endTime: new Intl.DateTimeFormat("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(endDate),
    timezone: event?.timezone || event?.timeZone || "Europe/Berlin",
  };
}

function eventToString(event) {
  const slot = eventToDisplayParts(event);
  return `${slot.weekdayLong}, ${slot.day} ${slot.monthLong} ${slot.year}, ${slot.startTime} – ${slot.endTime} (${slot.timezone})`;
}

function isRequestedCallSlot(event) {
  const directFlags = [
    event?.isRequested,
    event?.requested,
    event?.isCallRequested,
    event?.callRequested,
    event?.appointmentRequested,
    event?.requestCall,
    event?.clientRequested,
    event?.requestedByClient,
  ];

  if (directFlags.some((value) => value === true || value === "true" || value === "yes" || value === 1)) {
    return true;
  }

  const statusText = String(
    event?.status || event?.requestStatus || event?.appointmentStatus || event?.callStatus || ""
  ).toLowerCase();

  return statusText.includes("requested") || statusText.includes("pending");
}

function eventBelongsToExpert(event, expertID) {
  const eventExpertID = event?.expertID ?? event?.expertId ?? event?.expert_id ?? event?.consultantID ?? event?.consultantId;

  if (eventExpertID === undefined || eventExpertID === null || eventExpertID === "") {
    return true;
  }

  return String(eventExpertID) === String(expertID);
}

function AvailabilitySlotCard({ event, selected = false, requested = false, onClick, disabled = false }) {
  const slot = eventToDisplayParts(event);
  const isClickable = Boolean(onClick) && !disabled;

  return (
    <button
      type="button"
      onClick={isClickable ? () => onClick(event) : undefined}
      disabled={!isClickable}
      className={[
        "availability-card relative h-[82px] w-[85px] min-w-[85px] max-w-[85px] overflow-hidden rounded-xl border bg-[#365561]/5 text-left shadow-sm transition-all duration-150 focus:outline-none",
        isClickable ? "cursor-pointer hover:-translate-y-0.5 hover:shadow-md" : "cursor-default",
        selected ? "border-[#365561] ring-2 ring-[#365561]/30" : "border-[#365561]/20",
        requested ? "opacity-90" : "",
      ].join(" ")}
      aria-pressed={selected}
    >
      <div className="availability-card-top bg-[#365561] px-1 py-1 text-center text-[10px] font-semibold uppercase tracking-wide text-white">
        {slot.month} {slot.yearShort}
      </div>

      <div className="availability-card-body px-2 py-1 text-center">
        <div className="availability-day text-base font-bold leading-none text-[#365561]">
          {slot.day}
        </div>
        <div className="availability-weekday mt-0.5 text-[10px] font-semibold text-gray-700">
          {slot.weekday}
        </div>
        <div className="availability-time mt-0.5 truncate text-[10px] text-gray-500">
          {slot.startTime} - {slot.endTime}
        </div>
      </div>

      {selected && (
        <div className="slot-selected-overlay no-print absolute inset-0 z-[5] flex items-center justify-center bg-[#365561]/20 pointer-events-none">
          <div className="slot-selected-check flex h-7 w-7 items-center justify-center rounded-full bg-[#365561] text-lg font-extrabold leading-none text-white shadow-md">
            ✓
          </div>
        </div>
      )}

      {requested && (
        <div className="slot-selected-overlay no-print absolute inset-0 z-[5] flex items-center justify-center bg-[#365561]/20 pointer-events-none">
          <div className="whitespace-nowrap -rotate-45 text-xs font-semibold text-white/80">
            Call Requested
          </div>
        </div>
      )}
    </button>
  );
}

function AvailabilitySlotRow({ title, subtitle, slots = [], emptyText, onSlotClick, markRequested = false }) {
  return (
    <section className="rounded-3xl border border-slate-200 bg-white/80 p-4 shadow-sm">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
        <div>
          <p className="text-sm font-bold text-slate-800">{title}</p>
          {subtitle && <p className="mt-0.5 text-xs text-slate-500">{subtitle}</p>}
        </div>
        <span className="rounded-full bg-slate-100 px-2.5 py-1 text-xs font-semibold text-slate-500">
          {slots.length} future slot{slots.length === 1 ? "" : "s"}
        </span>
      </div>

      {slots.length > 0 ? (
        <div className="availability-grid grid w-full grid-cols-[repeat(auto-fill,85px)] gap-1.5 bg-white">
          {slots.map((event, index) => (
            <AvailabilitySlotCard
              key={getEventKey(event, index)}
              event={event}
              requested={markRequested && isRequestedCallSlot(event)}
              // disabled={markRequested && isRequestedCallSlot(event)}
              onClick={onSlotClick}
            />
          ))}
        </div>
      ) : (
        <div className="flex min-h-[96px] items-center justify-center rounded-2xl border border-dashed border-slate-200 bg-slate-50/80 px-4 text-center text-xs font-medium text-slate-400">
          {emptyText}
        </div>
      )}
    </section>
  );
}

function RequestCallModal({
  data,
  clientEvents = [],
  expertEvents = [],
  expertID,
  mediaLink,
  databaseLink,
  onClose,
  onOpenEmail,
  onSlotClick,
}) {
  const futureExpertEvents = getFutureSortedSlots(expertEvents, expertID);
  const futureClientEvents = getFutureSortedSlots(clientEvents);
  const requestedCount = futureExpertEvents.filter(isRequestedCallSlot).length;

  const profileImage = data?.profilePicture?.includes(mediaLink)
    ? data?.profilePicture
    : data?.profilePicture
      ? `${databaseLink}${data?.profilePicture}`
      : expertDefaultImg;

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 z-[70] flex items-center justify-center bg-black/45 px-4 py-6 backdrop-blur-sm"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          initial={{ y: 18, opacity: 0, scale: 0.98 }}
          animate={{ y: 0, opacity: 1, scale: 1 }}
          exit={{ y: 18, opacity: 0, scale: 0.98 }}
          transition={{ type: "spring", stiffness: 320, damping: 28 }}
          className="relative flex h-[calc(100vh-100px)] top-[35px] sm:h-[calc(88vh-100px)] w-full max-w-4xl flex-col overflow-hidden rounded-3xl bg-[radial-gradient(circle_at_top,rgba(54,85,97,0.16),transparent_35%),linear-gradient(to_bottom,#f8fafc,#eef2f6)] shadow-[0_24px_80px_rgba(15,23,42,0.32)]"
          onClick={(event) => event.stopPropagation()}
        >
          <div className="shrink-0 border-b border-slate-200/80 px-5 py-4">
            <div className="flex items-start justify-between gap-4">
              <div className="flex min-w-0 items-start gap-3">
                <img
                  src={profileImage}
                  onError={(event) => (event.currentTarget.src = expertDefaultImg)}
                  className="h-11 w-11 shrink-0 rounded-2xl border border-white object-cover shadow-sm"
                  alt="Profile"
                />
                <div className="min-w-0">
                  <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#365561]">
                    Client call request
                  </p>
                  <h2 className="mt-1 truncate text-xl font-semibold text-slate-900">
                    {data.expertName}
                  </h2>
                  <p className="mt-1 text-sm text-slate-500">
                    Review consultant and client availability. Expert slots use the same request state as the profile view.
                  </p>
                </div>
              </div>

              <div className="flex shrink-0 items-center gap-2">
                <button
                  type="button"
                  className="group relative inline-flex h-9 w-9 items-center justify-center overflow-visible rounded-2xl border border-slate-200 bg-white text-slate-500 shadow-sm transition hover:bg-slate-50 hover:text-[#365561] focus:outline-none"
                  onClick={onOpenEmail}
                  aria-label="Send email"
                >
                  <i className="fa-regular fa-envelope" />
                  <ToggleTooltip label="Send email with available slots" isRightEdge />
                </button>
                <button
                  type="button"
                  className="inline-flex h-9 w-9 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-500 shadow-sm transition hover:bg-slate-50 hover:text-red-500 focus:outline-none"
                  onClick={onClose}
                  aria-label="Close"
                >
                  <i className="fa-solid fa-xmark" />
                </button>
              </div>
            </div>

            <div className="mt-4 flex flex-wrap items-center gap-2 text-xs font-semibold">
              <span className="rounded-full bg-white px-3 py-1.5 text-slate-600 shadow-sm">
                {futureExpertEvents.length} expert slot{futureExpertEvents.length === 1 ? "" : "s"}
              </span>
              <span className="rounded-full bg-white px-3 py-1.5 text-slate-600 shadow-sm">
                {futureClientEvents.length} client slot{futureClientEvents.length === 1 ? "" : "s"}
              </span>
              {requestedCount > 0 && (
                <span className="rounded-full bg-[#365561] px-3 py-1.5 text-white shadow-sm">
                  {requestedCount} requested
                </span>
              )}
            </div>
          </div>

          <div className="min-h-0 flex-1 space-y-4 overflow-y-auto px-5 py-4">
            <AvailabilitySlotRow
              title="Expert availability"
              subtitle="Future consultant timeslots. Marked slots are selected by client for calls."
              slots={futureExpertEvents}
              emptyText="There are no future expert availability slots for this profile."
              onSlotClick={onSlotClick}
              markRequested
            />

            <AvailabilitySlotRow
              title="Client availability"
              subtitle="Future client availability slots saved for this project."
              slots={futureClientEvents}
              emptyText="There are no future client availability slots for this project."
              onSlotClick={onSlotClick}
            />
          </div>

          <div className="shrink-0 rounded-b-3xl border-t border-slate-200 bg-white/80 px-5 py-3 backdrop-blur-xl">
            <div className="flex flex-col-reverse gap-2 sm:flex-row sm:items-center sm:justify-between">
              <p className="text-xs text-slate-500">
                Clicking a future slot opens the calendar request flow with that time selected.
              </p>
              <button
                type="button"
                className="rounded-2xl border border-slate-200 bg-white px-4 py-2 text-xs font-semibold text-slate-600 transition hover:bg-slate-50 sm:text-sm"
                onClick={onClose}
              >
                Close
              </button>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}

function ExpertRow({
  data,
  index,
  proj_id,
  project,
  expert_id,
  appendExpertId,
  removeExpertId,
  backupData,
  setBackupData,
  events,
  logData,
  selectedExpertIds = []
}) {
  const { API_URL } = useContext(UrlContext);
  const mediaLink = "https://media.licdn.com/";
  const databaseLink = "https://images.expertpowerhouse.com";
  const [openCall, setOpenCall] = useState(false);
  const [appointmentExist, setAppointmentExist] = useState(null);

  const isLastRow = index === backupData.length - 1;


  const [exDigitalID, setExDigitalID] = useState("");
  const [, setExDigitalIDreturnSuccess] = useState(false);
  const [, setExDigitalIDreturnError] = useState(false);
  const [, setExDigitalIDloading] = useState(false);

  const [exRating1, setExRating1] = useState("");
  const [, setExRating1returnSuccess] = useState(false);
  const [, setExRating1returnError] = useState(false);
  const [, setExRating1loading] = useState(false);

  const [exRating2, setExRating2] = useState("");
  const [, setExRating2returnSuccess] = useState(false);
  const [, setExRating2returnError] = useState(false);
  const [, setExRating2loading] = useState(false);

  const [exRating3, setExRating3] = useState("");
  const [, setExRating3returnSuccess] = useState(false);
  const [, setExRating3returnError] = useState(false);
  const [, setExRating3loading] = useState(false);

  const [exRating4, setExRating4] = useState("");
  const [, setExRating4returnSuccess] = useState(false);
  const [, setExRating4returnError] = useState(false);
  const [, setExRating4loading] = useState(false);

  const [exRating5, setExRating5] = useState("");
  const [, setExRating5returnSuccess] = useState(false);
  const [, setExRating5returnError] = useState(false);
  const [, setExRating5loading] = useState(false);

  const [conCurrency, setConCurrency] = useState("");
  const [exDailyRateToEPH, setExDailyRateToEPH] = useState("");
  const [conBillingFrequency, setConBillingFrequency] = useState("");
  const [, setExDailyRateToEPHreturnSuccess] = useState(false);
  const [, setExDailyRateToEPHreturnError] = useState(false);
  const [, setExDailyRateToEPHloading] = useState(false);

  const [exAvailableComment, setExAvailableComment] = useState("");
  const [, setExAvailableCommentreturnSuccess] = useState(false);
  const [, setExAvailableCommentreturnError] = useState(false);
  const [, setExAvailableCommentloading] = useState(false);

  const [exCurrency, setExCurrency] = useState("");
  const [exDailyRate, setExDailyRate] = useState("");
  const [exBillingFrequency, setExBillingFrequency] = useState("");
  const [, setExCurrencyreturnSuccess] = useState(false);
  const [, setExCurrencyreturnError] = useState(false);
  const [, setExCurrencyloading] = useState(false);

  const [exFootNote, setExFootNote] = useState("");
  const [, setExFootNoteReturnSuccess] = useState(false);
  const [, setExFootNoteReturnError] = useState(false);
  const [, setExFootNoteLoading] = useState(false);

  const [exRatingPercentage, setExRatingPercentage] = useState(null);
  const [hideDeletedRow, setHideDeletedRow] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const toggleModal = () => setIsOpen(!isOpen);
  const [sortedEvents, setSortedEvents] = useState([]);
  const [openEmail, setOpenEmail] = useState(false);
  const [meetingStart, setMeetingStart] = useState(null);
  const [meetingEnd, setMeetingEnd] = useState(null);
  const [isSlotSelected, setIsSlotSelected] = useState(false);
  const [expertEmail, setExpertEmail] = useState("");
  const [user, setUser] = useState(null);
  const [isEditingConRate, setIsEditingConRate] = useState(false);
  const [isEditingClientRate, setIsEditingClientRate] = useState(false);
  const [defaultTemp, setDefaultTemp] = useState([]);
  const [showFeedback, setShowFeedback] = useState(false);
  const [expertEvents, setExpertEvents] = useState([]);

  useEffect(() => {
    setExDigitalID(data.expertDigitalID);
    setExRating1(data.rating1);
    setExRating2(data.rating2);
    setExRating3(data.rating3);
    setExRating4(data.rating4);
    setExRating5(data.rating5);
    setExDailyRateToEPH(data.dailyRateToEPH);
    setExAvailableComment(data.Available_comment);
    setExCurrency(data.projectCurrency);
    setExDailyRate(data.daily_rate);
    setExBillingFrequency(data.billingFrequency);
    setExFootNote(data.footNote);
    setExRatingPercentage(data.ratingPercentage);
    setAppointmentExist(data.eventExist);
    setConCurrency(data.conCurrency);
    setConBillingFrequency(data.conBillingFrequency);
    getEmailDetails();
  }, [data]);

  useEffect(() => {
    const rating1 = parseInt(exRating1);
    const rating2 = parseInt(exRating2);
    const rating3 = parseInt(exRating3);
    const rating4 = parseInt(exRating4);
    const rating5 = parseInt(exRating5);
    const ratingPercentage =
      (rating1 + rating2 + rating3 + rating4 + rating5) * 4 + "%";
    setExRatingPercentage(ratingPercentage);
  }, [exRating1, exRating2, exRating3, exRating4, exRating5]);

  const getExpertAvailabilitySlot = async () => {
    const requestBody = {
      expertID: data.expertID,
      projectID: proj_id,
    };
    try {
      let modifiedUrl = "get-expert-meeting-time-slot";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setExpertEvents(responseData.eventData);
      } else {
        console.error("Failed to add selected slot");
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
    }
  };

  useEffect(() => {
    getExpertAvailabilitySlot();
  }, []);

  useEffect(() => {
    const sorted = [...events].sort(
      (a, b) => new Date(a.startTime) - new Date(b.startTime)
    );
    setSortedEvents(sorted);
  }, [events]);

  useEffect(() => {
    if (user && events.length > 0) {
      const templates = getDefaultTemplate(events);
      setDefaultTemp(templates);
    }
  }, [user, expertEmail, events]);

  const saveExDigitalID = () => {
    setExDigitalIDreturnError(false);
    setExDigitalIDloading(true);
    const url = `${API_URL}save-ex-digital-id/` + proj_id + "/" + data.expertID;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ exDigitalID }),
    })
      .then((res) => res.json())
      .then((data) => {
        setExDigitalIDloading(false);
        if (data.status === "success") {
          setExDigitalIDreturnSuccess(true);
          setTimeout(() => {
            setExDigitalIDreturnSuccess(false);
          }, 1500);
          setBackupData(
            backupData.map((item) => {
              if (item.expertID === expert_id) {
                item.expertDigitalID = exDigitalID;
              }
              return item;
            })
          );
        } else {
          setExDigitalIDreturnError(true);
        }
      })
      .catch(() => {
        setExDigitalIDloading(false);
        setExDigitalIDreturnError(true);
      });
  };

  const saveExRating1 = () => {
    setExRating1returnError(false);
    setExRating1loading(true);
    const url = `${API_URL}save-ex-rating1/` + proj_id + "/" + data.expertID;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ exRating1 }),
    })
      .then((res) => res.json())
      .then((data) => {
        setExRating1loading(false);
        if (data.status === "success") {
          setExRating1returnSuccess(true);
          setTimeout(() => {
            setExRating1returnSuccess(false);
          }, 1500);
          setBackupData(
            backupData.map((item) => {
              if (item.expertID === expert_id) {
                item.rating1 = exRating1;
              }
              return item;
            })
          );
        } else {
          setExRating1returnError(true);
        }
      })
      .catch(() => {
        setExRating1loading(false);
        setExRating1returnError(true);
      });
  };

  const saveExRating2 = () => {
    setExRating2returnError(false);
    setExRating2loading(true);
    const url = `${API_URL}save-ex-rating2/` + proj_id + "/" + data.expertID;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ exRating2 }),
    })
      .then((res) => res.json())
      .then((data) => {
        setExRating2loading(false);
        if (data.status === "success") {
          setExRating2returnSuccess(true);
          setTimeout(() => {
            setExRating2returnSuccess(false);
          }, 1500);
          setBackupData(
            backupData.map((item) => {
              if (item.expertID === expert_id) {
                item.rating2 = exRating2;
              }
              return item;
            })
          );
        } else {
          setExRating2returnError(true);
        }
      })
      .catch(() => {
        setExRating2loading(false);
        setExRating2returnError(true);
      });
  };

  const saveExRating3 = () => {
    setExRating3returnError(false);
    setExRating3loading(true);
    const url = `${API_URL}save-ex-rating3/` + proj_id + "/" + data.expertID;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ exRating3 }),
    })
      .then((res) => res.json())
      .then((data) => {
        setExRating3loading(false);
        if (data.status === "success") {
          setExRating3returnSuccess(true);
          setTimeout(() => {
            setExRating3returnSuccess(false);
          }, 1500);
          setBackupData(
            backupData.map((item) => {
              if (item.expertID === expert_id) {
                item.rating3 = exRating3;
              }
              return item;
            })
          );
        } else {
          setExRating3returnError(true);
        }
      })
      .catch(() => {
        setExRating3loading(false);
        setExRating3returnError(true);
      });
  };

  const saveExRating4 = () => {
    setExRating4returnError(false);
    setExRating4loading(true);
    const url = `${API_URL}save-ex-rating4/` + proj_id + "/" + data.expertID;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ exRating4 }),
    })
      .then((res) => res.json())
      .then((data) => {
        setExRating4loading(false);
        if (data.status === "success") {
          setExRating4returnSuccess(true);
          setTimeout(() => {
            setExRating4returnSuccess(false);
          }, 1500);
          setBackupData(
            backupData.map((item) => {
              if (item.expertID === expert_id) {
                item.rating4 = exRating4;
              }
              return item;
            })
          );
        } else {
          setExRating4returnError(true);
        }
      })
      .catch(() => {
        setExRating4loading(false);
        setExRating4returnError(true);
      });
  };

  const saveExRating5 = () => {
    setExRating5returnError(false);
    setExRating5loading(true);
    const url = `${API_URL}save-ex-rating5/` + proj_id + "/" + data.expertID;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ exRating5 }),
    })
      .then((res) => res.json())
      .then((data) => {
        setExRating5loading(false);
        if (data.status === "success") {
          setExRating5returnSuccess(true);
          setTimeout(() => {
            setExRating5returnSuccess(false);
          }, 1500);
          setBackupData(
            backupData.map((item) => {
              if (item.expertID === expert_id) {
                item.rating5 = exRating5;
              }
              return item;
            })
          );
        } else {
          setExRating5returnError(true);
        }
      })
      .catch(() => {
        setExRating5loading(false);
        setExRating5returnError(true);
      });
  };

  const saveExDailyRateToEPH = () => {
    setExDailyRateToEPHreturnError(false);
    setExDailyRateToEPHloading(true);
    const url =
      `${API_URL}save-ex-daily-rate-to-eph/` + proj_id + "/" + data.expertID;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ exDailyRateToEPH }),
    })
      .then((res) => res.json())
      .then((data) => {
        setExDailyRateToEPHloading(false);
        if (data.status === "success") {
          setExDailyRateToEPHreturnSuccess(true);
          setTimeout(() => {
            setExDailyRateToEPHreturnSuccess(false);
          }, 1500);
          setBackupData(
            backupData.map((item) => {
              if (item.expertID === expert_id) {
                item.dailyRateToEPH = exDailyRateToEPH;
              }
              return item;
            })
          );
        } else {
          setExDailyRateToEPHreturnError(true);
        }
      })
      .catch(() => {
        setExDailyRateToEPHloading(false);
        setExDailyRateToEPHreturnError(true);
      });
  };

  const saveConCurrency = (value) => {
    setExDailyRateToEPHreturnError(false);
    setExDailyRateToEPHloading(true);
    const url =
      `${API_URL}save-consultant-currency/` + proj_id + "/" + data.expertID;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ conCurrency: value }),
    })
      .then((res) => res.json())
      .then((data) => {
        setExDailyRateToEPHloading(false);
        if (data.status === "success") {
          setExDailyRateToEPHreturnSuccess(true);
          setTimeout(() => {
            setExDailyRateToEPHreturnSuccess(false);
          }, 1500);
          setBackupData(
            backupData.map((item) => {
              if (item.expertID === expert_id) {
                item.conCurrency = value;
              }
              return item;
            })
          );
        } else {
          setExDailyRateToEPHreturnError(true);
        }
      })
      .catch(() => {
        setExDailyRateToEPHloading(false);
        setExDailyRateToEPHreturnError(true);
      });
  };

  const saveConBillingFrequency = (value) => {
    setExDailyRateToEPHreturnError(false);
    setExDailyRateToEPHloading(true);
    const url =
      `${API_URL}save-consultant-billing-frequency/` +
      proj_id +
      "/" +
      data.expertID;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ conBillingFrequency: value }),
    })
      .then((res) => res.json())
      .then((data) => {
        setExDailyRateToEPHloading(false);
        if (data.status === "success") {
          setExDailyRateToEPHreturnSuccess(true);
          setTimeout(() => {
            setExDailyRateToEPHreturnSuccess(false);
          }, 1500);
          setBackupData(
            backupData.map((item) => {
              if (item.expertID === expert_id) {
                item.conCurrency = value;
              }
              return item;
            })
          );
        } else {
          setExDailyRateToEPHreturnError(true);
        }
      })
      .catch(() => {
        setExDailyRateToEPHloading(false);
        setExDailyRateToEPHreturnError(true);
      });
  };

  const saveExAvailableComment = () => {
    setExAvailableCommentreturnError(false);
    setExAvailableCommentloading(true);
    const url =
      `${API_URL}save-ex-available-comment/` + proj_id + "/" + data.expertID;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ exAvailableComment }),
    })
      .then((res) => res.json())
      .then((data) => {
        setExAvailableCommentloading(false);
        if (data.status === "success") {
          setExAvailableCommentreturnSuccess(true);
          setTimeout(() => {
            setExAvailableCommentreturnSuccess(false);
          }, 1500);
          setBackupData(
            backupData.map((item) => {
              if (item.expertID === expert_id) {
                item.Available_comment = exAvailableComment;
              }
              return item;
            })
          );
        } else {
          setExAvailableCommentreturnError(true);
        }
      })
      .catch(() => {
        setExAvailableCommentloading(false);
        setExAvailableCommentreturnError(true);
      });
  };

  const saveExCurrency = (exCurrency) => {
    setExCurrencyreturnError(false);
    setExCurrencyloading(true);
    const url = `${API_URL}save-ex-currency/` + proj_id + "/" + data.expertID;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ exCurrency }),
    })
      .then((res) => res.json())
      .then((data) => {
        setExCurrencyloading(false);
        if (data.status === "success") {
          setExCurrencyreturnSuccess(true);
          setTimeout(() => {
            setExCurrencyreturnSuccess(false);
          }, 1500);
          setBackupData(
            backupData.map((item) => {
              if (item.expertID === expert_id) {
                item.projectCurrency = exCurrency;
              }
              return item;
            })
          );
        } else {
          setExCurrencyreturnError(true);
        }
      })
      .catch(() => {
        setExCurrencyloading(false);
        setExCurrencyreturnError(true);
      });
  };

  const saveExDailyRate = () => {
    setExCurrencyreturnError(false);
    setExCurrencyloading(true);
    const url = `${API_URL}save-ex-daily-rate/` + proj_id + "/" + data.expertID;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ exDailyRate }),
    })
      .then((res) => res.json())
      .then((data) => {
        setExCurrencyloading(false);
        if (data.status === "success") {
          setExCurrencyreturnSuccess(true);
          setTimeout(() => {
            setExCurrencyreturnSuccess(false);
          }, 1500);
          setBackupData(
            backupData.map((item) => {
              if (item.expertID === expert_id) {
                item.daily_rate = exDailyRate;
              }
              return item;
            })
          );
        } else {
          setExCurrencyreturnError(true);
        }
      })
      .catch(() => {
        setExCurrencyloading(false);
        setExCurrencyreturnError(true);
      });
  };

  const saveExBillingFrequency = (exBillingFrequency) => {
    setExCurrencyreturnError(false);
    setExCurrencyloading(true);
    const url =
      `${API_URL}save-ex-billing-frequency/` + proj_id + "/" + data.expertID;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ exBillingFrequency }),
    })
      .then((res) => res.json())
      .then((data) => {
        setExCurrencyloading(false);
        if (data.status === "success") {
          setExCurrencyreturnSuccess(true);
          setTimeout(() => {
            setExCurrencyreturnSuccess(false);
          }, 1500);
          setBackupData(
            backupData.map((item) => {
              if (item.expertID === expert_id) {
                item.billingFrequency = exBillingFrequency;
              }
              return item;
            })
          );
        } else {
          setExCurrencyreturnError(true);
        }
      })
      .catch(() => {
        setExCurrencyloading(false);
        setExCurrencyreturnError(true);
      });
  };

  const saveExFootNote = (exFootNote) => {
    setExFootNoteReturnError(false);
    setExFootNoteLoading(true);
    const url = `${API_URL}save-ex-foot-note/` + proj_id + "/" + data.expertID;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ exFootNote }),
    })
      .then((res) => res.json())
      .then((data) => {
        setExFootNoteLoading(false);
        if (data.status === "success") {
          setExFootNoteReturnSuccess(true);
          setTimeout(() => {
            setExFootNoteReturnSuccess(false);
          }, 1500);
          setBackupData(
            backupData.map((item) => {
              if (item.expertID === expert_id) {
                item.footNote = exFootNote;
              }
              return item;
            })
          );
        } else {
          setExFootNoteReturnError(true);
        }
      })
      .catch(() => {
        setExFootNoteLoading(false);
        setExFootNoteReturnError(true);
      });
  };

  const handleProfileDelete = async () => {
    const result = await Swal.fire({
      icon: "warning",
      title: "Remove profile?",
      html: "<p>This profile will be removed from the project summary.</p><p class='mt-1 text-sm text-slate-500'>This action cannot be undone from this page.</p>",
      showCancelButton: true,
      confirmButtonText: "Remove",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#64748b",
      reverseButtons: true,
      focusCancel: true,
    });

    if (!result.isConfirmed) return;

    Swal.fire({
      title: "Removing profile...",
      text: "Please wait while the profile is removed.",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => Swal.showLoading(),
    });

    const url =
      `${API_URL}prjsumm-delete-profile/` + proj_id + "/" + data.expertID;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const responseData = await response.json();

      if (responseData.status === "success") {
        setHideDeletedRow(true);
        Swal.fire({
          icon: "success",
          title: "Profile removed",
          text: "Profile has been removed successfully.",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Could not remove profile",
          text: responseData.text || "Something went wrong!",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Could not remove profile",
        text: "Something went wrong!",
      });
    }
  };

  if (hideDeletedRow) {
    return null;
  }

  const eventToString = (selectedEvent) => {
    const date = new Date(selectedEvent.startTime);
    const endDate = new Date(selectedEvent.endTime);

    return {
      weekday: new Intl.DateTimeFormat("en-GB", { weekday: "long" }).format(
        date
      ),
      day: new Intl.DateTimeFormat("en-GB", { day: "2-digit" }).format(date),
      month: new Intl.DateTimeFormat("en-GB", { month: "long" }).format(date),
      year: new Intl.DateTimeFormat("en-GB", { year: "numeric" }).format(date),
      startTime: new Intl.DateTimeFormat("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }).format(date),
      endTime: new Intl.DateTimeFormat("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }).format(endDate),
      timezone: selectedEvent.timezone,
    };
  };

  // const convertToEventSlot = (selectedEvent) => {
  //   const startDate = new Date(selectedEvent.startTime);
  //   const endDate = new Date(selectedEvent.endTime);

  //   const formatDateTime = (date) => {
  //     const pad = (n) => String(n).padStart(2, '0');
  //     return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  //   };

  //   return {
  //     startDateTime: formatDateTime(startDate),
  //     endDateTime: formatDateTime(endDate),
  //   };
  // };

  const convertToEventSlot = (selectedEvent) => {
    const startDate = new Date(selectedEvent.startTime);
    const endDate = new Date(selectedEvent.endTime);

    const formatDateTime = (date) => {
      const pad = (n) => String(n).padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
        date.getSeconds()
      )}`;
    };

    return {
      startDateTime: formatDateTime(startDate),
      endDateTime: formatDateTime(endDate),
    };
  };

  const handleCalendarOpen = (selectedEvent) => {
    console.log("selected event: ", selectedEvent);
    const eventTimes = convertToEventSlot(selectedEvent);
    setMeetingStart(eventTimes.startDateTime);
    setMeetingEnd(eventTimes.endDateTime);
    setIsOpen(false);
    setIsSlotSelected(true);
  };

  const sortEvents = (events) => {
    const sorted = [...events].sort(
      (a, b) => new Date(a.startTime) - new Date(b.startTime)
    );
    return sorted;
  };

  // Get current user
  const getEmailDetails = async () => {
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    try {
      const response = await fetch(`${API_URL}get-email-details`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token,
          expertID: data.expertID,
        }),
      });

      if (response.status === 200) {
        const result = await response.json();
        if (result.status === "success") {
          setUser(result.user);
          setExpertEmail(result.expert.email);
        }
      } else {
        console.log("Response error!");
      }
    } catch (error) {
      console.log("error while fetching current user!");
    }
  };


  // const getDefaultTemplate = (events) => {
  //   const sortedEvents = sortEvents(events);
  //   const slotItems = sortedEvents
  //     .map((event) => {
  //       const slot = eventToString(event);
  //       return `<li>${slot.weekday}, ${slot.day} ${slot.month} ${slot.year}, ${slot.startTime} – ${slot.endTime} (${slot.timezone})</li>`;
  //     })
  //     .join("");

  //   const templates = generateTemplates(data.expertName, user.name, slotItems);

  //   return templates;
  // };

  const getDefaultTemplate = (events) => {
    const sortedEvents = sortEvents(events);

    const now = new Date();
    const futureEvents = sortedEvents.filter((event) => {
      const eventDate = new Date(event.startTime);
      return eventDate >= now;
    });

    let slotItems;
    if (futureEvents.length > 0) {
      slotItems = futureEvents
        .map((event) => {
          const slot = eventToString(event);
          return `<li>${slot.weekday}, ${slot.day} ${slot.month} ${slot.year}, ${slot.startTime} – ${slot.endTime} (${slot.timezone})</li>`;
        })
        .join("");
    } else {
      slotItems = `<li><em>There are no future timeslots provided by the client.</em></li>`;
    }

    const templates = generateTemplates(data.expertName, user.name, slotItems);

    return templates;
  };

  const generateTemplates = (expertName, userName, slotsHTML) => [
    {
      lang: "en",
      label: "English",
      name: "Client timeslots for call",
      subject: "expertpowerhouse | Client call",
      value: `
        <div>Dear ${expertName},</div>
        <div><br></div>
        <div>The client is interested in your profile and would like to schedule a discussion. They are suggesting the following slots:</div>
        <ul>${slotsHTML}</ul>
        <div>Does one of the above fit?</div>
        <div><br></div>
        <div>Once confirmed, we will set up the discussion via Teams.</div>
        <div><br></div>
        <div>Best regards,</div>
        <div>${userName}</div>
      `,
    },
    {
      lang: "de",
      label: "German",
      name: "Zeitvorschläge für das Kundengespräch",
      subject: "expertpowerhouse | Client call",
      value: `
        <div>Sehr geehrte/r ${expertName},</div>
        <div><br></div>
        <div>Der Kunde möchte ein Gespräch führen. Hier sind die möglichen Zeiten:</div>
        <ul>${slotsHTML}</ul>
        <div>Bitte teilen Sie uns mit, ob einer der Termine passt.</div>
        <div><br></div>
        <div>Wir setzen dann ein Gespräch per Teams auf und schicken entsprechende Einwahldaten.</div>
        <div><br></div>
        <div>Mit freundlichen Grüßen,</div>
        <div>${userName}</div>
      `,
    },
  ];

  // useEffect(() => {
  //   if (data.isDeclined) {
  //     setIsShaking(true);
  //     const timer = setTimeout(() => setIsShaking(false), 1000);
  //     return () => clearTimeout(timer);
  //   }
  // }, [data.isDeclined]);

  const ratingValues = [exRating1, exRating2, exRating3, exRating4, exRating5];
  const ratingSetters = [setExRating1, setExRating2, setExRating3, setExRating4, setExRating5];
  const ratingSavers = [saveExRating1, saveExRating2, saveExRating3, saveExRating4, saveExRating5];

  const badges = [
    data.sharedWithClient === "yes" && {
      icon: "fa-regular fa-file-powerpoint",
      label: "PowerPoint generated",
      className: "bg-orange-50 text-orange-700",
    },
    data.sharedViaLink && {
      icon: "fa-solid fa-share-nodes",
      label: "Shared via link",
      className: "bg-blue-50 text-blue-700",
    },
    data.isSelected && {
      icon: "fa-solid fa-star",
      label: "Shortlisted",
      className: "bg-emerald-50 text-emerald-700",
    },
    data.removedFromClient && {
      icon: "fa-solid fa-user-slash",
      label: "Removed from client environment",
      className: "bg-rose-50 text-rose-700",
    },
    data.isCallRequested && {
      icon: "fa-solid fa-phone-volume",
      label: "Call requested",
      className: "bg-[#365561]/10 text-[#365561]",
    },
    data.isDeclined && {
      icon: "fa-solid fa-ban",
      label: "Declined",
      className: "bg-red-50 text-red-700",
    },
    data.isDeclined && {
      icon: "fa-solid fa-message",
      label: "Feedback from client",
      className: "bg-orange-50 text-orange-700 cursor-pointer",
    },
    data.sharedViaLink && {
      icon: "fa-solid fa-eye",
      label: "Client views",
      className: "bg-[#365561]/10 text-[#365561]",
    },
  ].filter(Boolean);

  return (
    <>
      <div
        className="grid min-w-[1340px] items-start gap-2 border-b border-slate-200 px-3 py-2 text-sm relative overflow-visible transition hover:bg-slate-50/60"
        style={{ gridTemplateColumns: rowGridTemplateColumns }}
      >
        {(data.isSelected || data.isDeclined) && (
          <div
            className="pointer-events-none absolute inset-y-0 left-0 z-0 w-[350px]"
            style={{
              background: data.isDeclined
                ? "linear-gradient(90deg, rgba(244,63,94,0.34) 0%, rgba(244,63,94,0.16) 48%, rgba(244,63,94,0) 100%)"
                : "linear-gradient(90deg, rgba(16,185,129,0.34) 0%, rgba(16,185,129,0.16) 48%, rgba(16,185,129,0) 100%)",
            }}
          />
        )}
        {/* Name */}
        <div className="flex flex-col min-w-0 pr-2">
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={selectedExpertIds.some((id) => String(id) === String(data.expertID))}
              onChange={(e) =>
                e.target.checked
                  ? appendExpertId(data.expertID)
                  : removeExpertId(data.expertID)
              }
              className="h-4 w-4 rounded-full border-slate-300 accent-[#365561]"
            />
            <a
              href={`/app/PreviewDigitalPPT/${proj_id}/${data.expertID}/null`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#365561] font-semibold hover:no-underline"
            >
              {data.expertName}
            </a>
            {data.isCallRequested && (
              <i
                className="fa-solid fa-phone-volume fa-shake cursor-pointer text-[#365561]"
                onClick={toggleModal}
              ></i>
            )}
          </div>
          {/* Bottom info bar — preserve its original bottom positioning and spacing. */}
          <div className="absolute bottom-2 flex flex-row items-center gap-2">
            <div className="flex flex-wrap items-center gap-1.5">
              <ContactInfoButton type="email" value={data.expertEmail || expertEmail} />
              <ContactInfoButton type="phone" value={data.expertPhone} />
              <ContactInfoButton type="linkedin" value={data.expertLinkedIn} />
              {badges.length > 0 && (
                <span
                  role="separator"
                  aria-orientation="vertical"
                  className="mx-0.5 h-4 w-px shrink-0 rounded-full bg-[#365561]/30"
                />
              )}
              {badges.map((badge) => (
                <SummaryBadge
                  key={badge.label}
                  icon={badge.icon}
                  label={badge.label}
                  className={badge.className}
                  isLeftEdge={false}
                  isRightEdge={false}
                  isLastRow={isLastRow}
                  logData={logData}
                  expert_id={expert_id}
                  showFeedback={showFeedback}
                  setShowFeedback={setShowFeedback}
                />
              ))}
            </div>
          </div>
        </div>

        {/* ID */}
        <div className="flex items-center justify-center">
          <span className="mr-1 -mt-[1px]">
            {project.projectType === "exp" ? "EPH_EXP_" : "EPH_CON_"}
          </span>
          <input
            type="text"
            value={exDigitalID}
            placeholder="ID#"
            maxLength={3}
            onChange={(e) => setExDigitalID(e.target.value)}
            onBlur={saveExDigitalID}
            className="border-b text-sm w-[25px] focus:outline-none"
          />
        </div>

        {/* Dimensions */}
        {ratingValues.map((val, i) => (
          <input
            key={i}
            type="number"
            className="w-[50px] shrink-0 border-b text-center"
            value={val}
            onChange={(e) => {
              const v = e.target.value;
              if (v >= 0 && v <= 5) ratingSetters[i](v);
            }}
            onBlur={() => ratingSavers[i]()}
          />
        ))}

        {/* In % */}
        <div className="text-center">
          {exRatingPercentage}
        </div>

        {/* Consultant rate */}
        <div
          className={`flex min-w-0 items-center justify-center ${
            isEditingConRate ? "" : "cursor-pointer"
          }`}
        >
          {!isEditingConRate ? (
            <div
              className="flex items-center gap-1 text-sm truncate group"
              onClick={() => {
                if (!isEditingConRate) setIsEditingConRate(true);
              }}
            >
              <span className="text-gray-700">{conCurrency || "---"}</span>
              <span className="text-gray-800">{exDailyRateToEPH || "0"}</span>
              <span className="text-gray-600 text-xs">
                / {conBillingFrequency?.replace("per ", "") || "--"}
              </span>
              {/* Tooltip */}
              <div className="absolute -top-6 mt-1 w-max bg-black text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition pointer-events-none">
                Click to edit consultant rate
              </div>
            </div>
          ) : (
            <div className="flex justify-center items-center gap-1 w-full">
              <div className="flex items-center gap-1">
                <div className="relative">
                  <select
                    className="w-[50px] cursor-pointer text-sm focus:outline-none"
                    value={conCurrency}
                    onChange={(e) => {
                      setConCurrency(e.target.value);
                      saveConCurrency(e.target.value);
                    }}
                  >
                    <option value="">---</option>
                    <option value="EUR">EUR</option>
                    <option value="USD">USD</option>
                    <option value="GBP">GBP</option>
                    <option value="CHF">CHF</option>
                    <option value="AUD">AUD</option>
                    <option value="AED">AED</option>
                    <option value="INR">INR</option>
                  </select>
                </div>

                <input
                  type="text"
                  // autoFocus
                  className="flex-1 max-w-[90px] border-b text-sm bg-gray-100 px-1"
                  value={exDailyRateToEPH}
                  onChange={(e) => setExDailyRateToEPH(e.target.value)}
                  onBlur={() => {
                    saveExDailyRateToEPH();
                    setIsEditingConRate(false);
                  }}
                />

                <select
                  className="w-[50px] text-sm focus:outline-none cursor-pointer"
                  value={conBillingFrequency}
                  onChange={(e) => {
                    setConBillingFrequency(e.target.value);
                    saveConBillingFrequency(e.target.value);
                  }}
                  onBlur={() => setIsEditingConRate(false)}
                >
                  <option value="">---</option>
                  <option value="per hour">hour</option>
                  <option value="per day">day</option>
                  <option value="per month">month</option>
                </select>
              </div>
            </div>
          )}
        </div>

        {/* Client rate */}
        <div className="relative flex min-w-0 items-center justify-center">
          {!isEditingClientRate ? (
            <div className="flex flex-col items-center justify-center w-full">
              <div
                className="flex items-center gap-1 text-sm truncate cursor-pointer group"
                onClick={() => {
                  if (!isEditingClientRate) setIsEditingClientRate(true);
                }}
              >
                <span className="text-gray-700">{exCurrency || "---"}</span>
                <span className="text-gray-800">{exDailyRate || "0"}</span>
                <span className="text-gray-600 text-xs">
                  / {exBillingFrequency?.replace("per ", "") || "--"}
                </span>

                {/* Tooltip */}
                <div className="absolute -top-8 mt-1 w-max bg-black text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition pointer-events-none">
                  Click to edit client rate
                </div>
              </div>

              <div className="absolute top-full flex items-center space-x-1 mt-[10px]">
                <input
                  type="checkbox"
                  checked={exFootNote === "yes"}
                  onChange={(e) => {
                    setExFootNote(e.target.checked ? "yes" : "no");
                    saveExFootNote(e.target.checked ? "yes" : "no");
                  }}
                  className="accent-[#365561]"
                />
                <label className="text-xs mt-2">
                  *rate includes EPH service
                </label>
              </div>
            </div>
          ) : (
            <div className="flex flex-col justify-center items-center w-full">
              <div className="flex items-center gap-1">
                <div className="relative">
                  <select
                    className="w-[50px] cursor-pointer text-sm focus:outline-none"
                    value={exCurrency}
                    onChange={(e) => {
                      setExCurrency(e.target.value);
                      saveExCurrency(e.target.value);
                    }}
                  >
                    <option value="">---</option>
                    <option value="EUR">EUR</option>
                    <option value="USD">USD</option>
                    <option value="GBP">GBP</option>
                    <option value="CHF">CHF</option>
                    <option value="AUD">AUD</option>
                    <option value="AED">AED</option>
                    <option value="INR">INR</option>
                  </select>
                </div>

                <input
                  type="text"
                  className="flex-1 max-w-[90px] border-b text-sm bg-gray-100 px-1"
                  value={exDailyRate}
                  onChange={(e) => setExDailyRate(e.target.value)}
                  onBlur={() => {
                    saveExDailyRate();
                    setIsEditingClientRate(false);
                  }}
                />

                <select
                  className="w-[50px] text-sm focus:outline-none cursor-pointer"
                  value={exBillingFrequency}
                  onChange={(e) => {
                    setExBillingFrequency(e.target.value);
                    saveExBillingFrequency(e.target.value);
                  }}
                  onBlur={() => setIsEditingClientRate(false)}
                >
                  <option value="">---</option>
                  <option value="per hour">hour</option>
                  <option value="per day">day</option>
                  <option value="per month">month</option>
                </select>
              </div>

              <div className="absolute top-full flex items-center space-x-1 mt-[10px]">
                <input
                  type="checkbox"
                  checked={exFootNote === "yes"}
                  onChange={(e) => {
                    setExFootNote(e.target.checked ? "yes" : "no");
                    saveExFootNote(e.target.checked ? "yes" : "no");
                  }}
                  className="accent-[#365561]"
                />
                <label className="text-xs mt-2">
                  *rate includes EPH service
                </label>
              </div>
            </div>
          )}
        </div>

        {/* Availability */}
        <div className="min-w-0">
          <textarea
            className="w-full border rounded px-2 py-1 text-sm resize-none"
            value={exAvailableComment}
            onChange={(e) => setExAvailableComment(e.target.value)}
            onBlur={saveExAvailableComment}
          />
        </div>

        {/* Call icon + delete */}
        <div className="flex flex-col items-center gap-2 relative">
          <button
            onClick={() => setOpenCall(true)}
            className="flex items-center justify-center focus:outline-none"
          >
            {appointmentExist ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="20"
                height="20"
                viewBox="0 0 55 55"
                fill="#365561"
              >
                <path d="M 27.5 5 C 24.08 5 21.269531 7.64 21.019531 11 L 24 11 C 26.76 11 29 13.24 29 16 L 29 17.820312 C 31.87 17.150312 34 14.57 34 11.5 C 34 7.91 31.09 5 27.5 5 z M 42.5 9 A 4.5 4.5 0 0 0 42.5 18 A 4.5 4.5 0 0 0 42.5 9 z M 6 13 C 4.346 13 3 14.346 3 16 L 3 34 C 3 35.654 4.346 37 6 37 L 24 37 C 25.654 37 27 35.654 27 34 L 27 16 C 27 14.346 25.654 13 24 13 L 6 13 z M 10 19 L 20 19 L 20 21 L 16 21 L 16 31 L 14 31 L 14 21 L 10 21 L 10 19 z M 29 21 L 29 34 C 29 36.76 26.76 39 24 39 L 18.199219 39 C 18.599219 40.96 19.569688 42.710313 20.929688 44.070312 C 22.739688 45.880312 25.24 47 28 47 C 33.52 47 38 42.52 38 37 L 38 21 L 29 21 z M 40 21 L 40 37 C 40 37.82 39.919531 38.620625 39.769531 39.390625 C 40.599531 39.780625 41.52 40 42.5 40 C 46.09 40 49 37.09 49 33.5 L 49 21 L 40 21 z"></path>
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="20"
                height="20"
                viewBox="0 0 55 55"
                fill="#365561"
              >
                <path d="M 27 4 C 23.145666 4 20 7.1456661 20 11 C 20 11.694215 20.109343 12.364062 20.298828 13 L 5 13 C 3.3550302 13 2 14.35503 2 16 L 2 34 C 2 35.64497 3.3550302 37 5 37 L 16.050781 37 C 16.558532 42.596375 21.274041 47 27 47 C 32.119276 47 36.240954 43.409081 37.460938 38.664062 C 38.643436 39.440841 39.984387 40 41.5 40 C 45.63039 40 49 36.63039 49 32.5 L 49 21 A 1.0001 1.0001 0 0 0 48 20 L 37 20 L 26 20 L 26 17.923828 C 26.327632 17.970927 26.660365 18 27 18 C 30.854334 18 34 14.854334 34 11 C 34 7.1456661 30.854334 4 27 4 z M 27 6 C 29.773666 6 32 8.2263339 32 11 C 32 13.773666 29.773666 16 27 16 C 26.651336 16 26.315457 15.955685 25.988281 15.888672 C 25.927569 14.29544 24.606899 13 23 13 L 22.421875 13 C 22.153458 12.388243 22 11.715897 22 11 C 22 8.2263339 24.226334 6 27 6 z M 42 8 C 40.416667 8 39.101892 8.6297556 38.251953 9.5859375 C 37.402014 10.542119 37 11.777778 37 13 C 37 14.222222 37.402014 15.457881 38.251953 16.414062 C 39.101892 17.370244 40.416667 18 42 18 C 43.583333 18 44.898108 17.370244 45.748047 16.414062 C 46.597986 15.457881 47 14.222222 47 13 C 47 11.777778 46.597986 10.542119 45.748047 9.5859375 C 44.898108 8.6297556 43.583333 8 42 8 z M 42 10 C 43.083333 10 43.768559 10.370244 44.251953 10.914062 C 44.735347 11.457882 45 12.222222 45 13 C 45 13.777778 44.735347 14.542119 44.251953 15.085938 C 43.768559 15.629755 43.083333 16 42 16 C 40.916667 16 40.231441 15.629756 39.748047 15.085938 C 39.264653 14.542118 39 13.777778 39 13 C 39 12.222222 39.264653 11.457881 39.748047 10.914062 C 40.231441 10.370245 40.916667 10 42 10 z M 5 15 L 21.757812 15 L 23 15 C 23.56503 15 24 15.43497 24 16 L 24 16.365234 A 1.0001 1.0001 0 0 0 24 16.919922 L 24 20.832031 A 1.0001 1.0001 0 0 0 24 21.158203 L 24 34 C 24 34.56503 23.56503 35 23 35 L 17.167969 35 A 1.0001 1.0001 0 0 0 16.841797 35 L 5 35 C 4.4349698 35 4 34.56503 4 34 L 4 16 C 4 15.43497 4.4349698 15 5 15 z M 9 19 L 9 21 L 13 21 L 13 31 L 15 31 L 15 21 L 19 21 L 19 19 L 9 19 z M 26 22 L 36 22 L 36 36 C 36 40.982593 31.982593 45 27 45 C 22.356014 45 18.554378 41.508579 18.058594 37 L 23 37 C 24.64497 37 26 35.64497 26 34 L 26 22 z M 38 22 L 47 22 L 47 32.5 C 47 35.54961 44.54961 38 41.5 38 C 40.097088 38 38.851397 37.45098 37.880859 36.591797 C 37.89251 36.384961 38 36.209688 38 36 L 38 22 z"></path>
              </svg>
            )}
          </button>
          <button
            onClick={handleProfileDelete}
            className="mt-[5px] focus:outline-none"
          >
            <i className="text-[#365561] cursor-pointer fa fa-trash hover:text-red-500 transition duration-100 ease-in-out" />
          </button>
        </div>
      </div>

      {showFeedback && (
        <ClientFeedbackModal
          data={data}
          onClose={() => setShowFeedback(false)}
        />
      )}

      {/* Popup Components */}
      {openCall && (
        <div className="fixed inset-0 z-50 flex items-end justify-center bg-black bg-opacity-30">
          {/* <AppointmentScheduler
            projectID={proj_id}
            expertID={data.expertID}
            setAppointmentExist={setAppointmentExist}
            openCall={openCall}
            setOpenCall={setOpenCall}
          /> */}
          <EphCalendar 
            projectID={proj_id}
            expertID={data.expertID}
            setOpenCall={setOpenCall}
            setAppointmentExist={setAppointmentExist}
          />
        </div>
      )}

      {isSlotSelected && (
        // <AppointmentScheduler
        //   projectID={proj_id}
        //   expertID={data.expertID}
        //   setAppointmentExist={setAppointmentExist}
        //   openCall={isSlotSelected}
        //   setOpenCall={setIsSlotSelected}
        //   selectedStartTime={meetingStart}
        //   selectedEndTime={meetingEnd}
        // />
        <div className="fixed inset-0 z-50 flex items-end justify-center bg-black bg-opacity-30">
          <EphCalendar 
            projectID={proj_id}
            expertID={data.expertID}
            setOpenCall={setIsSlotSelected}
            setAppointmentExist={setAppointmentExist}
          />
        </div>
      )}

      {isOpen && (
        <RequestCallModal
          data={data}
          clientEvents={sortedEvents}
          expertEvents={expertEvents}
          expertID={data.expertID}
          mediaLink={mediaLink}
          databaseLink={databaseLink}
          onClose={() => setIsOpen(false)}
          onOpenEmail={() => {
            setOpenEmail(true);
            setIsOpen(false);
          }}
          onSlotClick={handleCalendarOpen}
        />
      )}

      {openEmail && (
        <ComposeNewEmail
          onClose={() => setOpenEmail(false)}
          defaultTo={[expertEmail]}
          defaultTemplates={defaultTemp}
        />
      )}
    </>
  );
}

export default function ProjectSummary() {
  useEffect(() => {
    document.title = "Project Summary";
  }, []);
  const { API_URL } = useContext(UrlContext);
  const { userData } = useContext(UserContext);
  const proj_id = useParams().id;
  const [project, setProject] = useState({});
  const [allDigitalData, setAllDigitalData] = useState([]);
  const [backupData, setBackupData] = useState([]);
  const [profileFilter, setProfileFilter] = useState("all");
  const [loading, setLoading] = useState(true);
  const [dimension1, setDimension1] = useState("");
  const [dimension1returnSuccess, setDimension1returnSuccess] = useState(false);
  const [dimension1returnError, setDimension1returnError] = useState(false);
  const [dimension1loading, setDimension1loading] = useState(false);
  const [dimension2, setDimension2] = useState("");
  const [dimension2returnSuccess, setDimension2returnSuccess] = useState(false);
  const [dimension2returnError, setDimension2returnError] = useState(false);
  const [dimension2loading, setDimension2loading] = useState(false);
  const [dimension3, setDimension3] = useState("");
  const [dimension3returnSuccess, setDimension3returnSuccess] = useState(false);
  const [dimension3returnError, setDimension3returnError] = useState(false);
  const [dimension3loading, setDimension3loading] = useState(false);
  const [dimension4, setDimension4] = useState("");
  const [dimension4returnSuccess, setDimension4returnSuccess] = useState(false);
  const [dimension4returnError, setDimension4returnError] = useState(false);
  const [dimension4loading, setDimension4loading] = useState(false);
  const [dimension5, setDimension5] = useState("");
  const [dimension5returnSuccess, setDimension5returnSuccess] = useState(false);
  const [dimension5returnError, setDimension5returnError] = useState(false);
  const [dimension5loading, setDimension5loading] = useState(false);
  const [clientLogo, setClientLogo] = useState(false);
  const [addLogoPopUp, setAddLogoPopUp] = useState(false);
  const [continueWithoutLogo, setContinueWithoutLogo] = useState(false);
  const [clientid, setClientid] = useState(null);
  const [isLinkCreated, setIsLinkCreated] = useState(null);
  const [expertIds, setExpertIds] = useState([]);
  const [showButtons, setShowButtons] = useState(false);
  const [events, setEvents] = useState([]);
  const [clientLogs, setClientLogs] = useState([]);
  const [showLogs, setShowLogs] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [openEmailClient, setOpenEmailClient] = useState(false);
  const [projectSupporters, setProjectSupporters] = useState([]);

  const appendExpertId = (id) => {
    setExpertIds((prev) => {
      if (prev.some((expertId) => String(expertId) === String(id))) return prev;
      return [...prev, id];
    });
  };
  const removeExpertId = (id) => {
    setExpertIds((prev) => prev.filter((expertId) => String(expertId) !== String(id)));
  };

  useEffect(() => {
    const url = `${API_URL}project-title/` + proj_id;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setProject(data.project);
        setDimension1(data.project.dimension1);
        setDimension2(data.project.dimension2);
        setDimension3(data.project.dimension3);
        setDimension4(data.project.dimension4);
        setDimension5(data.project.dimension5);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    const url = `${API_URL}get-client-logs/` + proj_id;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == "success") {
          setClientLogs(data.response);
        } else {
          setClientLogs([]);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const getSummaryData = (proj_id) => {
    const url = `${API_URL}project-summary-info/` + proj_id;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setIsLinkCreated(data.linkCreated);
        setProjectSupporters(data.projectSupporters);
        let digitalDataWithNoID = [];
        let digitalData = [];
        for (let i = 0; i < data.allDigitalData.length; i++) {
          if (data.allDigitalData[i].expertDigitalID === "") {
            digitalDataWithNoID.push(data.allDigitalData[i]);
          } else {
            digitalData.push(data.allDigitalData[i]);
          }
        }
        digitalData = digitalData.concat(digitalDataWithNoID);
        setAllDigitalData(digitalData);
        setBackupData(digitalData);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getSummaryData(proj_id);
  }, []);

  const saveDimension1 = () => {
    setDimension1returnError(false);
    setDimension1loading(true);
    const url = `${API_URL}save-dimension1/` + proj_id;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ dimension1 }),
    })
      .then((res) => res.json())
      .then((data) => {
        setDimension1loading(false);
        if (data.status === "success") {
          setDimension1returnSuccess(true);
          setTimeout(() => {
            setDimension1returnSuccess(false);
          }, 1500);
        } else {
          setDimension1returnError(true);
        }
      })
      .catch(() => {
        setDimension1loading(false);
        setDimension1returnError(true);
      });
  };

  const saveDimension2 = () => {
    setDimension2returnError(false);
    setDimension2loading(true);
    const url = `${API_URL}save-dimension2/` + proj_id;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ dimension2 }),
    })
      .then((res) => res.json())
      .then((data) => {
        setDimension2loading(false);
        if (data.status === "success") {
          setDimension2returnSuccess(true);
          setTimeout(() => {
            setDimension2returnSuccess(false);
          }, 1500);
        } else {
          setDimension2returnError(true);
        }
      })
      .catch(() => {
        setDimension2loading(false);
        setDimension2returnError(true);
      });
  };

  const saveDimension3 = () => {
    setDimension3returnError(false);
    setDimension3loading(true);
    const url = `${API_URL}save-dimension3/` + proj_id;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ dimension3 }),
    })
      .then((res) => res.json())
      .then((data) => {
        setDimension3loading(false);
        if (data.status === "success") {
          setDimension3returnSuccess(true);
          setTimeout(() => {
            setDimension3returnSuccess(false);
          }, 1500);
        } else {
          setDimension3returnError(true);
        }
      })
      .catch(() => {
        setDimension3loading(false);
        setDimension3returnError(true);
      });
  };

  const saveDimension4 = () => {
    setDimension4returnError(false);
    setDimension4loading(true);
    const url = `${API_URL}save-dimension4/` + proj_id;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ dimension4 }),
    })
      .then((res) => res.json())
      .then((data) => {
        setDimension4loading(false);
        if (data.status === "success") {
          setDimension4returnSuccess(true);
          setTimeout(() => {
            setDimension4returnSuccess(false);
          }, 1500);
        } else {
          setDimension4returnError(true);
        }
      })
      .catch(() => {
        setDimension4loading(false);
        setDimension4returnError(true);
      });
  };

  const saveDimension5 = () => {
    setDimension5returnError(false);
    setDimension5loading(true);
    const url = `${API_URL}save-dimension5/` + proj_id;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ dimension5 }),
    })
      .then((res) => res.json())
      .then((data) => {
        setDimension5loading(false);
        if (data.status === "success") {
          setDimension5returnSuccess(true);
          setTimeout(() => {
            setDimension5returnSuccess(false);
          }, 1500);
        } else {
          setDimension5returnError(true);
        }
      })
      .catch(() => {
        setDimension5loading(false);
        setDimension5returnError(true);
      });
  };

  useEffect(() => {
    if (expertIds.length > 0) {
      setShowButtons(true);
    } else {
      setShowButtons(false);
    }
  }, [expertIds]);

  useEffect(() => {
    if (profileFilter === "ppt") {
      const filteredData = backupData.filter((item) => {
        return item?.sharedWithClient === "yes";
      });
      setAllDigitalData(filteredData);
      return;
    }

    if (profileFilter === "sharedViaLink") {
      const filteredData = backupData.filter((item) => {
        return item?.sharedViaLink === true || item?.sharedViaLink === "true" || item?.sharedViaLink === "yes";
      });
      setAllDigitalData(filteredData);
      return;
    }

    setAllDigitalData(backupData);
  }, [profileFilter, backupData]);

  const profileTypeCounts = {
    all: backupData.length,
    ppt: backupData.filter((item) => item?.sharedWithClient === "yes").length,
    sharedViaLink: backupData.filter((item) => item?.sharedViaLink === true || item?.sharedViaLink === "true" || item?.sharedViaLink === "yes").length,
  };

  useEffect(() => {
    const url = `${API_URL}account-details/` + proj_id;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setClientid(data.account.id);
        if (data.account.clientLogo) {
          setClientLogo(true);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  // API for fetching meeting timeslots
  const getClientAvailabilitySlot = async () => {
    const requestBody = {
      projectID: proj_id,
    };
    try {
      let modifiedUrl = "get-client-availability-slots";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setEvents(responseData.eventData);
      } else {
        console.error("Failed to add selected slot");
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
    }
  };

  useEffect(() => {
    if (allDigitalData.length > 0) {
      getClientAvailabilitySlot();
    }
  }, [allDigitalData]);

  const dimensionValues = [dimension1, dimension2, dimension3, dimension4, dimension5];
  const dimensionSetters = [setDimension1, setDimension2, setDimension3, setDimension4, setDimension5];
  const dimensionSavers = [saveDimension1, saveDimension2, saveDimension3, saveDimension4, saveDimension5];
  const dimensionSaveStates = [
    { loading: dimension1loading, success: dimension1returnSuccess, error: dimension1returnError },
    { loading: dimension2loading, success: dimension2returnSuccess, error: dimension2returnError },
    { loading: dimension3loading, success: dimension3returnSuccess, error: dimension3returnError },
    { loading: dimension4loading, success: dimension4returnSuccess, error: dimension4returnError },
    { loading: dimension5loading, success: dimension5returnSuccess, error: dimension5returnError },
  ];

  const isAdmin = userData?.roles?.includes("Admin");
  const isProjectSupporter = projectSupporters?.some(
    (supporter) =>
      String(supporter || "").trim().toLowerCase() ===
      String(userData?.username || "").trim().toLowerCase()
  );

  const canOpenClientEmails = isAdmin || isProjectSupporter;

  const projectClientName =
    typeof project?.clientName === "string"
      ? project.clientName
      : typeof project?.client_name === "string"
        ? project.client_name
        : typeof project?.client === "string"
          ? project.client
          : typeof project?.client?.name === "string"
            ? project.client.name
            : typeof project?.accountName === "string"
              ? project.accountName
              : "";

  return (
    <>
      {addLogoPopUp && !continueWithoutLogo ? (
        <AddLogo
          project_id={proj_id}
          setContinueWithoutLogo={setContinueWithoutLogo}
          clientId={clientid}
        />
      ) : null}

      <ProjectTitle project={project} />

      {!loading ? (
        <div className="p-4">
          <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex flex-wrap items-center gap-2">
              <MSbuttonsSummery
                clientLogo={clientLogo}
                project_id={proj_id}
                expertIds={expertIds}
                continueWithoutLogo={continueWithoutLogo}
                setContinueWithoutLogo={setContinueWithoutLogo}
                setAddLogoPopUp={setAddLogoPopUp}
                isLinkCreated={isLinkCreated}
                setIsLinkCreated={setIsLinkCreated}
                getSummaryData={getSummaryData}
                showButtons={showButtons}
                project_name={project?.name || ""}
                client_name={projectClientName}
                project_type={project?.projectType || ""}
              />
              {clientLogs.length ? (
                <MSActionButton
                  icon="fa-regular fa-file"
                  shortLabel="Logs"
                  isLeftEdge={!isLinkCreated && !showButtons}
                  label="Open client activity logs"
                  onClick={() => setShowLogs(true)}
                />
              ) : null}
            </div>
            
            <div className="flex flex-row items-center justify-center gap-2">
              <ProfileTypeToggle
                value={profileFilter}
                onChange={setProfileFilter}
                counts={profileTypeCounts}
              />

              {/* <button
                type="button"
                onClick={() => setOpenEmailClient(true)}
                className={[
                  "group relative inline-flex h-10 items-center gap-1.5 overflow-visible rounded-xl px-2.5 text-[11px] font-semibold transition focus:outline-none",
                  "border border-slate-200 bg-white text-slate-600 shadow-sm",
                  "hover:border-[#365561]/25 hover:bg-[#365561]/10 hover:text-[#365561]",
                  "disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-slate-200 disabled:hover:bg-white disabled:hover:text-slate-600",
                ].join(" ")}
                aria-label="Client emails"
                disabled={!canOpenClientEmails}
              >
                <i class="fa-solid fa-envelopes-bulk text-[14px]"></i>
                <span>{'Client emails'}</span>
                <ToggleTooltip label={'Client emails log for this project'} isLeftEdge={false} isRightEdge={true} />
              </button> */}
            </div>
          </div>
        
          <div className="w-full space-y-2 overflow-x-auto overflow-y-visible pb-2">
            {/* Header */}
            <div
              className="grid min-w-[1340px] items-center gap-2 rounded-2xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm font-semibold text-slate-600 shadow-sm"
              style={{ gridTemplateColumns: rowGridTemplateColumns }}
            >
              <div>Name</div>
              <div className="text-center">ID#</div>

              <div className="relative col-span-5 min-w-0">
                {editingIndex === null ? (
                  <div className="grid grid-cols-5 gap-2">
                    {dimensionValues.map((value, i) => (
                      <div key={i} className="relative min-w-0 text-left text-sm">
                        <button
                          type="button"
                          className="group w-full truncate rounded-lg px-1 py-0.5 text-left hover:bg-white focus:outline-none"
                          onClick={() => setEditingIndex(i)}
                        >
                          {value || <span className="text-gray-400">{`Dimension${i + 1}`}</span>}
                          <span className="pointer-events-none absolute left-0 top-full z-[70] mt-2 hidden whitespace-nowrap rounded-xl bg-slate-900 px-2 py-1 text-xs text-white shadow-lg group-hover:block">
                            {value || "Click to edit"}
                            <span className="absolute bottom-full left-4 h-2 w-2 translate-y-1 rotate-45 bg-slate-900" />
                          </span>
                        </button>

                        {dimensionSaveStates[i].loading && (
                          <img className="absolute right-1 top-1 w-4 h-4" src={LoadingIcon} alt="loading" title="Loading..." />
                        )}
                        {dimensionSaveStates[i].success && (
                          <img className="absolute right-1 top-1 w-4 h-4" src={successIcon} alt="success" title="Success" />
                        )}
                        {dimensionSaveStates[i].error && (
                          <img className="absolute right-1 top-1 w-4 h-4" src={errorIcon} alt="error" title="Error! Please reload" />
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="relative w-full">
                    <input
                      type="text"
                      autoFocus
                      placeholder={`Dimension ${editingIndex + 1}`}
                      value={dimensionValues[editingIndex] || ""}
                      onChange={(e) => {
                        dimensionSetters[editingIndex](e.target.value);
                      }}
                      onBlur={() => {
                        dimensionSavers[editingIndex]();
                        setEditingIndex(null);
                      }}
                      className="w-full rounded-lg border border-slate-200 bg-white px-2 py-1 text-sm focus:border-[#365561]/40 focus:outline-none"
                    />
                  </div>
                )}
              </div>

              <div className="text-center">In %</div>
              <div className="text-center">Consultant rate</div>
              <div className="text-center">Client rate</div>
              <div className="text-center">Availability</div>
              <div className="text-center">Call</div>
            </div>

            {/* Rows */}
            {allDigitalData.map((data, index) => (
              <ExpertRow
                key={data?.expertID || index}
                data={data}
                index={index}
                proj_id={proj_id}
                project={project}
                expert_id={data?.expertID}
                appendExpertId={appendExpertId}
                removeExpertId={removeExpertId}
                backupData={backupData}
                setBackupData={setBackupData}
                events={events}
                logData={clientLogs}
                selectedExpertIds={expertIds}
              />
            ))}
          </div>
        </div>
      ) : (
        <div className="text-center mt-6">
          <img src={LoadingIcon} alt="Loading..." className="h-[50px] inline-block" />
        </div>
      )}

      {showLogs && (
        <ClientLog
          showLogs={setShowLogs}
          logs={clientLogs}
          data={allDigitalData}
        />
      )}

      {openEmailClient && (
        <ProjectClientEmail
          projectID={proj_id}
          projectName={`${project?.name}`}
          isLinkCreated={isLinkCreated}
          onClose={() => setOpenEmailClient(false)}
        />
      )}
    </>
  );
}
